'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded$6M = ["color", "size"];
var ArrowLeft = function ArrowLeft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6M);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 5l-7 7 7 7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 12h16"
  }));
};
ArrowLeft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6L = ["color", "size"];
var ArrowRight = function ArrowRight(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6L);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 12h16"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13 5l7 7-7 7"
  }));
};
ArrowRight.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6K = ["color", "size"];
var ArrowUp = function ArrowUp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6K);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 20V4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 11l7-7 7 7"
  }));
};
ArrowUp.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6J = ["color", "size"];
var ArrowDown = function ArrowDown(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6J);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 20V4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 13l7 7 7-7"
  }));
};
ArrowDown.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6I = ["color", "size"];
var ArrowDownLeft = function ArrowDownLeft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6I);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 18L18 6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 8v10h10"
  }));
};
ArrowDownLeft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6H = ["color", "size"];
var ArrowUpLeft = function ArrowUpLeft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6H);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 6l12 12"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 6H6v10"
  }));
};
ArrowUpLeft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6G = ["color", "size"];
var ArrowUpRight = function ArrowUpRight(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6G);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 6L6 18"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 6h10v10"
  }));
};
ArrowUpRight.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6F = ["color", "size"];
var ArrowDownRight = function ArrowDownRight(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6F);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 18L6 6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 18h10V8"
  }));
};
ArrowDownRight.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6E = ["color", "size"];
var ChevronLeft = function ChevronLeft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6E);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 4l-8 8 8 8"
  }));
};
ChevronLeft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6D = ["color", "size"];
var ChevronRight = function ChevronRight(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6D);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 4l8 8-8 8"
  }));
};
ChevronRight.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6C = ["color", "size"];
var ChevronUp = function ChevronUp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6C);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 15l8-8 8 8"
  }));
};
ChevronUp.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6B = ["color", "size"];
var ChevronDown = function ChevronDown(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6B);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 9l8 8 8-8"
  }));
};
ChevronDown.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6A = ["color", "size"];
var ArrowCycle = function ArrowCycle(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6A);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 12c0 6-4.39 10-9.806 10C7.792 22 4.24 19.665 3 16"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 12C2 6 6.39 2 11.806 2 16.209 2 19.76 4.335 21 8"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 17l-4-1-1 4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 7l4 1 1-4"
  }));
};
ArrowCycle.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6z = ["color", "size"];
var ArrowClockwise = function ArrowClockwise(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.734 16.06a8.923 8.923 0 0 1-3.915 3.978 8.706 8.706 0 0 1-5.471.832 8.795 8.795 0 0 1-4.887-2.64 9.067 9.067 0 0 1-2.388-5.079 9.136 9.136 0 0 1 1.044-5.53 8.904 8.904 0 0 1 4.069-3.815 8.7 8.7 0 0 1 5.5-.608c1.85.401 3.366 1.313 4.62 2.755.151.16.735.806 1.22 1.781"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.069 7.813l5.04.907L21 3.59"
  }));
};
ArrowClockwise.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6y = ["color", "size"];
var ArrowCounterClockwise = function ArrowCounterClockwise(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.266 16.06a8.923 8.923 0 0 0 3.915 3.978 8.706 8.706 0 0 0 5.471.832 8.796 8.796 0 0 0 4.887-2.64 9.067 9.067 0 0 0 2.388-5.079 9.137 9.137 0 0 0-1.044-5.53 8.904 8.904 0 0 0-4.068-3.815 8.7 8.7 0 0 0-5.5-.608c-1.85.401-3.367 1.313-4.62 2.755-.152.16-.736.806-1.22 1.781"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.931 7.813l-5.04.907L3 3.59"
  }));
};
ArrowCounterClockwise.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6x = ["color", "size"];
var ArrowBackThick = function ArrowBackThick(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6x);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 11l7-9v5c11.953 0 13.332 9.678 13 15-.502-2.685-.735-7-13-7v5l-7-9z"
  }));
};
ArrowBackThick.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6w = ["color", "size"];
var ArrowBackThickFill = function ArrowBackThickFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6w);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2a1 1 0 0 0-1.79-.614l-7 9a1 1 0 0 0 0 1.228l7 9A1 1 0 0 0 10 20v-3.99c5.379.112 7.963 1.133 9.261 2.243 1.234 1.055 1.46 2.296 1.695 3.596l.061.335a1 1 0 0 0 1.981-.122c.171-2.748-.086-6.73-2.027-10.061C19.087 8.768 15.694 6.282 10 6.022V2z"
  }));
};
ArrowBackThickFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6v = ["color", "size"];
var ArrowForwardThick = function ArrowForwardThick(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6v);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 11l-7-9v5C3.047 7 1.668 16.678 2 22c.502-2.685.735-7 13-7v5l7-9z"
  }));
};
ArrowForwardThick.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6u = ["color", "size"];
var ArrowForwardThickFill = function ArrowForwardThickFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6u);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.675 1.054a1 1 0 0 1 1.114.332l7 9a1 1 0 0 1 0 1.228l-7 9A1 1 0 0 1 14 20v-3.99c-5.379.112-7.963 1.133-9.261 2.243-1.234 1.055-1.46 2.296-1.695 3.596l-.061.335a1 1 0 0 1-1.981-.122c-.172-2.748.086-6.73 2.027-10.061C4.913 8.768 8.305 6.282 14 6.022V2a1 1 0 0 1 .675-.946z"
  }));
};
ArrowForwardThickFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6t = ["color", "size"];
var Width = function Width(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6t);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 12H2m20 0l-4 4m4-4l-4-4M2 12l4 4m-4-4l4-4"
  }));
};
Width.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6s = ["color", "size"];
var Height = function Height(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6s);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 22V2m0 20l-4-4m4 4l4-4M12 2L8 6m4-4l4 4"
  }));
};
Height.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6r = ["color", "size"];
var Enlarge = function Enlarge(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6r);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14.5 9.5L21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"
  }));
};
Enlarge.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6q = ["color", "size"];
var Reduce = function Reduce(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 10l7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"
  }));
};
Reduce.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6p = ["color", "size"];
var ArrowLeftThick = function ArrowLeftThick(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6p);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 12l7-9v4.99L21 8v8H10v5l-7-9z"
  }));
};
ArrowLeftThick.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6o = ["color", "size"];
var ArrowDownThick = function ArrowDownThick(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6o);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 21l9-7h-4.99L16 3H8v11H3l9 7z"
  }));
};
ArrowDownThick.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6n = ["color", "size"];
var ArrowRightThick = function ArrowRightThick(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6n);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 12l-7-9v4.99L3 8v8h11v5l7-9z"
  }));
};
ArrowRightThick.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6m = ["color", "size"];
var ArrowUpThick = function ArrowUpThick(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6m);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 3l9 7h-4.99L16 21H8V10H3l9-7z"
  }));
};
ArrowUpThick.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6l = ["color", "size"];
var ArrowBack = function ArrowBack(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6l);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 5l-5 5 5 5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 10h8c5.523 0 10 4.477 10 10v1"
  }));
};
ArrowBack.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6k = ["color", "size"];
var ArrowForward = function ArrowForward(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6k);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 5l5 5-5 5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 10h-8C7.477 10 3 14.477 3 20v1"
  }));
};
ArrowForward.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6j = ["color", "size"];
var TriangleLeft = function TriangleLeft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6j);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 12l8-6v12l-8-6z"
  }));
};
TriangleLeft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6i = ["color", "size"];
var TriangleRight = function TriangleRight(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6i);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 12L9 6v12l8-6z"
  }));
};
TriangleRight.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6h = ["color", "size"];
var TriangleUp = function TriangleUp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6h);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 7l-6 8h12l-6-8z"
  }));
};
TriangleUp.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6g = ["color", "size"];
var TriangleDown = function TriangleDown(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6g);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 17L6 9h12l-6 8z"
  }));
};
TriangleDown.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6f = ["color", "size"];
var CircleTriangleRight = function CircleTriangleRight(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6f);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 12l-6-4v8l6-4z"
  }));
};
CircleTriangleRight.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6e = ["color", "size"];
var CircleTriangleLeft = function CircleTriangleLeft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6e);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 12l6-4v8l-6-4z"
  }));
};
CircleTriangleLeft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6d = ["color", "size"];
var CircleTriangleUp = function CircleTriangleUp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6d);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 8l-4 6h8l-4-6z"
  }));
};
CircleTriangleUp.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6c = ["color", "size"];
var CircleTriangleDown = function CircleTriangleDown(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6c);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 16l-4-6h8l-4 6z"
  }));
};
CircleTriangleDown.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6b = ["color", "size"];
var CircleChevronLeft = function CircleChevronLeft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6b);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.5 8l-4 4 4 4"
  }));
};
CircleChevronLeft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6a = ["color", "size"];
var CircleChevronRight = function CircleChevronRight(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6a);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.5 8l4 4-4 4"
  }));
};
CircleChevronRight.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$69 = ["color", "size"];
var CircleChevronUp = function CircleChevronUp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$69);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 13.5l4-4 4 4"
  }));
};
CircleChevronUp.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$68 = ["color", "size"];
var CircleChevronDown = function CircleChevronDown(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$68);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 10.5l4 4 4-4"
  }));
};
CircleChevronDown.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$67 = ["color", "size"];
var CircleTriangleRightFill = function CircleTriangleRightFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$67);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm-2 7.8c0-.295.152-.566.396-.705a.71.71 0 0 1 .77.04l4.5 3.2A.815.815 0 0 1 16 12a.815.815 0 0 1-.334.666l-4.5 3.2a.71.71 0 0 1-.77.04A.809.809 0 0 1 10 15.2V8.8z"
  }));
};
CircleTriangleRightFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$66 = ["color", "size"];
var CircleTriangleLeftFill = function CircleTriangleLeftFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$66);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm2 7.8a.809.809 0 0 0-.396-.705.71.71 0 0 0-.77.04l-4.5 3.2A.815.815 0 0 0 8 12c0 .268.125.517.334.666l4.5 3.2a.71.71 0 0 0 .77.04A.809.809 0 0 0 14 15.2V8.8z"
  }));
};
CircleTriangleLeftFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$65 = ["color", "size"];
var CircleTriangleUpFill = function CircleTriangleUpFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$65);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM8.8 14a.809.809 0 0 1-.705-.396.71.71 0 0 1 .04-.77l3.2-4.5A.815.815 0 0 1 12 8c.268 0 .517.125.666.334l3.2 4.5a.71.71 0 0 1 .04.77.809.809 0 0 1-.706.396H8.8z"
  }));
};
CircleTriangleUpFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$64 = ["color", "size"];
var CircleTriangleDownFill = function CircleTriangleDownFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$64);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm-3.2 9a.809.809 0 0 0-.705.396.71.71 0 0 0 .04.77l3.2 4.5A.815.815 0 0 0 12 16a.815.815 0 0 0 .666-.334l3.2-4.5a.71.71 0 0 0 .04-.77A.809.809 0 0 0 15.2 10H8.8z"
  }));
};
CircleTriangleDownFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$63 = ["color", "size"];
var CircleChevronLeftFill = function CircleChevronLeftFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$63);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm2.207 7.707a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L10.914 12l3.293-3.293z"
  }));
};
CircleChevronLeftFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$62 = ["color", "size"];
var CircleChevronRightFill = function CircleChevronRightFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$62);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM9.793 8.707a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L13.086 12 9.793 8.707z"
  }));
};
CircleChevronRightFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$61 = ["color", "size"];
var CircleChevronUpFill = function CircleChevronUpFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$61);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM8.707 14.207a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L12 10.914l-3.293 3.293z"
  }));
};
CircleChevronUpFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$60 = ["color", "size"];
var CircleChevronDownFill = function CircleChevronDownFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$60);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM8.707 9.793a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L12 13.086 8.707 9.793z"
  }));
};
CircleChevronDownFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5$ = ["color", "size"];
var ChevronHorizontal = function ChevronHorizontal(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5$);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 8l4 4-4 4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 8l-4 4 4 4"
  }));
};
ChevronHorizontal.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5_ = ["color", "size"];
var ChevronVertical = function ChevronVertical(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5_);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 17l4 4 4-4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 7l4-4 4 4"
  }));
};
ChevronVertical.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5Z = ["color", "size"];
var ArrowUpDown = function ArrowUpDown(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5Z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 3v18M6 3l4 4M6 3L2 7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 21V3m0 18l4-4m-4 4l-4-4"
  }));
};
ArrowUpDown.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5Y = ["color", "size"];
var ArrowRightLeft = function ArrowRightLeft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5Y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 6H3m18 0l-4 4m4-4l-4-4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 18h18M3 18l4 4m-4-4l4-4"
  }));
};
ArrowRightLeft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5X = ["color", "size"];
var ArrowShuffle = function ArrowShuffle(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5X);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 19h3.908a2 2 0 0 0 1.682-.919L11.5 12l3.91-6.082A2 2 0 0 1 17.091 5H22m0 14h-4.908a2 2 0 0 1-1.682-.919L13.428 15M2 5h3.908a2 2 0 0 1 1.682.918L9.571 9"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 2l3 3-3 3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 16l3 3-3 3"
  }));
};
ArrowShuffle.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5W = ["color", "size"];
var ArrowRepeat = function ArrowRepeat(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5W);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 2l3 3-3 3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 22l-3-3 3-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 5H10a7 7 0 0 0-7 7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 19h11a7 7 0 0 0 7-7"
  }));
};
ArrowRepeat.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5V = ["color", "size"];
var ForkRight = function ForkRight(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5V);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 3v18M9 3l4 4M9 3L5 7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 10l4 4-4 4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 21v0a7 7 0 0 1 7-7h4"
  }));
};
ForkRight.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5U = ["color", "size"];
var ForkLeft = function ForkLeft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5U);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 3v18m0-18l-4 4m4-4l4 4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 10l-4 4 4 4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 21v0a7 7 0 0 0-7-7H4"
  }));
};
ForkLeft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5T = ["color", "size"];
var TriangleLeftFill = function TriangleLeftFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5T);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 6a1 1 0 0 0-1.6-.8l-8 6a1 1 0 0 0 0 1.6l8 6A1 1 0 0 0 16 18V6z"
  }));
};
TriangleLeftFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5S = ["color", "size"];
var TriangleRightFill = function TriangleRightFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5S);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 6a1 1 0 0 1 1.6-.8l8 6a1 1 0 0 1 0 1.6l-8 6A1 1 0 0 1 8 18V6z"
  }));
};
TriangleRightFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5R = ["color", "size"];
var TriangleUpFill = function TriangleUpFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5R);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 16a1 1 0 0 1-.8-1.6l6-8a1 1 0 0 1 1.6 0l6 8A1 1 0 0 1 18 16H6z"
  }));
};
TriangleUpFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5Q = ["color", "size"];
var TriangleDownFill = function TriangleDownFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5Q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 8a1 1 0 0 0-.8 1.6l6 8a1 1 0 0 0 1.6 0l6-8A1 1 0 0 0 18 8H6z"
  }));
};
TriangleDownFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5P = ["color", "size"];
var ChevronDownSmall = function ChevronDownSmall(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5P);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 10l6 6 6-6"
  }));
};
ChevronDownSmall.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5O = ["color", "size"];
var ChevronUpSmall = function ChevronUpSmall(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5O);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 14l6-6 6 6"
  }));
};
ChevronUpSmall.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5N = ["color", "size"];
var ChevronRightSmall = function ChevronRightSmall(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5N);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 6l6 6-6 6"
  }));
};
ChevronRightSmall.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5M = ["color", "size"];
var ChevronLeftSmall = function ChevronLeftSmall(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5M);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 6l-6 6 6 6"
  }));
};
ChevronLeftSmall.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5L = ["color", "size"];
var Plus = function Plus(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5L);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 20v-8m0 0V4m0 8h8m-8 0H4"
  }));
};
Plus.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5K = ["color", "size"];
var Minus = function Minus(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5K);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 12H4"
  }));
};
Minus.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5J = ["color", "size"];
var Cross = function Cross(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5J);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 20L4 4m16 0L4 20"
  }));
};
Cross.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5I = ["color", "size"];
var Check = function Check(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5I);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 12l6 6L20 6"
  }));
};
Check.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5H = ["color", "size"];
var Question = function Question(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5H);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 8.484C10.5 7.494 11 7 12 7c1.246 0 2 .989 2 1.978s-.5 1.483-2 2.473V13m0 3.5v.5"
  }));
};
Question.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5G = ["color", "size"];
var CircleAlert = function CircleAlert(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5G);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 7v6m0 3.5v.5"
  }));
};
CircleAlert.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5F = ["color", "size"];
var CircleX = function CircleX(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5F);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 15L9 9m6 0l-6 6"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }));
};
CircleX.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5E = ["color", "size"];
var CircleCheck = function CircleCheck(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5E);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 12.5l3 3 5-6"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }));
};
CircleCheck.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5D = ["color", "size"];
var CirclePlus = function CirclePlus(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5D);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 8v4m0 0v4m0-4h4m-4 0H8"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }));
};
CirclePlus.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5C = ["color", "size"];
var CircleMinus = function CircleMinus(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5C);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 12H8"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }));
};
CircleMinus.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5B = ["color", "size"];
var TriangleAlert = function TriangleAlert(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5B);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 9v5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 17.5v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2.232 19.016L10.35 3.052c.713-1.403 2.59-1.403 3.302 0l8.117 15.964C22.45 20.36 21.544 22 20.116 22H3.883c-1.427 0-2.334-1.64-1.65-2.984z"
  }));
};
TriangleAlert.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5A = ["color", "size"];
var Stop = function Stop(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5A);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 2L2 8.156V16l6 6h8l6-6V8.156L16 2H8z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 12H8"
  }));
};
Stop.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5z = ["color", "size"];
var Info = function Info(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 7h.01"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 11h2v5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 16h4"
  }));
};
Info.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5y = ["color", "size"];
var Play = function Play(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 4v16"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 12L6 20"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 12L6 4"
  }));
};
Play.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5x = ["color", "size"];
var Pause = function Pause(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5x);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 5v14M17 5v14"
  }));
};
Pause.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5w = ["color", "size"];
var Command = function Command(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5w);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.3 17.85a3.15 3.15 0 1 1-3.15-3.15h11.7a3.15 3.15 0 1 1-3.15 3.15V6.15a3.15 3.15 0 1 1 3.15 3.15H6.15A3.15 3.15 0 1 1 9.3 6.15v11.7z"
  }));
};
Command.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5v = ["color", "size"];
var SoundDown = function SoundDown(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5v);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 12h-6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 14.959V9.04C2 8.466 2.448 8 3 8h3.586a.98.98 0 0 0 .707-.305l3-3.388c.63-.656 1.707-.191 1.707.736v13.914c0 .934-1.09 1.395-1.716.726l-2.99-3.369A.98.98 0 0 0 6.578 16H3c-.552 0-1-.466-1-1.041z"
  }));
};
SoundDown.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5u = ["color", "size"];
var SoundOn = function SoundOn(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5u);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 14.959V9.04C2 8.466 2.448 8 3 8h3.586a.98.98 0 0 0 .707-.305l3-3.388c.63-.656 1.707-.191 1.707.736v13.914c0 .934-1.09 1.395-1.716.726l-2.99-3.369A.98.98 0 0 0 6.578 16H3c-.552 0-1-.466-1-1.041z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 8.5c1.333 1.778 1.333 5.222 0 7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 5c3.988 3.808 4.012 10.217 0 14"
  }));
};
SoundOn.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5t = ["color", "size"];
var SoundOff = function SoundOff(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5t);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 15l-6-6m6 0l-6 6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 14.959V9.04C2 8.466 2.448 8 3 8h3.586a.98.98 0 0 0 .707-.305l3-3.388c.63-.656 1.707-.191 1.707.736v13.914c0 .934-1.09 1.395-1.716.726l-2.99-3.369A.98.98 0 0 0 6.578 16H3c-.552 0-1-.466-1-1.041z"
  }));
};
SoundOff.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5s = ["color", "size"];
var SoundUp = function SoundUp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5s);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 9v3m0 0v3m0-3h3m-3 0h-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 14.959V9.04C2 8.466 2.448 8 3 8h3.586a.98.98 0 0 0 .707-.305l3-3.388c.63-.656 1.707-.191 1.707.736v13.914c0 .934-1.09 1.395-1.716.726l-2.99-3.369A.98.98 0 0 0 6.578 16H3c-.552 0-1-.466-1-1.041z"
  }));
};
SoundUp.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5r = ["color", "size"];
var Infinite = function Infinite(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5r);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.636 16C2.91 16 2 14 2 12s.91-4 3.636-4c3.637 0 9.091 8 12.728 8C21.09 16 22 14 22 12s-.91-4-3.636-4c-3.637 0-9.091 8-12.728 8z"
  }));
};
Infinite.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5q = ["color", "size"];
var AirplayAudio = function AirplayAudio(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 16l6 5H6l6-5z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 18a9.956 9.956 0 0 1-2-6C2 6.477 6.477 2 12 2s10 4.477 10 10a9.956 9.956 0 0 1-2 6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17.123 15.125a6 6 0 1 0-10.247-.002"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 12a2 2 0 1 0-4 0"
  }));
};
AirplayAudio.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5p = ["color", "size"];
var AirplayVideo = function AirplayVideo(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5p);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 16l6 5H6l6-5z"
  }));
};
AirplayVideo.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5o = ["color", "size"];
var Miniplayer = function Miniplayer(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5o);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "4",
    width: "20",
    height: "16",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "13",
    y: "13",
    width: "9",
    height: "7",
    rx: "2"
  }));
};
Miniplayer.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5n = ["color", "size"];
var TextAlignLeft = function TextAlignLeft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5n);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 6h18M3 12h10M3 18h15"
  }));
};
TextAlignLeft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5m = ["color", "size"];
var TextAlignCenter = function TextAlignCenter(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5m);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 6h18M7 12h10M5 18h14"
  }));
};
TextAlignCenter.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5l = ["color", "size"];
var TextAlignRight = function TextAlignRight(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5l);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 6h18m-10 6h10M6 18h15"
  }));
};
TextAlignRight.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5k = ["color", "size"];
var TextAlignJustified = function TextAlignJustified(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5k);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 6h18M3 12h18M3 18h18"
  }));
};
TextAlignJustified.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5j = ["color", "size"];
var Mention = function Mention(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5j);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10c2.252 0 4.33-.744 6.001-2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 8v4c0 1 .6 3 3 3s3-2 3-3"
  }));
};
Mention.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5i = ["color", "size"];
var Heart = function Heart(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5i);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 3C4.239 3 2 5.216 2 7.95c0 2.207.875 7.445 9.488 12.74a.985.985 0 0 0 1.024 0C21.125 15.395 22 10.157 22 7.95 22 5.216 19.761 3 17 3s-5 3-5 3-2.239-3-5-3z"
  }));
};
Heart.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5h = ["color", "size"];
var FullScreen = function FullScreen(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5h);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 7V2h5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 7V2h-5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 22H2v-5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 22h5v-5"
  }));
};
FullScreen.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5g = ["color", "size"];
var NormalScreen = function NormalScreen(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5g);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 2v5H2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 2v5h5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 17h5v5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 17h-5v5"
  }));
};
NormalScreen.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5f = ["color", "size"];
var AlignLeft = function AlignLeft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5f);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 3v18"
  }), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "6",
    y: "6",
    width: "16",
    height: "4"
  }), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "6",
    y: "14",
    width: "10",
    height: "4"
  }));
};
AlignLeft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5e = ["color", "size"];
var AlignHorizontalCenter = function AlignHorizontalCenter(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5e);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 3v18"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 6h4v4h-4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 10H4V6h4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 14h2v4h-2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 14H6v4h2"
  }));
};
AlignHorizontalCenter.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5d = ["color", "size"];
var AlignRight = function AlignRight(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5d);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 3v18"
  }), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "6",
    width: "16",
    height: "4"
  }), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "8",
    y: "14",
    width: "10",
    height: "4"
  }));
};
AlignRight.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5c = ["color", "size"];
var AlignTop = function AlignTop(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5c);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 2H3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 22V6h4v16H6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 16V6h4v10h-4z"
  }));
};
AlignTop.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5b = ["color", "size"];
var AlignVerticalCenter = function AlignVerticalCenter(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5b);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 12H3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 16v4h4v-4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 16v2h4v-2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 8V6h4v2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 8V4H6v4"
  }));
};
AlignVerticalCenter.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5a = ["color", "size"];
var AlignBottom = function AlignBottom(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5a);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 22H3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 18V2h4v16H6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 18V8h4v10h-4z"
  }));
};
AlignBottom.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$59 = ["color", "size"];
var ShareBox = function ShareBox(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$59);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 3v12m0-12L8 7m4-4l4 4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 17l.621 2.485A2 2 0 0 0 4.561 21H19.439a2 2 0 0 0 1.94-1.515L22 17"
  }));
};
ShareBox.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$58 = ["color", "size"];
var Download = function Download(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$58);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 15V3m0 12l-4-4m4 4l4-4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 17l.621 2.485A2 2 0 0 0 4.561 21H19.439a2 2 0 0 0 1.94-1.515L22 17"
  }));
};
Download.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$57 = ["color", "size"];
var AlignToTop = function AlignToTop(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$57);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 22V7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 14l7-7 7 7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 2h18"
  }));
};
AlignToTop.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$56 = ["color", "size"];
var AlignToMiddle = function AlignToMiddle(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$56);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 12H3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2v6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 22v-6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 5l3 3 3-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 19l3-3 3 3"
  }));
};
AlignToMiddle.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$55 = ["color", "size"];
var AlignToBottom = function AlignToBottom(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$55);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 22h18"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2v15"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 10l7 7 7-7"
  }));
};
AlignToBottom.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$54 = ["color", "size"];
var Block = function Block(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$54);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 19L19 5"
  }));
};
Block.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$53 = ["color", "size"];
var MoreHorizontalFill = function MoreHorizontalFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$53);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
  }));
};
MoreHorizontalFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$52 = ["color", "size"];
var MoreVerticalFill = function MoreVerticalFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$52);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }));
};
MoreVerticalFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$51 = ["color", "size"];
var Wifi = function Wifi(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$51);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 10c6-6.667 14-6.667 20 0"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 14c3.6-4 8.4-4 12 0"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "18",
    r: "1"
  }));
};
Wifi.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$50 = ["color", "size"];
var Bluetooth = function Bluetooth(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$50);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 7l12 10-6 5V2l6 5L5 17"
  }));
};
Bluetooth.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4$ = ["color", "size"];
var Location = function Location(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4$);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "10",
    r: "3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2a8 8 0 0 0-8 8c0 1.892.402 3.13 1.5 4.5L12 22l6.5-7.5c1.098-1.37 1.5-2.608 1.5-4.5a8 8 0 0 0-8-8z"
  }));
};
Location.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4_ = ["color", "size"];
var LinkChain = function LinkChain(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4_);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.544 10.456a4.368 4.368 0 0 0-6.176 0l-3.089 3.088a4.367 4.367 0 1 0 6.177 6.177L12 18.177"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.456 13.544a4.368 4.368 0 0 0 6.176 0l3.089-3.088a4.367 4.367 0 1 0-6.177-6.177L12 5.823"
  }));
};
LinkChain.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4Z = ["color", "size"];
var LinkOut = function LinkOut(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4Z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.5 10.5L21 3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 3h5v5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5"
  }));
};
LinkOut.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4Y = ["color", "size"];
var SignOut = function SignOut(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4Y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13 12h9m0 0l-3.333-4M22 12l-3.333 4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 7V5.174a2 2 0 0 0-2.166-1.993l-8 .666A2 2 0 0 0 2 5.84v12.32a2 2 0 0 0 1.834 1.993l8 .667A2 2 0 0 0 14 18.826V17"
  }));
};
SignOut.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4X = ["color", "size"];
var Hashtag = function Hashtag(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4X);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 3L6 21"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 3l-4 18"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 8h17"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 16h17"
  }));
};
Hashtag.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4W = ["color", "size"];
var Grid = function Grid(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4W);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "7",
    height: "7",
    rx: "1"
  }), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "14",
    width: "7",
    height: "7",
    rx: "1"
  }), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "14",
    y: "3",
    width: "7",
    height: "7",
    rx: "1"
  }), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "14",
    y: "14",
    width: "7",
    height: "7",
    rx: "1"
  }));
};
Grid.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4V = ["color", "size"];
var LinkOn = function LinkOn(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4V);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 12h6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 6h1a6 6 0 0 1 0 12h-1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 18H8A6 6 0 0 1 8 6h1"
  }));
};
LinkOn.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4U = ["color", "size"];
var LinkOff = function LinkOff(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4U);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 6h1a6 6 0 0 1 0 12h-1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 18H8A6 6 0 0 1 8 6h1"
  }));
};
LinkOff.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4T = ["color", "size"];
var ChatBubble = function ChatBubble(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4T);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
  }));
};
ChatBubble.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4S = ["color", "size"];
var ChatAdd = function ChatAdd(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4S);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 8v3m0 0v3m0-3h3m-3 0H9"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
  }));
};
ChatAdd.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4R = ["color", "size"];
var ChatRemove = function ChatRemove(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4R);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 11H9"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
  }));
};
ChatRemove.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4Q = ["color", "size"];
var ZoomIn = function ZoomIn(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4Q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 21l-4.486-4.494M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.5 7v3.5m0 0V14m0-3.5H14m-3.5 0H7"
  }));
};
ZoomIn.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4P = ["color", "size"];
var ZoomOut = function ZoomOut(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4P);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 21l-4.486-4.494M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13 10.5H8"
  }));
};
ZoomOut.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4O = ["color", "size"];
var Box = function Box(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4O);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "4"
  }));
};
Box.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4N = ["color", "size"];
var CheckBox = function CheckBox(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4N);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 12l2.25 2L15 10"
  }));
};
CheckBox.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4M = ["color", "size"];
var CheckBoxFill = function CheckBoxFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4M);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5H7zm8.73 8.684a1 1 0 1 0-1.46-1.368l-3.083 3.29-1.523-1.353a1 1 0 0 0-1.328 1.494l2.25 2a1 1 0 0 0 1.393-.063l3.75-4z"
  }));
};
CheckBoxFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4L = ["color", "size"];
var Rss = function Rss(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4L);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 10.418c6.068-.319 9.9 3.514 9.582 9.582"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "5",
    cy: "19",
    r: "1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 4.03C14.114 3.5 20.501 9.887 19.97 20"
  }));
};
Rss.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4K = ["color", "size"];
var Backspace = function Backspace(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4K);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 15l-6-6m6 0l-6 6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7.4 4.8A2 2 0 0 1 9 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H9a2 2 0 0 1-1.6-.8l-4.5-6a2 2 0 0 1 0-2.4l4.5-6z"
  }));
};
Backspace.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4J = ["color", "size"];
var BackspaceFill = function BackspaceFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4J);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6 4.2A3 3 0 0 1 9 3h11a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H9a3 3 0 0 1-2.4-1.2l-4.5-6a3 3 0 0 1 0-3.6l4.5-6zm11.107 5.507a1 1 0 0 0-1.414-1.414L14 10.586l-2.293-2.293a1 1 0 1 0-1.414 1.414L12.586 12l-2.293 2.293a1 1 0 0 0 1.414 1.414L14 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L15.414 12l2.293-2.293z"
  }));
};
BackspaceFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4I = ["color", "size"];
var DoubleCheck = function DoubleCheck(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4I);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 12l5.25 5 2.625-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 12l5.25 5L22 7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 7l-3.5 4"
  }));
};
DoubleCheck.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4H = ["color", "size"];
var DragVerticalFill = function DragVerticalFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4H);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }));
};
DragVerticalFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4G = ["color", "size"];
var DragHorizontalFill = function DragHorizontalFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4G);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
  }));
};
DragHorizontalFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4F = ["color", "size"];
var DotGridFill = function DotGridFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4F);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm10 2a2 2 0 1 0-4 0 2 2 0 0 0 4 0zM4 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm10 2a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm6-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM6 20a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm6-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm10 2a2 2 0 1 0-4 0 2 2 0 0 0 4 0z"
  }));
};
DotGridFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4E = ["color", "size"];
var ChatDots = function ChatDots(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4E);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 11v.01"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 11v.01"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 11v.01"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
  }));
};
ChatDots.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4D = ["color", "size"];
var ChatError = function ChatError(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4D);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.879 8.879L12 11m0 0l2.121 2.121M12 11l2.121-2.121M12 11l-2.121 2.121"
  }));
};
ChatError.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4C = ["color", "size"];
var Health = function Health(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4C);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v5H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h5v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-5h5a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-5V3z"
  }));
};
Health.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4B = ["color", "size"];
var QuestionFill = function QuestionFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4B);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm-1.108 7.935c.23-.453.4-.668.541-.78.106-.084.25-.155.567-.155.625 0 1 .47 1 .978 0 .278-.054.416-.202.592-.207.246-.59.545-1.348 1.046l-.45.296V13a1 1 0 1 0 2 0v-1.017c.542-.374.997-.732 1.327-1.124.477-.566.673-1.17.673-1.881C15 7.508 13.867 6 12 6c-.684 0-1.289.176-1.808.587-.484.383-.814.91-1.084 1.445a1 1 0 1 0 1.784.903zM13 16.5a1 1 0 1 0-2 0v.5a1 1 0 1 0 2 0v-.5z"
  }));
};
QuestionFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4A = ["color", "size"];
var CircleAlertFill = function CircleAlertFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4A);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm1 6a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0V7zm0 9.5a1 1 0 1 0-2 0v.5a1 1 0 1 0 2 0v-.5z"
  }));
};
CircleAlertFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4z = ["color", "size"];
var CircleXFill = function CircleXFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm3.707 8.707a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293a1 1 0 1 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293z"
  }));
};
CircleXFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4y = ["color", "size"];
var CirclePlusFill = function CirclePlusFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm1 15a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 1 1 2 0v3h3a1 1 0 1 1 0 2h-3v3z"
  }));
};
CirclePlusFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4x = ["color", "size"];
var CircleMinusFill = function CircleMinusFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4x);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM8 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8z"
  }));
};
CircleMinusFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4w = ["color", "size"];
var CircleCheckFill = function CircleCheckFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4w);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm4.768 9.14a1 1 0 1 0-1.536-1.28l-4.3 5.159-2.225-2.226a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.475-.067l5-6z"
  }));
};
CircleCheckFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4v = ["color", "size"];
var TriangleAlertFill = function TriangleAlertFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4v);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.543 2.598a2.821 2.821 0 0 0-5.086 0L1.341 18.563C.37 20.469 1.597 23 3.883 23h16.233c2.287 0 3.512-2.53 2.543-4.437L14.543 2.598zM12 8a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1zm0 8.5a1 1 0 0 1 1 1v.5a1 1 0 1 1-2 0v-.5a1 1 0 0 1 1-1z"
  }));
};
TriangleAlertFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4u = ["color", "size"];
var StopFill = function StopFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4u);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1a1 1 0 0 0-.716.302l-6 6.156A1 1 0 0 0 1 8.156V16a1 1 0 0 0 .293.707l6 6A1 1 0 0 0 8 23h8a1 1 0 0 0 .707-.293l6-6A1 1 0 0 0 23 16V8.156a1 1 0 0 0-.284-.698l-6-6.156A1 1 0 0 0 16 1H8zm0 10a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8z"
  }));
};
StopFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4t = ["color", "size"];
var InfoFill = function InfoFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4t);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm-.5 5a1 1 0 1 0 0 2h.5a1 1 0 1 0 0-2h-.5zM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2z"
  }));
};
InfoFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4s = ["color", "size"];
var CloudDownload = function CloudDownload(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4s);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 22v-9m0 9l-2.5-2m2.5 2l2.5-2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.034 9.117A4.002 4.002 0 0 0 6 17h1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.83 7.138a5.5 5.5 0 0 0-10.796 1.98S5.187 10 5.5 10.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 17a5 5 0 1 0-1.17-9.862L14.5 7.5"
  }));
};
CloudDownload.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4r = ["color", "size"];
var CloudUpload = function CloudUpload(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4r);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 12v9m0-9l-2.5 2m2.5-2l2.5 2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.034 9.117A4.002 4.002 0 0 0 6 17h1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.83 7.138a5.5 5.5 0 0 0-10.796 1.98S5.187 10 5.5 10.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 17a5 5 0 1 0-1.17-9.862L14.5 7.5"
  }));
};
CloudUpload.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4q = ["color", "size"];
var Network = function Network(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "18",
    cy: "5",
    r: "3"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "18",
    cy: "19",
    r: "3"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "6",
    cy: "12",
    r: "3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.408 6.512l-6.814 3.975m6.814 7.001l-6.814-3.975"
  }));
};
Network.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4p = ["color", "size"];
var ToggleOff = function ToggleOff(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4p);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "7",
    width: "20",
    height: "10",
    rx: "5"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "7",
    cy: "12",
    r: "5"
  }));
};
ToggleOff.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4o = ["color", "size"];
var ToggleOn = function ToggleOn(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4o);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "7",
    width: "20",
    height: "10",
    rx: "5"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "17",
    cy: "12",
    r: "5"
  }));
};
ToggleOn.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4n = ["color", "size"];
var ToggleOffFill = function ToggleOffFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4n);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7a5 5 0 0 0 0 10h10a5 5 0 0 0 0-10H7zm0 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
  }));
};
ToggleOffFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4m = ["color", "size"];
var ToggleOnFill = function ToggleOnFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4m);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7a5 5 0 0 0 0 10h10a5 5 0 0 0 0-10H7zm10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
  }));
};
ToggleOnFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4l = ["color", "size"];
var ThreeLineHorizontal = function ThreeLineHorizontal(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4l);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 6h14M5 12h14M5 18h14"
  }));
};
ThreeLineHorizontal.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4k = ["color", "size"];
var ThreeLineVertical = function ThreeLineVertical(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4k);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 19V5m6 14V5M6 19V5"
  }));
};
ThreeLineVertical.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4j = ["color", "size"];
var TwoLineHorizontal = function TwoLineHorizontal(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4j);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 9h14M5 15h14"
  }));
};
TwoLineHorizontal.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4i = ["color", "size"];
var TwoLineVertical = function TwoLineVertical(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4i);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 19V5M9 19V5"
  }));
};
TwoLineVertical.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4h = ["color", "size"];
var PointerLeftFill = function PointerLeftFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4h);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6 4.2A3 3 0 0 1 9 3h11a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H9a3 3 0 0 1-2.4-1.2l-4.5-6a3 3 0 0 1 0-3.6l4.5-6z"
  }));
};
PointerLeftFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4g = ["color", "size"];
var PointerRightFill = function PointerRightFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4g);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9 4.2A3 3 0 0 0 15.5 3h-11a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h11a3 3 0 0 0 2.4-1.2l4.5-6a3 3 0 0 0 0-3.6l-4.5-6z"
  }));
};
PointerRightFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4f = ["color", "size"];
var PointerUpFill = function PointerUpFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4f);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.05 6.35a3 3 0 0 1 1.2 2.4v11a3 3 0 0 1-3 3h-12a3 3 0 0 1-3-3v-11a3 3 0 0 1 1.2-2.4l6-4.5a3 3 0 0 1 3.6 0l6 4.5z"
  }));
};
PointerUpFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4e = ["color", "size"];
var PointerDownFill = function PointerDownFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4e);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.05 17.65a3 3 0 0 0 1.2-2.4v-11a3 3 0 0 0-3-3h-12a3 3 0 0 0-3 3v11a3 3 0 0 0 1.2 2.4l6 4.5a3 3 0 0 0 3.6 0l6-4.5z"
  }));
};
PointerDownFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4d = ["color", "size"];
var ChatApprove = function ChatApprove(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4d);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 11l2.25 2L15 9"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
  }));
};
ChatApprove.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4c = ["color", "size"];
var ChatQuestion = function ChatQuestion(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4c);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 8.484C10.5 7.494 11 7 12 7c1.246 0 2 .989 2 1.978s-.5 1.033-2 2.022v1m0 2.5v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
  }));
};
ChatQuestion.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4b = ["color", "size"];
var ChatEdit = function ChatEdit(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4b);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.207 6.793a1 1 0 0 0-1.418.003l-4.55 4.597a2 2 0 0 0-.54 1.015l-.18.896a1 1 0 0 0 1.177 1.177l.896-.18a2 2 0 0 0 1.015-.54l4.597-4.55a1 1 0 0 0 .003-1.418l-1-1z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.5 9.5l1 1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
  }));
};
ChatEdit.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4a = ["color", "size"];
var Cursor = function Cursor(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4a);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 3l7 19 2.051-6.154a6 6 0 0 1 3.795-3.795L22 10 3 3z"
  }));
};
Cursor.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$49 = ["color", "size"];
var Frame = function Frame(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$49);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 3v18"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 3v18"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 6h18"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 18h18"
  }));
};
Frame.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$48 = ["color", "size"];
var Slice = function Slice(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$48);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13 21H3l10-10v10z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 19L21 3v4l-8 8"
  }));
};
Slice.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$47 = ["color", "size"];
var Percentage = function Percentage(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$47);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 19L19 5"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "7",
    cy: "7",
    r: "3"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "17",
    cy: "17",
    r: "3"
  }));
};
Percentage.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$46 = ["color", "size"];
var CheckIn = function CheckIn(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$46);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2a6 6 0 0 0-6 6c0 1.419.302 2.348 1.125 3.375L12 17l4.875-5.625C17.698 10.348 18 9.419 18 8a6 6 0 0 0-6-6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 15.143C3.149 15.87 2 16.881 2 18c0 2.21 4.477 4 10 4s10-1.79 10-4c0-1.119-1.149-2.13-3-2.857"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "8",
    r: "1"
  }));
};
CheckIn.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$45 = ["color", "size"];
var Video = function Video(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$45);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "4",
    width: "20",
    height: "16",
    rx: "4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 12l-5-3v6l5-3z"
  }));
};
Video.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$44 = ["color", "size"];
var Cut = function Cut(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$44);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "7",
    cy: "18",
    r: "3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 15L7 3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 15l3-4.5M17 3l-3 4.5"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "17",
    cy: "18",
    r: "3"
  }));
};
Cut.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$43 = ["color", "size"];
var Filter = function Filter(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$43);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("ellipse", {
    cx: "12",
    cy: "5",
    rx: "9",
    ry: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 5c0 2.23 3.871 6.674 5.856 8.805A4.197 4.197 0 0 1 10 16.657V19a2 2 0 0 0 2 2v0a2 2 0 0 0 2-2v-2.343c0-1.061.421-2.075 1.144-2.852C17.13 11.674 21 7.231 21 5"
  }));
};
Filter.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$42 = ["color", "size"];
var SettingsHorizontal = function SettingsHorizontal(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$42);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 5h4m14 0H11m-8 7h12m6 0h-2M3 19h2m16 0H9"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "9",
    cy: "5",
    r: "2"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "17",
    cy: "12",
    r: "2"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "7",
    cy: "19",
    r: "2"
  }));
};
SettingsHorizontal.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$41 = ["color", "size"];
var SettingsVertical = function SettingsVertical(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$41);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 3v4m0 14V11m-7-8v12m0 6v-2M5 3v2m0 16V9"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "19",
    cy: "9",
    r: "2",
    transform: "rotate(90 19 9)"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "17",
    r: "2",
    transform: "rotate(90 12 17)"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "5",
    cy: "7",
    r: "2",
    transform: "rotate(90 5 7)"
  }));
};
SettingsVertical.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$40 = ["color", "size"];
var Ascending = function Ascending(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$40);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 3v18M6 3l3 3.333M6 3L3 6.333"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 21h8l-1-4h-7v4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 14h6l-1-4h-5v4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 7h4l-1-4h-3v4z"
  }));
};
Ascending.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3$ = ["color", "size"];
var Descending = function Descending(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3$);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 21V3m0 18l3-3.333M6 21l-3-3.333"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 3h8l-1 4h-7V3z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 10h6l-1 4h-5v-4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 17h4l-1 4h-3v-4z"
  }));
};
Descending.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3_ = ["color", "size"];
var StatisticUp = function StatisticUp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3_);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 3v16a2 2 0 0 0 2 2h16"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 14l4-4 4 4 6-6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 8h3v3"
  }));
};
StatisticUp.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3Z = ["color", "size"];
var StatisticDown = function StatisticDown(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3Z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 3v16a2 2 0 0 0 2 2h16"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 9l4 4 4-4 6 6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 15h3v-3"
  }));
};
StatisticDown.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3Y = ["color", "size"];
var PanelRight = function PanelRight(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3Y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "3",
    width: "20",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 3v18"
  }));
};
PanelRight.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3X = ["color", "size"];
var PanelLeft = function PanelLeft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3X);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "3",
    width: "20",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 3v18"
  }));
};
PanelLeft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3W = ["color", "size"];
var PanelSplit = function PanelSplit(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3W);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "3",
    width: "20",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 3v18"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 12H9"
  }));
};
PanelSplit.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3V = ["color", "size"];
var Dashboard = function Dashboard(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3V);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 5a2 2 0 0 1 2-2h6v18H4a2 2 0 0 1-2-2V5z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 3h6a2 2 0 0 1 2 2v5h-8V3z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 14h8v5a2 2 0 0 1-2 2h-6v-7z"
  }));
};
Dashboard.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3U = ["color", "size"];
var PanelBottom = function PanelBottom(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3U);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "3",
    width: "20",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 15H2"
  }));
};
PanelBottom.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3T = ["color", "size"];
var PanelTop = function PanelTop(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3T);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "3",
    width: "20",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 9H2"
  }));
};
PanelTop.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3S = ["color", "size"];
var PanelSplitRow = function PanelSplitRow(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3S);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "3",
    width: "20",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 3v18"
  }));
};
PanelSplitRow.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3R = ["color", "size"];
var PanelSplitColumn = function PanelSplitColumn(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3R);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "3",
    width: "20",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 12H2"
  }));
};
PanelSplitColumn.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3Q = ["color", "size"];
var Language = function Language(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3Q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.5 13.5l1-2m0 0l1.106-2.211a1 1 0 0 1 1.788 0L10.5 11.5m-4 0h4m0 0l1 2m1-6h1.982V9c0 .5-.496 1.5-1.487 1.5m3.964-3v2m0 0v4m0-4H18.5"
  }));
};
Language.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3P = ["color", "size"];
var Sort = function Sort(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3P);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 6h18M6 12h12m-9 6h6"
  }));
};
Sort.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3O = ["color", "size"];
var Equal = function Equal(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3O);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 14H8"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 10H8"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }));
};
Equal.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3N = ["color", "size"];
var EqualFill = function EqualFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3N);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm6 2a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1zm1-5a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8z"
  }));
};
EqualFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3M = ["color", "size"];
var Radio = function Radio(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3M);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z"
  }));
};
Radio.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3L = ["color", "size"];
var RadioFill = function RadioFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3L);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
  }));
};
RadioFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3K = ["color", "size"];
var Save = function Save(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3K);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 21h10a4 4 0 0 0 4-4V7.414a1 1 0 0 0-.293-.707l-3.414-3.414A1 1 0 0 0 16.586 3H7a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 3h6v3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V3z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 17h2"
  }));
};
Save.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3J = ["color", "size"];
var AugmentedReality = function AugmentedReality(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3J);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.971 6.617a2 2 0 0 1 2.058 0l3.486 2.092a1 1 0 0 1 .485.857v4.302a2 2 0 0 1-.971 1.715l-3 1.8a2 2 0 0 1-2.058 0l-3-1.8A2 2 0 0 1 7 13.868V9.566a1 1 0 0 1 .486-.857l3.485-2.092z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 9l5 2.759m0 0L17 9m-5 2.759V17"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 2H4a2 2 0 0 0-2 2v2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 22h2a2 2 0 0 0 2-2v-2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 6V4a2 2 0 0 0-2-2h-2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 18v2a2 2 0 0 0 2 2h2"
  }));
};
AugmentedReality.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3I = ["color", "size"];
var History = function History(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3I);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.266 16.06a8.923 8.923 0 0 0 3.915 3.978 8.706 8.706 0 0 0 5.471.832 8.795 8.795 0 0 0 4.887-2.64 9.067 9.067 0 0 0 2.388-5.079 9.135 9.135 0 0 0-1.044-5.53 8.903 8.903 0 0 0-4.069-3.815 8.7 8.7 0 0 0-5.5-.608c-1.85.401-3.366 1.313-4.62 2.755-.151.16-.735.806-1.22 1.781M7.5 8l-3.609.72L3 5m9 4v4l3 2"
  }));
};
History.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3H = ["color", "size"];
var XSmall = function XSmall(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3H);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 17L7 7m10 0L7 17"
  }));
};
XSmall.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3G = ["color", "size"];
var Ribbon = function Ribbon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3G);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 5v14.586c0 .89 1.077 1.337 1.707.707L12 14l6.293 6.293c.63.63 1.707.184 1.707-.707V5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2z"
  }));
};
Ribbon.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3F = ["color", "size"];
var Phone = function Phone(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3F);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.554 6.24L7.171 2.335c-.39-.45-1.105-.448-1.558.006L2.831 5.128c-.828.829-1.065 2.06-.586 3.047a29.207 29.207 0 0 0 13.561 13.58c.986.479 2.216.242 3.044-.587l2.808-2.813c.455-.455.456-1.174.002-1.564l-3.92-3.365c-.41-.352-1.047-.306-1.458.106l-1.364 1.366a.462.462 0 0 1-.553.088 14.557 14.557 0 0 1-5.36-5.367.463.463 0 0 1 .088-.554l1.36-1.361c.412-.414.457-1.054.101-1.465z"
  }));
};
Phone.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3E = ["color", "size"];
var Attach = function Attach(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3E);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 7.91V16a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V6a4 4 0 0 0-4-4v0a4 4 0 0 0-4 4v9.182a2 2 0 0 0 2 2v0a2 2 0 0 0 2-2V8"
  }));
};
Attach.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3D = ["color", "size"];
var Thunder = function Thunder(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3D);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17.684 3.603c.521-.659.03-1.603-.836-1.603h-6.716c-.375 0-.722.192-.909.502l-5.082 8.456c-.401.666.103 1.497.908 1.497h3.429l-3.23 8.065c-.467 1.02.795 1.953 1.643 1.215L20 9.331h-6.849l4.533-5.728z"
  }));
};
Thunder.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3C = ["color", "size"];
var Send = function Send(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3C);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.912 12H4L2.023 4.135A.662.662 0 0 1 2 3.995c-.022-.721.772-1.221 1.46-.891L22 12 3.46 20.896c-.68.327-1.464-.159-1.46-.867a.66.66 0 0 1 .033-.186L3.5 15"
  }));
};
Send.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3B = ["color", "size"];
var Sun = function Sun(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3B);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 3V2m0 20v-1m9-9h1M2 12h1m15.5-6.5L20 4M4 20l1.5-1.5M4 4l1.5 1.5m13 13L20 20"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }));
};
Sun.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3A = ["color", "size"];
var Moon = function Moon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3A);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.958 15.325c.204-.486-.379-.9-.868-.684a7.684 7.684 0 0 1-3.101.648c-4.185 0-7.577-3.324-7.577-7.425a7.28 7.28 0 0 1 1.134-3.91c.284-.448-.057-1.068-.577-.936C5.96 4.041 3 7.613 3 11.862 3 16.909 7.175 21 12.326 21c3.9 0 7.24-2.345 8.632-5.675z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.611 3.103c-.53-.354-1.162.278-.809.808l.63.945a2.332 2.332 0 0 1 0 2.588l-.63.945c-.353.53.28 1.162.81.808l.944-.63a2.332 2.332 0 0 1 2.588 0l.945.63c.53.354 1.162-.278.808-.808l-.63-.945a2.332 2.332 0 0 1 0-2.588l.63-.945c.354-.53-.278-1.162-.809-.808l-.944.63a2.332 2.332 0 0 1-2.588 0l-.945-.63z"
  }));
};
Moon.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3z = ["color", "size"];
var Pencil = function Pencil(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.333 16.048L16.57 3.81a2.56 2.56 0 0 1 3.62 3.619L7.951 19.667a2 2 0 0 1-1.022.547L3 21l.786-3.93a2 2 0 0 1 .547-1.022z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14.5 6.5l3 3"
  }));
};
Pencil.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3y = ["color", "size"];
var Pin = function Pin(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 10.726l-3 .505L11.23 2l-.504 3M12 16.881l-.77 2.042 7.693-7.692-2.042.769m-1.804 3.077L21 21M3.538 9.692l6.154-6.154.236.341a52.22 52.22 0 0 0 7.376 8.518l.235.218-4.924 4.923-.218-.234A52.22 52.22 0 0 0 3.88 9.928l-.34-.236z"
  }));
};
Pin.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3x = ["color", "size"];
var Draft = function Draft(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3x);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.5 6v4H16m-1.315-8H10a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.242a2 2 0 0 0-.602-1.43L16.083 2.57A2 2 0 0 0 14.685 2z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 18v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2"
  }));
};
Draft.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3w = ["color", "size"];
var EyeOpen = function EyeOpen(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3w);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21.257 10.962c.474.62.474 1.457 0 2.076C19.764 14.987 16.182 19 12 19c-4.182 0-7.764-4.013-9.257-5.962a1.692 1.692 0 0 1 0-2.076C4.236 9.013 7.818 5 12 5c4.182 0 7.764 4.013 9.257 5.962z"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }));
};
EyeOpen.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3v = ["color", "size"];
var EyeSlashed = function EyeSlashed(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3v);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.873 17.129c-1.845-1.31-3.305-3.014-4.13-4.09a1.693 1.693 0 0 1 0-2.077C4.236 9.013 7.818 5 12 5c1.876 0 3.63.807 5.13 1.874"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14.13 9.887a3 3 0 1 0-4.243 4.242"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 20L20 4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 18.704A7.124 7.124 0 0 0 12 19c4.182 0 7.764-4.013 9.257-5.962a1.694 1.694 0 0 0-.001-2.078A22.939 22.939 0 0 0 19.57 9"
  }));
};
EyeSlashed.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3u = ["color", "size"];
var EyeClosed = function EyeClosed(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3u);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 10s3.5 4 10 4 10-4 10-4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 11.645L2 14"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 14l-1.996-2.352"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.914 13.68L8 16.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.063 13.688L16 16.5"
  }));
};
EyeClosed.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3t = ["color", "size"];
var Airpods = function Airpods(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3t);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 7c0 2.21 1.644 4 4 4s4-1.79 4-4-1.644-4-4-4-4 1.79-4 4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 7c0 2.21-1.644 4-4 4S2 9.21 2 7s1.644-4 4-4 4 1.79 4 4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 7v12a2 2 0 0 0 2 2v0a2 2 0 0 0 2-2v-8"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 17h4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 17h4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 7v12a2 2 0 0 1-2 2v0a2 2 0 0 1-2-2v-8"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 4v0a5.408 5.408 0 0 0 0 6v0"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 4v0a5.408 5.408 0 0 1 0 6v0"
  }));
};
Airpods.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3s = ["color", "size"];
var Paper = function Paper(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3s);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 4v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.342a2 2 0 0 0-.602-1.43l-4.44-4.342A2 2 0 0 0 13.56 2H6a2 2 0 0 0-2 2z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 2v4a2 2 0 0 0 2 2h4"
  }));
};
Paper.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3r = ["color", "size"];
var File = function File(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3r);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 4v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.342a2 2 0 0 0-.602-1.43l-4.44-4.342A2 2 0 0 0 13.56 2H6a2 2 0 0 0-2 2z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 13h6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 17h3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 2v4a2 2 0 0 0 2 2h4"
  }));
};
File.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3q = ["color", "size"];
var Headphone = function Headphone(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 13.565C2 11.512 4 11 6 11v9a4 4 0 0 1-4-4v-2.435z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 13.565C22 11.512 20 11 18 11v9a4 4 0 0 0 4-4v-2.435z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 20V10a6 6 0 1 1 12 0v10"
  }));
};
Headphone.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3p = ["color", "size"];
var MobileDevice = function MobileDevice(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3p);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "6",
    y: "2",
    width: "12",
    height: "20",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.95 18h.1"
  }));
};
MobileDevice.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3o = ["color", "size"];
var TabletDevice = function TabletDevice(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3o);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "4",
    y: "2",
    width: "16",
    height: "20",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 18h2"
  }));
};
TabletDevice.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3n = ["color", "size"];
var LaptopDevice = function LaptopDevice(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3n);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9H4V7z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 19h20"
  }));
};
LaptopDevice.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3m = ["color", "size"];
var DesktopDevice = function DesktopDevice(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3m);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 20h8"
  }));
};
DesktopDevice.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3l = ["color", "size"];
var WatchDevice = function WatchDevice(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3l);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 22h6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 2h6"
  }));
};
WatchDevice.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3k = ["color", "size"];
var Wallet = function Wallet(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3k);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 8h20"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 12h7c0 1 .6 3 3 3s3-2 3-3h7"
  }));
};
Wallet.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3j = ["color", "size"];
var Search = function Search(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3j);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 21l-4.486-4.494M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z"
  }));
};
Search.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3i = ["color", "size"];
var LockOn = function LockOn(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3i);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "10",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v4H6V6z"
  }));
};
LockOn.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3h = ["color", "size"];
var LockOff = function LockOff(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3h);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "10",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 10V5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1"
  }));
};
LockOff.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3g = ["color", "size"];
var Camera = function Camera(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3g);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.233 5.834l.445-2.226A2 2 0 0 1 8.64 2h6.72a2 2 0 0 1 1.962 1.608l.445 2.226a1.879 1.879 0 0 0 1.387 1.454A3.758 3.758 0 0 1 22 10.934V18a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4v-7.066a3.758 3.758 0 0 1 2.846-3.646 1.879 1.879 0 0 0 1.387-1.454z"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "14",
    r: "4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 6h2"
  }));
};
Camera.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3f = ["color", "size"];
var Image = function Image(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3f);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6z"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "8.5",
    cy: "8.5",
    r: "2.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14.526 12.621L6 22h12.133A3.867 3.867 0 0 0 22 18.133V18c0-.466-.175-.645-.49-.99l-4.03-4.395a2 2 0 0 0-2.954.006z"
  }));
};
Image.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3e = ["color", "size"];
var Folder = function Folder(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3e);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 19V9a2 2 0 0 0-2-2h-6.764a2 2 0 0 1-1.789-1.106l-.894-1.788A2 2 0 0 0 8.763 3H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2z"
  }));
};
Folder.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3d = ["color", "size"];
var FolderAdd = function FolderAdd(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3d);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 19V9a2 2 0 0 0-2-2h-6.764a2 2 0 0 1-1.789-1.106l-.894-1.788A2 2 0 0 0 8.763 3H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 11v3m0 0v3m0-3h3m-3 0H9"
  }));
};
FolderAdd.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3c = ["color", "size"];
var Calendar = function Calendar(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3c);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "4",
    width: "20",
    height: "18",
    rx: "4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 2v4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 2v4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 10h20"
  }));
};
Calendar.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3b = ["color", "size"];
var Bell = function Bell(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3b);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.721 5.003L11.255 5c-3.344-.008-6.247 2.709-6.27 6v3.79c0 .79-.1 1.561-.531 2.218l-.287.438C3.73 18.11 4.2 19 4.985 19h14.03c.785 0 1.254-.89.818-1.554l-.287-.438c-.43-.657-.531-1.429-.531-2.219v-3.788c-.04-3.292-2.95-5.99-6.294-5.998z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 19a3 3 0 1 1-6 0"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2a2 2 0 0 1 2 2v1h-4V4a2 2 0 0 1 2-2z"
  }));
};
Bell.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3a = ["color", "size"];
var BatteryEmpty = function BatteryEmpty(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3a);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "6",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 10h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H20v-4z"
  }));
};
BatteryEmpty.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$39 = ["color", "size"];
var BatteryLow = function BatteryLow(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$39);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "6",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 10v4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 10h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H20v-4z"
  }));
};
BatteryLow.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$38 = ["color", "size"];
var BatteryMedium = function BatteryMedium(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$38);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "6",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 10h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H20v-4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 10v4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 10v4"
  }));
};
BatteryMedium.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$37 = ["color", "size"];
var BatteryFull = function BatteryFull(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$37);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "6",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 10v4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 10v4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 10v4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 10h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H20v-4z"
  }));
};
BatteryFull.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$36 = ["color", "size"];
var Flashlight = function Flashlight(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$36);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 4v1c0 1.636 2 4 3 5l.75 9.01A3.26 3.26 0 0 0 12 22v0a3.26 3.26 0 0 0 3.25-2.99L16 10c1-1 3-3.364 3-5V4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 11v2"
  }), /*#__PURE__*/React__default["default"].createElement("ellipse", {
    cx: "12",
    cy: "4",
    rx: "7",
    ry: "2"
  }));
};
Flashlight.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$35 = ["color", "size"];
var Calculator = function Calculator(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$35);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v5H2V6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18.5 16.5h-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 11h10v7a4 4 0 0 1-4 4h-6V11z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 11H2v7a4 4 0 0 0 4 4h6V11z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.5 18L7 16.5m0 0L8.5 15M7 16.5L8.5 18M7 16.5L5.5 15"
  }));
};
Calculator.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$34 = ["color", "size"];
var Alarm = function Alarm(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$34);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "13",
    r: "9"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.5 9.5L12 13"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 19l1 3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 19l-1 3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 5l3-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 2l3 3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 4V2"
  }));
};
Alarm.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$33 = ["color", "size"];
var Globe = function Globe(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$33);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("ellipse", {
    cx: "12",
    cy: "12",
    rx: "10",
    ry: "4",
    transform: "rotate(90 12 12)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 12h20"
  }));
};
Globe.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$32 = ["color", "size"];
var BookOpen = function BookOpen(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$32);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 6s1.5-2 5-2 5 2 5 2v14s-1.5-1-5-1-5 1-5 1V6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 6s1.5-2 5-2 5 2 5 2v14s-1.5-1-5-1-5 1-5 1V6z"
  }));
};
BookOpen.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$31 = ["color", "size"];
var Cloud = function Cloud(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$31);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.034 11.117A4.002 4.002 0 0 0 6 19h11a5 5 0 1 0-1.17-9.862L14.5 9.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.83 9.138a5.5 5.5 0 0 0-10.796 1.98S5.187 12 5.5 12.5"
  }));
};
Cloud.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$30 = ["color", "size"];
var Envelope = function Envelope(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$30);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 8l7.501 6.001a4 4 0 0 0 4.998 0L22 8"
  }));
};
Envelope.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2$ = ["color", "size"];
var ShoppingBag = function ShoppingBag(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2$);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3.977 9.84A2 2 0 0 1 5.971 8h12.058a2 2 0 0 1 1.994 1.84l.803 10A2 2 0 0 1 18.833 22H5.167a2 2 0 0 1-1.993-2.16l.803-10z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 11V6a4 4 0 0 0-4-4v0a4 4 0 0 0-4 4v5"
  }));
};
ShoppingBag.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2_ = ["color", "size"];
var Gift = function Gift(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2_);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "8",
    width: "18",
    height: "14",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 5a3 3 0 1 0-3 3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 8a3 3 0 1 0-3-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 5v17"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 15H3"
  }));
};
Gift.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2Z = ["color", "size"];
var Map = function Map(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2Z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.368 4.79l-2.736-.913A2 2 0 0 0 3 5.775v11.783a2 2 0 0 0 1.368 1.898l4 1.333a2 2 0 0 0 1.264 0l4.736-1.578a2 2 0 0 1 1.264 0l2.736.912A2 2 0 0 0 21 18.224V6.442a2 2 0 0 0-1.367-1.898l-4-1.333a2 2 0 0 0-1.265 0L9.631 4.789a2 2 0 0 1-1.264 0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 5v16"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 3v16"
  }));
};
Map.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2Y = ["color", "size"];
var Shield = function Shield(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2Y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.147 21.197l1.67-1.168a13.393 13.393 0 0 0 5.447-13.624.837.837 0 0 0-.453-.586L12 2 4.19 5.819a.837.837 0 0 0-.454.586 13.393 13.393 0 0 0 5.448 13.624l1.67 1.168a2 2 0 0 0 2.293 0z"
  }));
};
Shield.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2X = ["color", "size"];
var Tag = function Tag(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2X);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.244 21.366a2.164 2.164 0 0 1-3.061 0l-8.549-8.549A2.164 2.164 0 0 1 3 11.287V5.163C3 3.97 3.97 3 5.164 3h6.123c.573 0 1.124.228 1.53.634l8.549 8.549a2.164 2.164 0 0 1 0 3.061l-6.122 6.122z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.5 6.5L7 7"
  }));
};
Tag.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2W = ["color", "size"];
var Gear = function Gear(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2W);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 3.269C14 2.568 13.432 2 12.731 2H11.27C10.568 2 10 2.568 10 3.269v0c0 .578-.396 1.074-.935 1.286-.085.034-.17.07-.253.106-.531.23-1.162.16-1.572-.249v0a1.269 1.269 0 0 0-1.794 0L4.412 5.446a1.269 1.269 0 0 0 0 1.794v0c.41.41.48 1.04.248 1.572a7.946 7.946 0 0 0-.105.253c-.212.539-.708.935-1.286.935v0C2.568 10 2 10.568 2 11.269v1.462C2 13.432 2.568 14 3.269 14v0c.578 0 1.074.396 1.286.935.034.085.07.17.105.253.231.531.161 1.162-.248 1.572v0a1.269 1.269 0 0 0 0 1.794l1.034 1.034a1.269 1.269 0 0 0 1.794 0v0c.41-.41 1.04-.48 1.572-.249.083.037.168.072.253.106.539.212.935.708.935 1.286v0c0 .701.568 1.269 1.269 1.269h1.462c.701 0 1.269-.568 1.269-1.269v0c0-.578.396-1.074.935-1.287.085-.033.17-.068.253-.104.531-.232 1.162-.161 1.571.248v0a1.269 1.269 0 0 0 1.795 0l1.034-1.034a1.269 1.269 0 0 0 0-1.794v0c-.41-.41-.48-1.04-.249-1.572.037-.083.072-.168.106-.253.212-.539.708-.935 1.286-.935v0c.701 0 1.269-.568 1.269-1.269V11.27c0-.701-.568-1.269-1.269-1.269v0c-.578 0-1.074-.396-1.287-.935a7.755 7.755 0 0 0-.105-.253c-.23-.531-.16-1.162.249-1.572v0a1.269 1.269 0 0 0 0-1.794l-1.034-1.034a1.269 1.269 0 0 0-1.794 0v0c-.41.41-1.04.48-1.572.249a7.913 7.913 0 0 0-.253-.106C14.396 4.343 14 3.847 14 3.27v0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"
  }));
};
Gear.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2V = ["color", "size"];
var Flag = function Flag(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2V);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 15h13.865a1 1 0 0 0 .768-1.64L15 9l3.633-4.36A1 1 0 0 0 17.865 3H4v18"
  }));
};
Flag.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2U = ["color", "size"];
var Ticket = function Ticket(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2U);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.707 3.293c-.39.39-.369 1.021-.138 1.523a2.83 2.83 0 0 1-3.753 3.753c-.502-.23-1.133-.252-1.523.138l-.586.586a1 1 0 0 0 0 1.414l10.586 10.586a1 1 0 0 0 1.414 0l.586-.586c.39-.39.369-1.021.138-1.523a2.83 2.83 0 0 1 3.753-3.753c.502.23 1.133.252 1.523-.138l.586-.586a1 1 0 0 0 0-1.414L10.707 2.707a1 1 0 0 0-1.414 0l-.586.586z"
  }));
};
Ticket.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2T = ["color", "size"];
var Bug = function Bug(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2T);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 9a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v5a7 7 0 0 1-7 7v0a7 7 0 0 1-7-7V9z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 6v-.425c0-.981.384-1.96 1.326-2.238 1.525-.45 3.823-.45 5.348 0C15.616 3.615 16 4.594 16 5.575V6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18.5 7.5L22 4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.5 7.5L2 4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 18l-4 3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 12H1.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22.5 12H19"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 18l4 3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 13v8"
  }));
};
Bug.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2S = ["color", "size"];
var Copy = function Copy(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2S);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 4v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.242a2 2 0 0 0-.602-1.43L16.083 2.57A2 2 0 0 0 14.685 2H10a2 2 0 0 0-2 2z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 18v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2"
  }));
};
Copy.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2R = ["color", "size"];
var Lifesaver = function Lifesaver(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2R);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_73_30)"
  }, /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    transform: "rotate(45 12 12)"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4",
    transform: "rotate(45 12 12)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.071 4.929l-4.243 4.243"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.172 14.828l-4.243 4.243"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.071 19.071l-4.243-4.243"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.172 9.172L4.929 4.929"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_73_30"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
Lifesaver.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2Q = ["color", "size"];
var Star = function Star(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2Q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.074 2.633c.32-.844 1.531-.844 1.852 0l2.07 5.734c.145.38.514.633.926.633h5.087c.94 0 1.35 1.17.611 1.743L18 14a.968.968 0 0 0-.322 1.092L19 20.695c.322.9-.72 1.673-1.508 1.119l-4.917-3.12a1 1 0 0 0-1.15 0l-4.917 3.12c-.787.554-1.83-.22-1.508-1.119l1.322-5.603A.968.968 0 0 0 6 14l-3.62-3.257C1.64 10.17 2.052 9 2.99 9h5.087a.989.989 0 0 0 .926-.633l2.07-5.734z"
  }));
};
Star.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2P = ["color", "size"];
var BatteryCharging = function BatteryCharging(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2P);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "6",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 10h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H20v-4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.4 9L9 12h4l-2.4 3"
  }));
};
BatteryCharging.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2O = ["color", "size"];
var Trophy = function Trophy(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2O);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v5a7 7 0 0 1-7 7v0a7 7 0 0 1-7-7V4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 22h6l-3-5-3 5z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 4H4a2 2 0 0 0-2 2v1.239a4 4 0 0 0 2.128 3.535L5.5 11.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 4h1a2 2 0 0 1 2 2v.637a5 5 0 0 1-2.66 4.419l-.84.444"
  }));
};
Trophy.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2N = ["color", "size"];
var Leaf = function Leaf(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2N);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 18C19.954 18 20.917 7.83 20.994 2.997a.983.983 0 0 0-1.006-.988C3 2.321 3 10.557 3 18v4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 18s0-6 8-7"
  }));
};
Leaf.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2M = ["color", "size"];
var Schedule = function Schedule(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2M);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 20H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h11a4 4 0 0 1 4 4v3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 2v2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 2v2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 8h19"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18.5 15.643l-1.5 1.5"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "17",
    cy: "17",
    r: "5"
  }));
};
Schedule.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2L = ["color", "size"];
var Money = function Money(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2L);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7z"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 9v0a4 4 0 0 0 4-4v0"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 19v0a4 4 0 0 1 4-4v0"
  }));
};
Money.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2K = ["color", "size"];
var Scissor = function Scissor(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2K);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.252 18.459C7.462 19.764 7.107 21 5.7 21 4.209 21 3 19.757 3 18.223s1.209-2.778 2.7-2.778c1.4 0 2.55 1.095 2.686 2.498a.846.846 0 0 1-.134.515zm0 0l1.948-3.476m5.548 3.476C16.538 19.764 16.893 21 18.3 21c1.491 0 2.7-1.243 2.7-2.777s-1.209-2.778-2.7-2.778c-1.4 0-2.55 1.095-2.687 2.498-.017.182.04.36.135.515zm0 0L7.093 3.346a.659.659 0 0 0-1.1-.081c-1.704 2.19-1.534 5.35.395 7.333l9.36 7.86zm-3.797-6.63l4.953-8.494a.66.66 0 0 1 1.098-.076c1.707 2.194 1.537 5.358-.395 7.345L16.5 11.742"
  }));
};
Scissor.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2J = ["color", "size"];
var Coin = function Coin(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2J);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("ellipse", {
    cx: "9.5",
    cy: "10",
    rx: "9.5",
    ry: "10",
    transform: "matrix(-1 0 0 1 20 2)"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13 8.8a3.583 3.583 0 0 0-2.25-.8C8.679 8 7 9.79 7 12s1.679 4 3.75 4c.844 0 1.623-.298 2.25-.8"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 2c4.333 0 13 1 13 10s-8.667 10-13 10"
  }));
};
Coin.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2I = ["color", "size"];
var Telescope = function Telescope(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2I);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 21l6-8 8 8"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.228 7.303l13.532-5.06a1 1 0 0 1 1.108.285l.19.22A8 8 0 0 1 22 7.973v.616a1 1 0 0 1-.65.937l-13.536 5.06-2.586-7.283z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2.66 11.371a2 2 0 0 1 1.193-2.545l1.694-.624 1.944 5.473-1.64.612a2 2 0 0 1-2.585-1.205l-.606-1.711z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13 13v9"
  }));
};
Telescope.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2H = ["color", "size"];
var Planet = function Planet(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2H);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "8"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.399 4.849C5.372 2.582 2.972 1.489 2.23 2.23c-1.174 1.174 2.248 6.5 7.643 11.895 5.396 5.395 10.722 8.817 11.895 7.643.431-.43.243-1.421-.435-2.769"
  }));
};
Planet.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2G = ["color", "size"];
var GameController = function GameController(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2G);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 15l-2.968 2.968A2.362 2.362 0 0 1 2 16.298V15l1.357-6.784A4 4 0 0 1 7.279 5h9.442a4 4 0 0 1 3.922 3.216L22 15v1.297a2.362 2.362 0 0 1-4.032 1.67L15 15H9z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 5l1 2h4l1-2"
  }));
};
GameController.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2F = ["color", "size"];
var VrAr = function VrAr(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2F);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 10a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3.868a2 2 0 0 1-1.715-.971l-1.56-2.6a1 1 0 0 0-1.714 0l-1.56 2.6A2 2 0 0 1 7.868 19H4a2 2 0 0 1-2-2v-7z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3.813 6.781A4 4 0 0 1 7.14 5h9.718a4 4 0 0 1 3.328 1.781L21 8H3l.813-1.219z"
  }));
};
VrAr.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2E = ["color", "size"];
var Computing = function Computing(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2E);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "5",
    y: "5",
    width: "14",
    height: "14",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 5V2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 5V3l1-1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 22v-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 22v-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 8H2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 8h-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 16h-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 16H3l-1 1"
  }));
};
Computing.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2D = ["color", "size"];
var Inbox = function Inbox(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2D);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3.304 6.132A4 4 0 0 1 7.209 3h9.582a4 4 0 0 1 3.905 3.132l.147.662a23.997 23.997 0 0 1 0 10.412l-.147.662A4 4 0 0 1 16.791 21H7.21a4 4 0 0 1-3.905-3.132l-.147-.662a24 24 0 0 1 0-10.412l.147-.662z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2.5 13h6.338c0 1 .973 3 3.405 3 2.433 0 3.406-2 3.406-3H21.5"
  }));
};
Inbox.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2C = ["color", "size"];
var LightBulb = function LightBulb(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2C);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 22h4M5 9a7 7 0 0 1 14 0 6.972 6.972 0 0 1-3 5.734l-.542 2.566a2 2 0 0 1-1.977 1.7h-2.962a2 2 0 0 1-1.977-1.7L8 14.745A6.992 6.992 0 0 1 5 9z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 15h8"
  }));
};
LightBulb.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2B = ["color", "size"];
var Chess = function Chess(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2B);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.533 3.81L8 2l1 4-5.37 4.475A1.75 1.75 0 0 0 3 11.82v0c0 .617.537 1.088 1.127.986L9 12l-2.097 7h10.614l1.283-5.745c.913-4.088-1.386-8.21-5.267-9.445z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 21a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H4v-1z"
  }));
};
Chess.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2A = ["color", "size"];
var TrashCan = function TrashCan(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2A);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 6h16l-1.58 14.22A2 2 0 0 1 16.432 22H7.568a2 2 0 0 1-1.988-1.78L4 6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7.345 3.147A2 2 0 0 1 9.154 2h5.692a2 2 0 0 1 1.81 1.147L18 6H6l1.345-2.853z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 6h20"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 11v5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 11v5"
  }));
};
TrashCan.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2z = ["color", "size"];
var Microphone = function Microphone(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "8",
    y: "2",
    width: "8",
    height: "13",
    rx: "4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 16.292A7.98 7.98 0 0 1 12 19a7.98 7.98 0 0 1-6-2.708"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 19v3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 22h4"
  }));
};
Microphone.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2y = ["color", "size"];
var Coffee = function Coffee(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 7c4.418 0 8 .895 8 2s-3.582 2-8 2-8-.895-8-2c0-.357.375-.693 1.033-.984"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 9v9.343c0 1.061.44 2.08 1.409 2.513C5.624 21.399 7.711 22 11 22c3.29 0 5.377-.601 6.591-1.144.968-.433 1.409-1.452 1.409-2.513V9"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 10v0a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3v0"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 3v4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 2v2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 4v3"
  }));
};
Coffee.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2x = ["color", "size"];
var CreditCard = function CreditCard(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2x);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "4",
    width: "20",
    height: "16",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 10.016A2.794 2.794 0 0 0 9.857 9C8.28 9 7 10.343 7 12s1.28 3 2.857 3c.854 0 1.62-.393 2.143-1.016M17 12c0 1.657-1.28 3-2.857 3-1.578 0-2.857-1.343-2.857-3s1.279-3 2.857-3C15.72 9 17 10.343 17 12z"
  }));
};
CreditCard.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2w = ["color", "size"];
var Utensils = function Utensils(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2w);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 8V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5a4 4 0 0 0 4 4h1a4 4 0 0 0 4-4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 16V2h3a4 4 0 0 1 4 4v10h-4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 16v5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 12v9a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-9"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 6V2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 6V2"
  }));
};
Utensils.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2v = ["color", "size"];
var Radish = function Radish(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2v);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 10H8c-2.188 0-3.698 1.415-3.935 3.282-.325 2.56.529 4.105 3.634 5.128 1.394.46 2.579 1.464 3.01 2.868l.223.722.095-.082a8 8 0 0 1 2.175-1.331l1.921-.789c3.286-1.348 5.22-3.408 4.826-6.516C19.712 11.415 18.188 10 16 10z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.964 6.97s-3.075.306-4.685-1.035C5.669 4.593 6.036 2.03 6.036 2.03s3.075-.306 4.686 1.035c1.61 1.342 1.242 3.905 1.242 3.905z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.036 6.97s3.075.306 4.685-1.035c1.61-1.342 1.243-3.905 1.243-3.905s-3.075-.306-4.685 1.035c-1.61 1.342-1.243 3.905-1.243 3.905z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 11.5c-.5 1-3.134 1.5-7 1.5s-6.5-.5-7-1.5"
  }));
};
Radish.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2u = ["color", "size"];
var Clipboard = function Clipboard(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2u);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.5 4H18a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.621 3.515A2 2 0 0 1 10.561 2h2.877a2 2 0 0 1 1.94 1.515L16 6H8l.621-2.485z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 12h6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 16h6"
  }));
};
Clipboard.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2t = ["color", "size"];
var Bicycle = function Bicycle(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2t);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "6",
    cy: "15",
    r: "4"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "18",
    cy: "15",
    r: "4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 15l2-7h7.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 5h3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 15L15 5h4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 5h.5A1.5 1.5 0 0 1 21 6.5v0A1.5 1.5 0 0 1 19.5 8H19"
  }));
};
Bicycle.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2s = ["color", "size"];
var Plane = function Plane(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2s);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 11l-2 4 3.408 1.363a4 4 0 0 1 2.229 2.229L9 22l4-2-1.21-2.42a2 2 0 0 1 .679-2.56L14 14l4 7 3-4-2.29-7.469.715-.714c1.412-1.412 2.71-3.682 1.075-5.317-1.635-1.635-3.91-.34-5.316 1.077l-.72.708L7 3 3 6l7 4-1.02 1.531a2 2 0 0 1-2.56.68L4 11z"
  }));
};
Plane.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2r = ["color", "size"];
var PlaneFill = function PlaneFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2r);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 11l-2 4 3.408 1.363a4 4 0 0 1 2.229 2.229L9 22l4-2-1.21-2.42a2 2 0 0 1 .679-2.56L14 14l4 7 3-4-2.29-7.469.715-.714c1.412-1.412 2.71-3.682 1.075-5.317-1.635-1.635-3.91-.34-5.316 1.077l-.72.708L7 3 3 6l7 4-1.02 1.531a2 2 0 0 1-2.56.68L4 11z"
  }));
};
PlaneFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2q = ["color", "size"];
var Jar = function Jar(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 9l1.164 8.926a3.875 3.875 0 0 0 2.844 3.243v0c3.27.872 6.713.872 9.984 0v0a3.875 3.875 0 0 0 2.844-3.243L21 9"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.035 7.266C3.763 7.661 3 8.165 3 8.714 3 9.977 7.03 11 12 11s9-1.023 9-2.286c0-.55-.764-1.054-2.037-1.448"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 4l-3 .51C4.159 4.874 3 5.407 3 6c0 1.105 4.03 2 9 2s9-.895 9-2c0-.592-1.159-1.125-3-1.49L15 4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 4v0a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v0"
  }));
};
Jar.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2p = ["color", "size"];
var Glasses = function Glasses(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2p);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "6",
    cy: "14",
    r: "4"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "18",
    cy: "14",
    r: "4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 14l.211-.106a4 4 0 0 1 3.578 0L14 14"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 6l2.838 6.623a2 2 0 0 1 .162.788V14"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 6l-2.838 6.623A2 2 0 0 0 2 13.41V14"
  }));
};
Glasses.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2o = ["color", "size"];
var Plant = function Plant(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2o);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.964 6.97s-3.075.306-4.685-1.035C5.669 4.593 6.036 2.03 6.036 2.03s3.075-.306 4.686 1.035c1.61 1.342 1.242 3.905 1.242 3.905z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.036 6.97s3.075.306 4.685-1.035c1.61-1.342 1.243-3.905 1.243-3.905s-3.075-.306-4.685 1.035c-1.61 1.342-1.243 3.905-1.243 3.905z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 11a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 14h14l-2 8H7l-2-8z"
  }));
};
Plant.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2n = ["color", "size"];
var Edit = function Edit(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2n);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.474 5.408l2.118 2.117m-.756-3.982L12.109 9.27a2.118 2.118 0 0 0-.58 1.082L11 13l2.648-.53c.41-.082.786-.283 1.082-.579l5.727-5.727a1.853 1.853 0 1 0-2.621-2.621z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 15v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3"
  }));
};
Edit.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2m = ["color", "size"];
var TrashBin = function TrashBin(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2m);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 4l2.303 14.076a4 4 0 0 0 2.738 3.167l.328.104a12 12 0 0 0 7.262 0l.328-.104a4 4 0 0 0 2.738-3.166L21 4"
  }), /*#__PURE__*/React__default["default"].createElement("ellipse", {
    cx: "12",
    cy: "4",
    rx: "9",
    ry: "2"
  }));
};
TrashBin.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2l = ["color", "size"];
var SunFill = function SunFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2l);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1zM3.293 3.293a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414zm17.414 0a1 1 0 0 1 0 1.414l-1.5 1.5a1 1 0 1 1-1.414-1.414l1.5-1.5a1 1 0 0 1 1.414 0zM1 12a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1zm19 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1zM6.207 17.793a1 1 0 0 1 0 1.414l-1.5 1.5a1 1 0 0 1-1.414-1.414l1.5-1.5a1 1 0 0 1 1.414 0zm11.586 0a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414zM12 20a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1z"
  }));
};
SunFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2k = ["color", "size"];
var MoonFill = function MoonFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2k);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.958 15.325c.204-.486-.379-.9-.868-.684a7.684 7.684 0 0 1-3.101.648c-4.185 0-7.577-3.324-7.577-7.425a7.28 7.28 0 0 1 1.134-3.91c.284-.448-.057-1.068-.577-.936C5.96 4.041 3 7.613 3 11.862 3 16.909 7.175 21 12.326 21c3.9 0 7.24-2.345 8.632-5.675z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.611 3.103c-.53-.354-1.162.278-.809.808l.63.945a2.332 2.332 0 0 1 0 2.588l-.63.945c-.353.53.28 1.162.81.808l.944-.63a2.332 2.332 0 0 1 2.588 0l.945.63c.53.354 1.162-.278.808-.808l-.63-.945a2.332 2.332 0 0 1 0-2.588l.63-.945c.354-.53-.278-1.162-.809-.808l-.944.63a2.332 2.332 0 0 1-2.588 0l-.945-.63z"
  }));
};
MoonFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2j = ["color", "size"];
var KeyCap = function KeyCap(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2j);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 3s3 .5 5 .5 5-.5 5-.5l1 9s-3 1-6 1-6-1-6-1l1-9z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3.869 8.147l-.862 10.294c-.03.366.04.733.205 1.06l.197.393A2.01 2.01 0 0 0 5.206 21h13.588a2.01 2.01 0 0 0 1.797-1.106l.197-.392c.165-.328.236-.695.205-1.06l-.862-10.295a3.99 3.99 0 0 0-.79-2.068L17 3s-3 .5-5 .5S6.978 3 6.978 3l-2.32 3.08a3.99 3.99 0 0 0-.79 2.067z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 12l-2.5 8M18 12l2.5 8"
  }));
};
KeyCap.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2i = ["color", "size"];
var Newspaper = function Newspaper(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2i);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 21h12a4 4 0 0 0 4-4V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v13c0 1.657-.343 3-2 3z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 10a2 2 0 0 1 2-2h2v10.5c0 1.38-.62 2.5-2 2.5s-2-1.12-2-2.5V10z"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "8",
    r: "1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 14h6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 17h3"
  }));
};
Newspaper.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2h = ["color", "size"];
var Door = function Door(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2h);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 2h11a3 3 0 0 1 3 3v14a1 1 0 0 1-1 1h-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 2l7.588 1.518A3 3 0 0 1 15 6.459V20.78a1 1 0 0 1-1.196.98l-7.196-1.438A2 2 0 0 1 5 18.36V2z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 12v2"
  }));
};
Door.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2g = ["color", "size"];
var Water = function Water(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2g);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 22a8 8 0 0 1-8-8c0-3.502 2.71-6.303 5.093-8.87L12 2l2.907 3.13C17.29 7.698 20 10.499 20 14a8 8 0 0 1-8 8z"
  }));
};
Water.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2f = ["color", "size"];
var Fire = function Fire(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2f);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 22c-4.97 0-9-2.582-9-7v-.088C3 12.794 4.338 11.1 6.375 10c1.949-1.052 3.101-2.99 2.813-5l-.563-3 2.086.795c3.757 1.43 6.886 3.912 8.914 7.066A8.495 8.495 0 0 1 21 14.464V15c0 1.562-.504 2.895-1.375 3.965"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 22c-1.657 0-3-1.433-3-3.2 0-1.4 1.016-2.521 1.91-3.548L12 14l1.09 1.252C13.984 16.28 15 17.4 15 18.8c0 1.767-1.343 3.2-3 3.2z"
  }));
};
Fire.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2e = ["color", "size"];
var Air = function Air(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2e);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 8h7a3 3 0 1 0-3-3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 16h11a3 3 0 1 1-3 3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 12h17a3 3 0 1 0-3-3"
  }));
};
Air.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2d = ["color", "size"];
var Home = function Home(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2d);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 19v-6.733a4 4 0 0 0-1.245-2.9L13.378 3.31a2 2 0 0 0-2.755 0L4.245 9.367A4 4 0 0 0 3 12.267V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z"
  }));
};
Home.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2c = ["color", "size"];
var Umbrella = function Umbrella(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2c);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 4c-4.915 0-8.91 3.378-8.999 8.817a.18.18 0 0 0 .182.183.188.188 0 0 0 .17-.11C3.876 11.767 4.782 11.5 6 11.5c1.185 0 1.964.227 2.456 1.302.054.12.172.198.304.198a.366.366 0 0 0 .326-.224C9.56 11.729 10.901 11.5 12 11.5M12 4c4.916 0 8.91 3.378 8.998 8.817a.18.18 0 0 1-.18.183.188.188 0 0 1-.17-.11c-.525-1.123-1.43-1.39-2.648-1.39-1.185 0-1.964.227-2.456 1.302a.336.336 0 0 1-.304.198.366.366 0 0 1-.326-.224C14.44 11.729 13.099 11.5 12 11.5M12 4V2m0 9.5V20a2 2 0 1 1-4 0"
  }));
};
Umbrella.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2b = ["color", "size"];
var TogoCup = function TogoCup(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2b);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 5.4A2.4 2.4 0 0 1 5.4 3h13.2A2.4 2.4 0 0 1 21 5.4v0a.6.6 0 0 1-.6.6H3.6a.6.6 0 0 1-.6-.6v0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 6h14l-1.555 14.218A2 2 0 0 1 15.457 22H8.543a2 2 0 0 1-1.988-1.782L5 6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.313 18l-.875-8h13.125l-.875 8H6.313z"
  }));
};
TogoCup.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2a = ["color", "size"];
var Devices = function Devices(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2a);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 15H4V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 18h12"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 9.2c0-.663.597-1.2 1.333-1.2h5.334C21.403 8 22 8.537 22 9.2v9.6c0 .663-.597 1.2-1.333 1.2h-5.334C14.597 20 14 19.463 14 18.8V9.2z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 17h.01"
  }));
};
Devices.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$29 = ["color", "size"];
var ShippingBoxV1 = function ShippingBoxV1(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$29);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.029 2.54a2 2 0 0 1 1.942 0l7.515 4.174a1 1 0 0 1 .514.874v8.235a2 2 0 0 1-1.029 1.748l-7 3.89a2 2 0 0 1-1.942 0l-7-3.89A2 2 0 0 1 3 15.824V7.588a1 1 0 0 1 .514-.874L11.03 2.54z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 7l9 5m0 0l9-5m-9 5v9.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7.5 9.5l9-5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 12.328L9 14"
  }));
};
ShippingBoxV1.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$28 = ["color", "size"];
var ShippingBoxV2 = function ShippingBoxV2(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$28);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.029 2.54a2 2 0 0 1 1.942 0l7.515 4.174a1 1 0 0 1 .514.874v8.235a2 2 0 0 1-1.029 1.748l-7 3.89a2 2 0 0 1-1.942 0l-7-3.89A2 2 0 0 1 3 15.824V7.588a1 1 0 0 1 .514-.874L11.03 2.54z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7.5 4.5l9 5V13"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 12.328L9 14"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 7l9 5m0 0l9-5m-9 5v9.5"
  }));
};
ShippingBoxV2.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$27 = ["color", "size"];
var Cart = function Cart(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$27);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 7h13.79a2 2 0 0 1 1.99 2.199l-.6 6A2 2 0 0 1 18.19 17H8.64a2 2 0 0 1-1.962-1.608L5 7z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 7l-.81-3.243A1 1 0 0 0 3.22 3H2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 21h2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 21h2"
  }));
};
Cart.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$26 = ["color", "size"];
var Basket = function Basket(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$26);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2.31 11.242A1 1 0 0 1 3.28 10h17.44a1 1 0 0 1 .97 1.242l-1.811 7.243A2 2 0 0 1 17.939 20H6.061a2 2 0 0 1-1.94-1.515L2.31 11.243z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 14v2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 14v2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 10l4-6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 10l-4-6"
  }));
};
Basket.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$25 = ["color", "size"];
var OpenEnvelope = function OpenEnvelope(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$25);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 11.083a4 4 0 0 1 1.706-3.277l6-4.2a4 4 0 0 1 4.588 0l6 4.2A4 4 0 0 1 22 11.083V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7.917z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2.5 9.5l7.001 5.501a4 4 0 0 0 4.998 0L21.5 9.5"
  }));
};
OpenEnvelope.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$24 = ["color", "size"];
var Clock = function Clock(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$24);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 16l-2.414-2.414A2 2 0 0 1 12 12.172V6"
  }));
};
Clock.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$23 = ["color", "size"];
var Truck = function Truck(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$23);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 17h6V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a1 1 0 0 0 1 1h1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 16v-4a4 4 0 0 0-4-4h-2v9h5a1 1 0 0 0 1-1z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 17a3 3 0 1 0 6 0h-6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 14h-2"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "7",
    cy: "17",
    r: "3"
  }));
};
Truck.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$22 = ["color", "size"];
var WineGlass = function WineGlass(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$22);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 13c6 0 8-4.477 8-10H4c0 5.523 2 10 8 10z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 13v7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 8h14"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 22h8l-4-2-4 2z"
  }));
};
WineGlass.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$21 = ["color", "size"];
var VapeKit = function VapeKit(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$21);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 10a1 1 0 0 1 1-1h6v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V10z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13 15a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v6h-8v-6z"
  }), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "15",
    y: "9",
    width: "4",
    height: "3"
  }), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "6",
    y: "4",
    width: "4",
    height: "5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 4V2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 9V6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 17v-5"
  }));
};
VapeKit.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$20 = ["color", "size"];
var Briefcase = function Briefcase(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$20);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "7",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1H9V6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 12l.211.106a4 4 0 0 0 3.578 0L14 12"
  }));
};
Briefcase.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1$ = ["color", "size"];
var Boat = function Boat(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1$);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.926 19.381l-4.302 1.414a2 2 0 0 1-1.248 0L7.074 19.38a4 4 0 0 1-2.623-2.794L3 11l9 1 9-1-1.451 5.587a4 4 0 0 1-2.623 2.794z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.497 7.257A2 2 0 0 1 8.354 6h7.292a2 2 0 0 1 1.857 1.257L19 11l-7 1-7-1 1.497-3.743z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 3v3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 3h2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 12v4"
  }));
};
Boat.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1_ = ["color", "size"];
var Crown = function Crown(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1_);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 8l1.304 1.043a4 4 0 0 0 5.995-1.181L12 3l2.701 4.862a4 4 0 0 0 5.995 1.18L22 8l-1.754 8.77a2.564 2.564 0 0 1-1.367 1.79v0a15.381 15.381 0 0 1-13.758 0v0a2.564 2.564 0 0 1-1.367-1.79L2 8z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 15c2.596 1.333 5.404 1.333 8 0"
  }));
};
Crown.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1Z = ["color", "size"];
var Sword = function Sword(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1Z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 3l4-1-1 4-10 10-2.5-.5L8 13 18 3z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 20l2 2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 14l1 4 4 1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 18l-3 3"
  }));
};
Sword.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1Y = ["color", "size"];
var DoubleSword = function DoubleSword(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1Y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 19.2L3.8 21m.9-7.2l.9 3.6m0 0l3.6.9m-3.6-.9l-2.7 2.7M16.4 3.9l-9 9 .45 2.25 2.25.45 9-9L20 3l-3.6.9z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 19.2L20.2 21m-.9-7.2l-.9 3.6m0 0l2.7 2.7m-2.7-2.7l-1.8.45-1.8.45M9.3 11L4.9 6.6 4 3l3.6.9L12 8.3m.1 5.5l1.8 1.8 2.25-.45.45-2.25-1.8-1.8"
  }));
};
DoubleSword.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1X = ["color", "size"];
var Key = function Key(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1X);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 18l2-2h2l1.36-1.36a6.5 6.5 0 1 0-3.997-3.992L2 18v4h4l2-2v-2z"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "17",
    cy: "7",
    r: "1"
  }));
};
Key.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1W = ["color", "size"];
var Dental = function Dental(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1W);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 4.363C9 2.732 3 1.23 3 8.277c0 5.492 1.188 9.756 3.005 12.141.645.847 2.216.584 2.888-.265a1.22 1.22 0 0 0 .174-.328l1.063-2.8c.654-1.72 3.086-1.72 3.74 0l1.063 2.8c.045.116.097.23.174.328.672.85 2.243 1.112 2.888.265C19.812 18.033 21 13.77 21 8.277c0-7.046-6-5.545-9-3.914zm0 0L15 6"
  }));
};
Dental.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1V = ["color", "size"];
var Cake = function Cake(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1V);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 13a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 13l2.914 2.331c1.187.95 2.9.855 3.975-.22v0a2.985 2.985 0 0 1 4.222 0v0a2.985 2.985 0 0 0 3.975.22L21 13"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 6a2 2 0 0 1-2-2c0-.876.677-1.576 1.273-2.217L12 1l.727.783C13.323 2.424 14 3.124 14 4a2 2 0 0 1-2 2z"
  }));
};
Cake.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1U = ["color", "size"];
var BookClose = function BookClose(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1U);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 4.222v15.556C4 21.005 5.023 22 6.286 22h11.428C18.977 22 20 21.005 20 19.778V8.444a2 2 0 0 0-2-2H6.286C5.023 6.444 4 5.45 4 4.222zm0 0C4 2.995 5.023 2 6.286 2h9.143c1.262 0 2.285.995 2.285 2.222v2.222"
  }));
};
BookClose.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1T = ["color", "size"];
var Sparkles = function Sparkles(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1T);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 2l.19.94a4 4 0 0 0 2.57 2.974L8 6l-.24.086A4 4 0 0 0 5.19 9.06L5 10l-.19-.94a4 4 0 0 0-2.57-2.974L2 6l.24-.086A4 4 0 0 0 4.81 2.94L5 2z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 16l.23 1.276a2 2 0 0 0 1.219 1.501L10 19l-.551.223a2 2 0 0 0-1.22 1.5L8 22l-.23-1.276a2 2 0 0 0-1.219-1.501L6 19l.551-.223a2 2 0 0 0 1.22-1.5L8 16z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 3l.556 2.654a8 8 0 0 0 5.213 5.92L23 12l-1.231.426a8 8 0 0 0-5.213 5.92L16 21l-.556-2.654a8 8 0 0 0-5.213-5.92L9 12l1.231-.426a8 8 0 0 0 5.213-5.92L16 3z"
  }));
};
Sparkles.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1S = ["color", "size"];
var Music = function Music(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1S);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 18V5.716a2 2 0 0 1 1.696-1.977l9-1.385A2 2 0 0 1 21 4.331V16"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 9l13-2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 18a3 3 0 1 1-6 0c0-1.657 1.343-2 3-2s3 .343 3 2z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 16a3 3 0 1 1-6 0c0-1.657 1.343-2 3-2s3 .343 3 2z"
  }));
};
Music.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1R = ["color", "size"];
var MusicNote = function MusicNote(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1R);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 4v14"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 7.674v-.657a4 4 0 0 0-2.901-3.846l-2.824-.807A1 1 0 0 0 12 3.326V7l5.725 1.636A1 1 0 0 0 19 7.674z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 18a3 3 0 1 1-6 0c0-1.657 1.343-2 3-2s3 .343 3 2z"
  }));
};
MusicNote.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1Q = ["color", "size"];
var MusicAlbum = function MusicAlbum(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1Q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 16.5V8.78a1 1 0 0 1 .757-.97l6-1.5A1 1 0 0 1 17 7.28V15"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 11l8-2"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "7.5",
    cy: "16.5",
    r: "1.5"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "15.5",
    cy: "15.5",
    r: "1.5"
  }));
};
MusicAlbum.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1P = ["color", "size"];
var MusicAlbumFill = function MusicAlbumFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1P);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5c0-2.21 1.792-4 4.002-4h13.996C21.208 1 23 2.79 23 5v14a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V5zm19 7a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-8 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  }));
};
MusicAlbumFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1O = ["color", "size"];
var Dice6 = function Dice6(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1O);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 8h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.25 7.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.25 11.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.25 15.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.5 8h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.75 7.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.75 11.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.75 15.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 12h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.5 12h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 16h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.5 16h.5"
  }));
};
Dice6.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1N = ["color", "size"];
var Dice5 = function Dice5(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1N);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 8h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.5 8h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 12h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.25 11.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 16h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.5 16h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.25 7.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.25 15.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.75 7.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.75 15.75v.5"
  }));
};
Dice5.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1M = ["color", "size"];
var Bank = function Bank(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1M);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 11V8l-8-5-8 5v3h16z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3 21h18"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5 20v-5h2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 20v-5h2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 20v-5h2"
  }));
};
Bank.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1L = ["color", "size"];
var PaperAirplane = function PaperAirplane(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1L);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.474 16l9.181 3.284a1.1 1.1 0 0 0 1.462-.887L21.99 4.239c.114-.862-.779-1.505-1.567-1.13L2.624 11.605c-.88.42-.814 1.69.106 2.017l2.44.868 1.33.467M13 17.26l-1.99 3.326c-.65.808-1.959.351-1.959-.683V17.24a2 2 0 0 1 .53-1.356l3.871-4.2"
  }));
};
PaperAirplane.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1K = ["color", "size"];
var HomeAlt1 = function HomeAlt1(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1K);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 19v-6.733a4 4 0 0 0-1.245-2.9L13.378 3.31a2 2 0 0 0-2.755 0L4.245 9.367A4 4 0 0 0 3 12.267V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 15a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6H9v-6z"
  }));
};
HomeAlt1.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1J = ["color", "size"];
var CreditCardAlt1 = function CreditCardAlt1(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1J);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "4",
    width: "20",
    height: "16",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "6",
    y: "8",
    width: "2",
    height: "2"
  }));
};
CreditCardAlt1.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1I = ["color", "size"];
var Receipt = function Receipt(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1I);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 21H7a4 4 0 0 1-4-4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v13c0 1.657.343 3 2 3z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 10a2 2 0 0 0-2-2h-2v10.5c0 1.38.62 2.5 2 2.5s2-1.12 2-2.5V10z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13 11H7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13 7H7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 15H7"
  }));
};
Receipt.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1H = ["color", "size"];
var Hammer = function Hammer(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1H);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 22l-2-2 1-1 2 2-1 1z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 13l2 2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 12l-8 8"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 4l-1 1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.707 7.707a1 1 0 0 1 0-1.414l4.086-4.086a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 0 1.414l-4.086 4.086a1 1 0 0 1-1.414 0L9.707 7.707z"
  }));
};
Hammer.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1G = ["color", "size"];
var Data = function Data(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1G);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("ellipse", {
    cx: "12",
    cy: "6",
    rx: "8",
    ry: "3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.037 12C4.77 12.53 4 13.232 4 14c0 1.657 3.582 3 8 3s8-1.343 8-3c0-.768-.77-1.47-2.037-2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 6v4c0 1.657 3.582 3 8 3s8-1.343 8-3V6"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 14v4c0 1.657 3.582 3 8 3s8-1.343 8-3v-4"
  }));
};
Data.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1F = ["color", "size"];
var Dice4 = function Dice4(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1F);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 8h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.5 8h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 16h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.5 16h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.25 7.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.25 15.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.75 7.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.75 15.75v.5"
  }));
};
Dice4.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1E = ["color", "size"];
var Dice3 = function Dice3(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1E);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.25 11.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.25 7.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.75 15.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 8h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 12h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.5 16h.5"
  }));
};
Dice3.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1D = ["color", "size"];
var Dice2 = function Dice2(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1D);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.25 7.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.75 15.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 8h.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.5 16h.5"
  }));
};
Dice2.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1C = ["color", "size"];
var Dice1 = function Dice1(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1C);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.25 11.75v.5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 12h.5"
  }));
};
Dice1.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1B = ["color", "size"];
var PriceCut = function PriceCut(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1B);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2 7v8a2 2 0 0 0 2 2h1M2 7V5a2 2 0 0 1 2-2h2M2 7a4 4 0 0 0 4-4m0 0h13m-9.236 9A3 3 0 0 1 14 7.764M2 20L20 2m1.22 16.047l.549-6.261c.075-.865-.598-1.63-1.504-1.71l-.82-.071m1.776 8.042l-.137 1.566c-.076.864-.872 1.501-1.778 1.422l-1.64-.144m3.555-2.844c-1.813-.158-3.405 1.115-3.556 2.844m0 0L7 19.958m4.347-3.477c.409.52.94.785 1.67.849 1.359.119 2.553-.836 2.666-2.133.061-.696-.085-1.269-.551-1.743"
  }));
};
PriceCut.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1A = ["color", "size"];
var Person = function Person(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1A);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "7",
    r: "5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 14h.352a3 3 0 0 1 2.976 2.628l.391 3.124A2 2 0 0 1 18.734 22H5.266a2 2 0 0 1-1.985-2.248l.39-3.124A3 3 0 0 1 6.649 14H7"
  }));
};
Person.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1z = ["color", "size"];
var PersonAdd = function PersonAdd(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "7",
    r: "5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 22H5.266a2 2 0 0 1-1.985-2.248l.39-3.124A3 3 0 0 1 6.649 14H7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 14v4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 16h4"
  }));
};
PersonAdd.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1y = ["color", "size"];
var PersonCheck = function PersonCheck(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "7",
    r: "5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 22H5.266a2 2 0 0 1-1.985-2.248l.39-3.124A3 3 0 0 1 6.649 14H7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 16.5l1.5 1.5 2.5-3"
  }));
};
PersonCheck.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1x = ["color", "size"];
var PersonCross = function PersonCross(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1x);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "7",
    r: "5"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 22H5.266a2 2 0 0 1-1.985-2.248l.39-3.124A3 3 0 0 1 6.649 14H7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 18l-3-3m3 0l-3 3"
  }));
};
PersonCross.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1w = ["color", "size"];
var FaceVeryHappy = function FaceVeryHappy(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1w);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 9.05v-.1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 9.05v-.1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 18a4 4 0 0 0 4-4H8a4 4 0 0 0 4 4z"
  }));
};
FaceVeryHappy.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1v = ["color", "size"];
var FaceHappy = function FaceHappy(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1v);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 9.05v-.1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 9.05v-.1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 14c-.5 1.5-1.79 3-4 3s-3.5-1.5-4-3"
  }));
};
FaceHappy.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1u = ["color", "size"];
var FaceNeutral = function FaceNeutral(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1u);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 9.05v-.1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 9.05v-.1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 14h8"
  }));
};
FaceNeutral.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1t = ["color", "size"];
var FaceSad = function FaceSad(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1t);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 9.05v-.1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 9.05v-.1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 16c-.5-1.5-1.79-3-4-3s-3.5 1.5-4 3"
  }));
};
FaceSad.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1s = ["color", "size"];
var FaceVerySad = function FaceVerySad(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1s);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 9.05v-.1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 9.05v-.1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 13a4 4 0 0 1 4 4H8a4 4 0 0 1 4-4z"
  }));
};
FaceVerySad.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1r = ["color", "size"];
var FaceWink = function FaceWink(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1r);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 9h2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 9.05v-.1"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 15c-.5 1-1.79 2-4 2s-3.5-1-4-2"
  }));
};
FaceWink.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1q = ["color", "size"];
var ThumbsUp = function ThumbsUp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.605 5.782l.23-2.369c.091-.952.98-1.598 1.878-1.366 1.351.35 2.3 1.605 2.3 3.044v3.035c0 .675 0 1.013.146 1.26.083.141.197.26.333.345.24.151.567.151 1.22.151h.396c1.703 0 2.554 0 3.078.39.393.293.67.722.78 1.208.146.65-.181 1.463-.836 3.087l-.326.81a3.261 3.261 0 0 0-.226 1.48c.232 2.874-2.047 5.295-4.833 5.136l-10.424-.599c-1.139-.065-1.708-.098-2.222-.553-.515-.455-.612-.924-.805-1.861a14.324 14.324 0 0 1 .055-6.037c.283-1.248 1.475-1.92 2.706-1.76 3.264.42 6.223-2.019 6.55-5.4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7 11.5l-.137.457A14.983 14.983 0 0 0 7 21"
  }));
};
ThumbsUp.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1p = ["color", "size"];
var ThumbsDown = function ThumbsDown(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1p);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.395 18.218l-.23 2.369c-.091.952-.98 1.598-1.878 1.366-1.351-.35-2.3-1.605-2.3-3.044v-3.035c0-.675 0-1.013-.146-1.26a1.018 1.018 0 0 0-.333-.345c-.24-.151-.567-.151-1.22-.151h-.396c-1.703 0-2.554 0-3.078-.39a2.073 2.073 0 0 1-.78-1.208c-.146-.65.181-1.463.836-3.087l.327-.81c.188-.468.265-.975.225-1.48-.232-2.874 2.047-5.295 4.833-5.135l10.424.598c1.139.065 1.708.098 2.222.553.515.455.612.924.805 1.861a14.317 14.317 0 0 1-.055 6.037c-.283 1.248-1.475 1.92-2.706 1.76-3.264-.42-6.223 2.019-6.55 5.4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 12.5l.137-.457c.887-2.956.84-6.115-.137-9.043"
  }));
};
ThumbsDown.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1o = ["color", "size"];
var VictoryHand = function VictoryHand(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1o);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 11l-1-7.272c0-.466.185-.913.515-1.243 1.024-1.024 2.777-.44 2.982.994L16 10l1.508-6.328a1.682 1.682 0 0 1 3.276.73L19 16"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 16c-.536 4-3.358 6-7.5 6C7.358 22 4 20 4 16"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 16v-4a2 2 0 1 1 4 0m4 1v-2a2 2 0 1 0-4 0v4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.692 17H11a2 2 0 1 1 0-4h4c2.21 0 4.5 2 3.5 5"
  }));
};
VictoryHand.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1n = ["color", "size"];
var PointingUp = function PointingUp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1n);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 16l.87-11.735a2.102 2.102 0 0 0-4.181-.433L15 9"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 15v-3a2 2 0 1 0-4 0v4"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 13v-1.5a2 2 0 1 0-4 0V15"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 13v-2a2 2 0 1 0-4 0v2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 16c-.536 4-3.358 6-7.5 6C7.358 22 4 20 4 16"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.692 17H11a2 2 0 1 1 0-4h4c2.21 0 4.5 2 3.5 5"
  }));
};
PointingUp.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1m = ["color", "size"];
var RockOn = function RockOn(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1m);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 16l.87-11.735a2.102 2.102 0 0 0-4.181-.433L15 9"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 11l-.713-4.279a2.06 2.06 0 0 0-4.083.525L4 16"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 13v-1.5a2 2 0 1 0-4 0V15"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 13v-2a2 2 0 1 0-4 0v2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 16c-.536 4-3.358 6-7.5 6C7.358 22 4 20 4 16"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.692 17H11a2 2 0 1 1 0-4h4c2.21 0 4.5 2 3.5 5"
  }));
};
RockOn.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1l = ["color", "size"];
var PeopleMultiple = function PeopleMultiple(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1l);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "7",
    cy: "6",
    r: "3"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 13H5.818a3 3 0 0 0-2.964 2.537L2.36 18.69A2 2 0 0 0 4.337 21H9"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21.64 18.691l-.494-3.154A3 3 0 0 0 18.182 13h-2.364a3 3 0 0 0-2.964 2.537l-.493 3.154A2 2 0 0 0 14.337 21h5.326a2 2 0 0 0 1.976-2.309z"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "17",
    cy: "6",
    r: "3"
  }));
};
PeopleMultiple.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1k = ["color", "size"];
var PeopleGroup = function PeopleGroup(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1k);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.719 19.752l-.64-5.124A3 3 0 0 0 13.101 12h-2.204a3 3 0 0 0-2.976 2.628l-.641 5.124A2 2 0 0 0 9.266 22h5.468a2 2 0 0 0 1.985-2.248z"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "5",
    r: "3"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "4",
    cy: "9",
    r: "2"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "20",
    cy: "9",
    r: "2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 14h-.306a2 2 0 0 0-1.973 1.671l-.333 2A2 2 0 0 0 3.361 20H7"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 14h.306a2 2 0 0 1 1.973 1.671l.333 2A2 2 0 0 1 20.639 20H17"
  }));
};
PeopleGroup.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1j = ["color", "size"];
var Hand = function Hand(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1j);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 16V8.5c0-.828-.641-1.5-1.48-1.5C18 7 17 7.3 17 8.5v-3c0-.828-.641-1.5-1.48-1.5-.507 0-1.52.3-1.52 1.5v-2c0-.828-.641-1.5-1.48-1.5-.84 0-1.52.672-1.52 1.5v2C11 4.3 10.007 4 9.5 4 8.66 4 8 4.691 8 5.52V14"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 5.5V11"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 5.5V11"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 5.5V11"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 16c0 4-3.134 6-7 6s-5.196-1-8.196-6l-1.571-2.605c-.536-.868-.107-1.994.881-2.314a1.657 1.657 0 0 1 1.818.552L8 14.033"
  }));
};
Hand.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1i = ["color", "size"];
var PointerHand = function PointerHand(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1i);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 16V9.5c0-.828-.641-1.5-1.48-1.5C18 8 17 8.3 17 9.5M8 14V5.52"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 16c0 4-3.134 6-7 6s-5.196-1-8.196-6l-1.571-2.605c-.536-.868-.107-1.994.881-2.314a1.657 1.657 0 0 1 1.818.552L8 14.033"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14 11V7.5A1.5 1.5 0 0 1 15.5 6v0A1.5 1.5 0 0 1 17 7.5V11"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 11V6.5A1.5 1.5 0 0 1 12.5 5v0A1.5 1.5 0 0 1 14 6.5V11"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8 11V2.5A1.5 1.5 0 0 1 9.5 1v0A1.5 1.5 0 0 1 11 2.5V11"
  }));
};
PointerHand.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1h = ["color", "size"];
var FacebookFill = function FacebookFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1h);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_65_70)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.067C0 18.033 4.333 22.994 10 24v-8.667H7V12h3V9.333c0-3 1.933-4.666 4.667-4.666.866 0 1.8.133 2.666.266V8H15.8c-1.467 0-1.8.733-1.8 1.667V12h3.2l-.533 3.333H14V24c5.667-1.006 10-5.966 10-11.933C24 5.43 18.6 0 12 0S0 5.43 0 12.067z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_65_70"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
FacebookFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1g = ["color", "size"];
var TwitterFill = function TwitterFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1g);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M23.643 4.937c-.835.37-1.732.62-2.675.733a4.67 4.67 0 0 0 2.048-2.578 9.3 9.3 0 0 1-2.958 1.13 4.66 4.66 0 0 0-7.938 4.25 13.229 13.229 0 0 1-9.602-4.868c-.4.69-.63 1.49-.63 2.342A4.66 4.66 0 0 0 3.96 9.824a4.647 4.647 0 0 1-2.11-.583v.06a4.66 4.66 0 0 0 3.737 4.568 4.692 4.692 0 0 1-2.104.08 4.661 4.661 0 0 0 4.352 3.234 9.348 9.348 0 0 1-5.786 1.995 9.5 9.5 0 0 1-1.112-.065 13.175 13.175 0 0 0 7.14 2.093c8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602a9.47 9.47 0 0 0 2.323-2.41l.002-.003z"
  }));
};
TwitterFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1f = ["color", "size"];
var LinkedinBoxFill = function LinkedinBoxFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1f);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.838A1.838 1.838 0 0 1 2.838 1H21.16A1.837 1.837 0 0 1 23 2.838V21.16A1.838 1.838 0 0 1 21.161 23H2.838A1.838 1.838 0 0 1 1 21.161V2.838zm8.708 6.55h2.979v1.496c.43-.86 1.53-1.634 3.183-1.634 3.169 0 3.92 1.713 3.92 4.856v5.822h-3.207v-5.106c0-1.79-.43-2.8-1.522-2.8-1.515 0-2.145 1.089-2.145 2.8v5.106H9.708V9.388zm-5.5 10.403h3.208V9.25H4.208v10.54zM7.875 5.812a2.063 2.063 0 1 1-4.125 0 2.063 2.063 0 0 1 4.125 0z"
  }));
};
LinkedinBoxFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1e = ["color", "size"];
var DribbbleFill = function DribbbleFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1e);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_67_12)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.375 0 0 5.375 0 12s5.375 12 12 12c6.612 0 12-5.375 12-12S18.612 0 12 0zm7.926 5.531a10.202 10.202 0 0 1 2.317 6.378c-.338-.065-3.722-.755-7.132-.325-.079-.17-.144-.352-.222-.534a30.53 30.53 0 0 0-.676-1.484c3.774-1.536 5.492-3.748 5.713-4.035zM12 1.771c2.603 0 4.985.975 6.794 2.576-.182.26-1.731 2.33-5.375 3.696-1.68-3.084-3.54-5.61-3.827-6A10.424 10.424 0 0 1 12 1.77zm-4.36.962c.273.365 2.095 2.903 3.8 5.922-4.79 1.276-9.02 1.25-9.475 1.25.664-3.176 2.812-5.818 5.675-7.172zm-5.896 9.28v-.312c.443.013 5.414.078 10.53-1.458.299.573.572 1.158.832 1.744-.13.039-.273.078-.403.117-5.284 1.705-8.096 6.364-8.33 6.755a10.226 10.226 0 0 1-2.629-6.846zM12 22.256c-2.369 0-4.555-.807-6.286-2.16.182-.378 2.264-4.387 8.043-6.404.026-.013.04-.013.065-.026 1.445 3.735 2.03 6.872 2.187 7.77-1.237.534-2.59.82-4.009.82zm5.714-1.757c-.104-.625-.651-3.618-1.992-7.302 3.215-.507 6.026.326 6.378.443-.443 2.85-2.083 5.31-4.386 6.859z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_67_12"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
DribbbleFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1d = ["color", "size"];
var RedditFill = function RedditFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1d);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_67_13)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-4.312-.942c.194.277.304.604.316.942a1.751 1.751 0 0 1-.972 1.596c.014.176.014.352 0 .528 0 2.688-3.132 4.872-6.996 4.872-3.864 0-6.996-2.184-6.996-4.872a3.444 3.444 0 0 1 0-.528 1.75 1.75 0 1 1 1.932-2.868 8.568 8.568 0 0 1 4.68-1.476l.888-4.164a.372.372 0 0 1 .444-.288l2.94.588a1.2 1.2 0 1 1-.156.732L13.2 5.58l-.78 3.744a8.544 8.544 0 0 1 4.62 1.476 1.751 1.751 0 0 1 2.648.258zM8.206 12.533a1.2 1.2 0 1 0 1.996 1.334 1.2 1.2 0 0 0-1.996-1.334zm3.806 4.891c1.065.044 2.113-.234 2.964-.876a.335.335 0 1 0-.468-.48A3.936 3.936 0 0 1 12 16.8a3.924 3.924 0 0 1-2.496-.756.324.324 0 0 0-.456.456 4.608 4.608 0 0 0 2.964.924zm2.081-3.178c.198.132.418.25.655.25a1.199 1.199 0 0 0 1.212-1.248 1.2 1.2 0 1 0-1.867.998z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_67_13"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
RedditFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1c = ["color", "size"];
var TumblrFill = function TumblrFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1c);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_66_158)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18.895 22.517c-.798.867-2.646 1.456-4.301 1.483h-.182c-5.557 0-6.766-4.164-6.766-6.594v-6.748H5.458a.454.454 0 0 1-.324-.137.472.472 0 0 1-.134-.33V7.003c0-.164.05-.324.142-.458a.782.782 0 0 1 .376-.29c2.855-1.026 3.748-3.562 3.87-5.49.035-.516.297-.765.738-.765H13.4a.451.451 0 0 1 .33.134.468.468 0 0 1 .137.333V5.87h3.823c.121 0 .238.05.324.137a.472.472 0 0 1 .134.33v3.83a.472.472 0 0 1-.134.33.454.454 0 0 1-.324.138h-3.84v6.245c0 1.568 1.015 2.001 1.64 2.001a4.537 4.537 0 0 0 1.488-.321.973.973 0 0 1 .595-.106.483.483 0 0 1 .34.37l1.012 3.014c.068.237.14.498-.03.68z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_66_158"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
TumblrFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1b = ["color", "size"];
var PinterestFill = function PinterestFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1b);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_67_11)"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip1_67_11)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M0 12c0 5.123 3.211 9.497 7.73 11.218-.11-.937-.227-2.482.025-3.566.217-.932 1.401-5.938 1.401-5.938s-.357-.715-.357-1.774c0-1.66.962-2.9 2.161-2.9 1.02 0 1.512.765 1.512 1.682 0 1.025-.653 2.557-.99 3.978-.281 1.189.597 2.159 1.769 2.159 2.123 0 3.756-2.239 3.756-5.471 0-2.861-2.056-4.86-4.991-4.86-3.398 0-5.393 2.549-5.393 5.184 0 1.027.395 2.127.889 2.726a.36.36 0 0 1 .083.343c-.091.378-.293 1.189-.332 1.355-.053.218-.173.265-.4.159-1.492-.694-2.424-2.875-2.424-4.627 0-3.769 2.737-7.229 7.892-7.229 4.144 0 7.365 2.953 7.365 6.899 0 4.117-2.595 7.431-6.199 7.431-1.211 0-2.348-.63-2.738-1.373 0 0-.599 2.282-.744 2.84-.282 1.084-1.064 2.456-1.549 3.235C9.584 23.815 10.77 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12z"
  }))), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_67_11"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  })), /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip1_67_11"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
PinterestFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1a = ["color", "size"];
var VkFill = function VkFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1a);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.45 5.948c.166-.546 0-.948-.795-.948H20.03c-.668 0-.976.347-1.143.73 0 0-1.335 3.196-3.226 5.272-.612.602-.89.793-1.224.793-.167 0-.418-.191-.418-.738V5.948c0-.656-.184-.948-.74-.948H9.151c-.417 0-.668.304-.668.593 0 .621.946.765 1.043 2.513v3.798c0 .833-.153.984-.487.984-.89 0-3.055-3.211-4.34-6.885C4.45 5.288 4.198 5 3.527 5H.9c-.75 0-.9.347-.9.73 0 .682.89 4.07 4.145 8.551C6.315 17.341 9.37 19 12.153 19c1.669 0 1.875-.368 1.875-1.003v-2.313c0-.737.158-.884.687-.884.39 0 1.057.192 2.615 1.667C19.11 18.216 19.403 19 20.405 19h2.625c.75 0 1.126-.368.91-1.096-.238-.724-1.088-1.775-2.215-3.022-.612-.71-1.53-1.475-1.809-1.858-.389-.491-.278-.71 0-1.147 0 0 3.2-4.426 3.533-5.929z"
  }));
};
VkFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$19 = ["color", "size"];
var YoutubeFill = function YoutubeFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$19);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_100_7)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M23.5 6.507a2.786 2.786 0 0 0-.766-1.27 3.05 3.05 0 0 0-1.338-.742C19.518 4 11.994 4 11.994 4a76.624 76.624 0 0 0-9.39.47 3.16 3.16 0 0 0-1.338.76c-.37.356-.638.795-.778 1.276A29.09 29.09 0 0 0 0 12c-.012 1.841.151 3.68.488 5.494.137.479.404.916.775 1.269.371.353.833.608 1.341.743 1.903.494 9.39.494 9.39.494a76.8 76.8 0 0 0 9.402-.47 3.05 3.05 0 0 0 1.338-.742c.37-.353.633-.792.765-1.27A28.38 28.38 0 0 0 24 12.023a26.579 26.579 0 0 0-.5-5.517zM9.602 15.424V8.577l6.26 3.424-6.26 3.423z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_100_7"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
YoutubeFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$18 = ["color", "size"];
var InstagramFill = function InstagramFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$18);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.465 1.066C8.638 1.012 9.012 1 12 1c2.988 0 3.362.013 4.534.066 1.172.053 1.972.24 2.672.511.733.277 1.398.71 1.948 1.27.56.549.992 1.213 1.268 1.947.272.7.458 1.5.512 2.67C22.988 8.639 23 9.013 23 12c0 2.988-.013 3.362-.066 4.535-.053 1.17-.24 1.97-.512 2.67a5.396 5.396 0 0 1-1.268 1.949c-.55.56-1.215.992-1.948 1.268-.7.272-1.5.458-2.67.512-1.174.054-1.548.066-4.536.066-2.988 0-3.362-.013-4.535-.066-1.17-.053-1.97-.24-2.67-.512a5.397 5.397 0 0 1-1.949-1.268 5.392 5.392 0 0 1-1.269-1.948c-.271-.7-.457-1.5-.511-2.67C1.012 15.361 1 14.987 1 12c0-2.988.013-3.362.066-4.534.053-1.172.24-1.972.511-2.672a5.396 5.396 0 0 1 1.27-1.948 5.392 5.392 0 0 1 1.947-1.269c.7-.271 1.5-.457 2.67-.511zm8.98 1.98c-1.16-.053-1.508-.064-4.445-.064-2.937 0-3.285.011-4.445.064-1.073.049-1.655.228-2.043.379-.513.2-.88.437-1.265.822a3.412 3.412 0 0 0-.822 1.265c-.151.388-.33.97-.379 2.043-.053 1.16-.064 1.508-.064 4.445 0 2.937.011 3.285.064 4.445.049 1.073.228 1.655.379 2.043.176.477.457.91.822 1.265.355.365.788.646 1.265.822.388.151.97.33 2.043.379 1.16.053 1.507.064 4.445.064 2.938 0 3.285-.011 4.445-.064 1.073-.049 1.655-.228 2.043-.379.513-.2.88-.437 1.265-.822.365-.355.646-.788.822-1.265.151-.388.33-.97.379-2.043.053-1.16.064-1.508.064-4.445 0-2.937-.011-3.285-.064-4.445-.049-1.073-.228-1.655-.379-2.043-.2-.513-.437-.88-.822-1.265a3.413 3.413 0 0 0-1.265-.822c-.388-.151-.97-.33-2.043-.379zm-5.85 12.345a3.669 3.669 0 0 0 4-5.986 3.67 3.67 0 1 0-4 5.986zM8.002 8.002a5.654 5.654 0 1 1 7.996 7.996 5.654 5.654 0 0 1-7.996-7.996zm10.906-.814a1.337 1.337 0 1 0-1.89-1.89 1.337 1.337 0 0 0 1.89 1.89z"
  }));
};
InstagramFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$17 = ["color", "size"];
var FigmaFill = function FigmaFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$17);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_100_5)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.415 0C5.968 0 4 2.053 4 4.568c0 1.529.728 2.887 1.847 3.716A4.613 4.613 0 0 0 4 12c0 1.53.728 2.887 1.847 3.716A4.613 4.613 0 0 0 4 19.432C4 21.947 5.968 24 8.415 24c2.446 0 4.415-2.053 4.415-4.568V15.57a4.307 4.307 0 0 0 2.755.999C18.032 16.568 20 14.515 20 12c0-1.53-.727-2.887-1.847-3.716A4.613 4.613 0 0 0 20 4.568C20 2.053 18.032 0 15.585 0h-7.17zM5.659 4.568c0-1.591 1.242-2.865 2.756-2.865h2.755v5.73H8.415c-1.514 0-2.756-1.275-2.756-2.865zm9.926 2.864H12.83v-5.73h2.755c1.515 0 2.756 1.275 2.756 2.866 0 1.59-1.241 2.864-2.756 2.864zM5.66 12c0-1.59 1.242-2.865 2.756-2.865h2.755v5.73H8.415C6.9 14.865 5.659 13.59 5.659 12zm7.17 0c0-1.59 1.242-2.865 2.756-2.865 1.515 0 2.756 1.274 2.756 2.865 0 1.59-1.241 2.865-2.756 2.865-1.514 0-2.755-1.274-2.755-2.865zm-7.17 7.432c0-1.59 1.242-2.864 2.756-2.864h2.755v2.864c0 1.591-1.24 2.865-2.755 2.865-1.514 0-2.756-1.274-2.756-2.865z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_100_5"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
FigmaFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$16 = ["color", "size"];
var GithubFill = function GithubFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$16);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_100_4)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_100_4"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
GithubFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$15 = ["color", "size"];
var TelegramFill = function TelegramFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$15);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_331_272)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zM12.43 8.859c-1.167.485-3.5 1.49-6.998 3.014-.568.226-.866.447-.893.663-.046.366.412.51 1.034.705.085.027.173.054.263.084.613.199 1.437.432 1.865.441.389.008.823-.152 1.302-.48 3.268-2.207 4.955-3.322 5.061-3.346.075-.017.179-.039.249.024.07.062.063.18.056.212-.046.193-1.84 1.862-2.77 2.726-.29.269-.495.46-.537.504-.094.097-.19.19-.282.279-.57.548-.996.96.024 1.632.49.323.882.59 1.273.856.427.291.853.581 1.405.943.14.092.274.187.405.28.497.355.944.673 1.496.623.32-.03.652-.331.82-1.23.397-2.126 1.179-6.73 1.36-8.628a2.111 2.111 0 0 0-.02-.472.506.506 0 0 0-.172-.325c-.143-.117-.365-.142-.465-.14-.451.008-1.143.249-4.476 1.635z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_331_272"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
TelegramFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$14 = ["color", "size"];
var DropboxFill = function DropboxFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$14);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6 2l6 3.75L6 9.5 0 5.75 6 2zm12 0l6 3.75-6 3.75-6-3.75L18 2zM0 13.25L6 9.5l6 3.75L6 17l-6-3.75zM18 9.5l6 3.75L18 17l-6-3.75 6-3.75zM6 18.25l6-3.75 6 3.75L12 22l-6-3.75z"
  }));
};
DropboxFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$13 = ["color", "size"];
var GoogleFill = function GoogleFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$13);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21.456 10.154c.123.659.19 1.348.19 2.067 0 5.624-3.764 9.623-9.449 9.623A9.841 9.841 0 0 1 2.353 12a9.841 9.841 0 0 1 9.844-9.844c2.658 0 4.879.978 6.583 2.566l-2.775 2.775V7.49c-1.033-.984-2.344-1.489-3.808-1.489-3.248 0-5.888 2.744-5.888 5.993 0 3.248 2.64 5.998 5.888 5.998 2.947 0 4.953-1.685 5.365-3.999h-5.365v-3.839h9.26z"
  }));
};
GoogleFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$12 = ["color", "size"];
var GoogleContainedFill = function GoogleContainedFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$12);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_399_293)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12c6.627 0 12-5.373 12-12S18.627 0 12 0zm.14 19.018c-3.868 0-7-3.14-7-7.018 0-3.878 3.132-7.018 7-7.018 1.89 0 3.47.697 4.682 1.829l-1.974 1.978v-.004c-.735-.702-1.667-1.062-2.708-1.062-2.31 0-4.187 1.956-4.187 4.273 0 2.315 1.877 4.277 4.187 4.277 2.096 0 3.522-1.202 3.816-2.852H12.14v-2.737h6.585c.088.47.135.96.135 1.474 0 4.01-2.677 6.86-6.72 6.86z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_399_293"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
GoogleContainedFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$11 = ["color", "size"];
var AndroidFill = function AndroidFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$11);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17.532 15.106a1.003 1.003 0 1 1 .001-2.007 1.003 1.003 0 0 1 0 2.007zm-11.044 0a1.003 1.003 0 1 1 .001-2.007 1.003 1.003 0 0 1 0 2.007zm11.4-6.018l2.006-3.459a.413.413 0 1 0-.721-.407l-2.027 3.5a12.243 12.243 0 0 0-5.13-1.108c-1.85 0-3.595.398-5.141 1.098l-2.027-3.5a.413.413 0 1 0-.72.407l1.995 3.458C2.696 10.947.345 14.417 0 18.523h24c-.334-4.096-2.675-7.565-6.112-9.435z"
  }));
};
AndroidFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$10 = ["color", "size"];
var BitcoinFill = function BitcoinFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$10);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_399_390)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.385 15.275c1.111-.004 3.54-.013 3.512-1.558-.027-1.58-2.36-1.485-3.497-1.438-.127.005-.24.01-.332.011l.052 2.987c.075-.002.165-.002.265-.002z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.267 10.922c.927-.001 2.95-.003 2.926-1.408-.026-1.437-1.969-1.352-2.918-1.31-.107.005-.2.009-.278.01l.047 2.709.223-.001z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.096 23.641c6.43 1.603 12.942-2.31 14.545-8.738C25.244 8.474 21.33 1.962 14.9.36 8.474-1.244 1.962 2.67.36 9.1c-1.603 6.428 2.31 12.94 8.737 14.542zm4.282-17.02c1.754.124 3.15.638 3.333 2.242.136 1.174-.344 1.889-1.123 2.303 1.3.288 2.125 1.043 1.995 2.771-.161 2.145-1.748 2.748-4.026 2.918l.038 2.25-1.356.025-.039-2.22c-.351.006-.711.01-1.084.008l.04 2.23-1.356.024-.04-2.254-.383.003c-.194.001-.39.002-.586.006l-1.766.03.241-1.624s1.004-.002.986-.017c.384-.008.481-.285.502-.459L8.693 11.3l.097-.002h.046a1.101 1.101 0 0 0-.144-.007l-.044-2.54c-.057-.274-.241-.59-.79-.58.015-.02-.986.017-.986.017L6.846 6.74l1.872-.032v.007c.281-.005.57-.015.863-.026l-.038-2.229 1.356-.023.038 2.184c.362-.013.726-.027 1.083-.033l-.038-2.17 1.357-.024.039 2.229z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_399_390"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
BitcoinFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$$ = ["color", "size"];
var SpotifyFill = function SpotifyFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$$);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_399_388)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.995 0C5.381 0 0 5.382 0 11.996 0 18.616 5.381 24 11.995 24 18.615 24 24 18.615 24 11.996 24 5.382 18.615 0 11.995 0zM5.908 16.404a14.548 14.548 0 0 1 4.238-.638c2.414 0 4.797.612 6.892 1.77.125.068.238.292.29.572.05.28.03.567-.052.716a.61.61 0 0 1-.834.24A13.107 13.107 0 0 0 6.277 18.03a.61.61 0 0 1-.771-.402c-.107-.35.114-1.13.402-1.224zm-.523-4.42a18.154 18.154 0 0 1 4.76-.635c2.894 0 5.767.7 8.31 2.026.179.09.31.244.37.432a.747.747 0 0 1-.052.578c-.227.444-.493.743-.66.743a.769.769 0 0 1-.35-.086 16.33 16.33 0 0 0-7.617-1.854 16.34 16.34 0 0 0-4.366.585.749.749 0 0 1-.92-.525c-.112-.422.145-1.16.525-1.264zM5.25 9.098a.88.88 0 0 1-1.073-.641c-.123-.498.188-1.076.64-1.19a22.365 22.365 0 0 1 5.328-.649c3.45 0 6.756.776 9.824 2.307a.888.888 0 0 1 .4 1.19c-.143.288-.453.598-.795.598a.924.924 0 0 1-.388-.087 20.026 20.026 0 0 0-9.041-2.126c-1.635 0-3.282.201-4.895.598z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_399_388"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
SpotifyFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$_ = ["color", "size"];
var SoundcloudFill = function SoundcloudFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$_);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1.16 16.466c.049 0 .09-.039.098-.093l.27-2.022-.27-2.069c-.007-.054-.05-.093-.099-.093-.05 0-.094.04-.1.093l-.236 2.069.236 2.021c.006.055.05.094.1.094z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M.272 15.697c.048 0 .088-.036.095-.09l.209-1.256-.209-1.28c-.007-.053-.047-.09-.095-.09-.051 0-.09.037-.098.09L0 14.351l.174 1.256c.008.053.047.09.098.09z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2.22 11.897a.122.122 0 0 0-.12-.114.12.12 0 0 0-.119.114l-.224 2.454.224 2.364a.12.12 0 0 0 .12.112.121.121 0 0 0 .12-.113l.254-2.363-.254-2.454z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3.052 16.922a.143.143 0 0 0 .14-.132l.241-2.439-.24-2.522a.143.143 0 0 0-.141-.132.14.14 0 0 0-.14.133l-.213 2.521.212 2.439a.14.14 0 0 0 .141.133z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.01 16.962a.162.162 0 0 0 .162-.152l.226-2.459-.226-2.34a.162.162 0 0 0-.162-.151.16.16 0 0 0-.16.152l-.2 2.34.2 2.458a.16.16 0 0 0 .16.152z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.37 14.352l-.212-3.805a.184.184 0 0 0-.182-.173.183.183 0 0 0-.182.173l-.188 3.805.188 2.458a.183.183 0 0 0 .364 0l.212-2.458z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.951 16.987a.201.201 0 0 0 .201-.192v.002l.199-2.444-.199-4.676a.203.203 0 0 0-.405 0l-.174 4.676.175 2.443a.201.201 0 0 0 .203.19z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.931 9.076a.222.222 0 0 0-.223.212l-.162 5.065.162 2.418a.221.221 0 0 0 .223.211.22.22 0 0 0 .223-.211l.185-2.418-.185-5.065a.22.22 0 0 0-.223-.212z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7.92 16.987a.24.24 0 0 0 .244-.232v.002l.17-2.404-.17-5.235a.24.24 0 0 0-.243-.232.238.238 0 0 0-.243.232l-.153 5.235.153 2.404c.002.129.11.23.243.23z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.918 16.985a.26.26 0 0 0 .263-.252v.002l.157-2.381-.157-5.103a.26.26 0 0 0-.263-.25.26.26 0 0 0-.264.25l-.138 5.103.139 2.38c.003.14.119.25.263.25z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.349 14.354l-.142-4.917a.28.28 0 0 0-.284-.27.28.28 0 0 0-.285.271l-.127 4.916.127 2.366a.28.28 0 0 0 .285.27.28.28 0 0 0 .284-.273v.003l.142-2.366z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.935 16.994c.165 0 .301-.13.304-.29l.129-2.349-.129-5.85a.301.301 0 0 0-.304-.291.303.303 0 0 0-.305.291l-.115 5.848.115 2.352c.003.158.14.289.305.289z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.944 7.664a.322.322 0 0 0-.327.31l-.133 6.382.134 2.315a.32.32 0 0 0 .325.308.32.32 0 0 0 .324-.311v.003l.146-2.315-.146-6.381a.32.32 0 0 0-.323-.311z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.866 16.996l8.181.004C22.678 17 24 15.732 24 14.167c0-1.564-1.322-2.832-2.953-2.832-.404 0-.79.079-1.142.22C19.672 9.003 17.44 7 14.718 7c-.665 0-1.314.126-1.887.339-.223.083-.283.168-.285.333v8.989a.349.349 0 0 0 .32.335z"
  }));
};
SoundcloudFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$Z = ["color", "size"];
var CodepenFill = function CodepenFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$Z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_419_281)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.372.19c.38-.253.875-.253 1.256 0L23.492 7.4c.317.21.508.565.508.946v7.308c0 .38-.19.736-.508.947l-10.864 7.21c-.38.252-.875.252-1.256 0L.508 16.6A1.136 1.136 0 0 1 0 15.654V8.346c0-.38.19-.736.508-.947L11.372.19zm-9.1 10.273v3.058l2.288-1.54-2.288-1.518zm4.337 2.878L3.18 15.648l7.684 5.1v-4.583L6.61 13.341zm6.527 2.824v4.582l7.684-5.1-3.43-2.306-4.254 2.824zm6.303-4.183l2.29 1.54v-3.06l-2.29 1.52zm1.371-3.636l-3.41 2.263-4.264-2.868V3.253l7.674 5.093zm-9.946-5.093V7.74l-4.263 2.868L3.19 8.346l7.674-5.093zM12 9.715l-3.35 2.254L12 14.192l3.35-2.223L12 9.715z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_419_281"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
CodepenFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$Y = ["color", "size"];
var WhatsappFill = function WhatsappFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$Y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_615_275)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.415 14.382c-.298-.149-1.759-.867-2.031-.967-.272-.099-.47-.148-.669.15-.198.296-.767.966-.94 1.164-.174.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.019-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.668-1.612-.916-2.207-.241-.579-.486-.5-.668-.51-.174-.008-.372-.01-.57-.01-.198 0-.52.074-.792.372-.273.297-1.04 1.016-1.04 2.479 0 1.462 1.064 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.57-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.422 7.403h-.004a9.87 9.87 0 0 1-5.032-1.378l-.36-.214-3.742.982.999-3.648-.235-.374a9.861 9.861 0 0 1-1.511-5.26c.002-5.45 4.436-9.884 9.889-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.892 6.993c-.002 5.45-4.436 9.885-9.884 9.885zm8.412-18.297A11.815 11.815 0 0 0 11.992 0C5.438 0 .102 5.335.1 11.892c-.001 2.096.546 4.142 1.587 5.945L0 24l6.304-1.654a11.881 11.881 0 0 0 5.684 1.448h.005c6.554 0 11.89-5.335 11.892-11.893a11.821 11.821 0 0 0-3.48-8.413"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_615_275"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
WhatsappFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$X = ["color", "size"];
var LinkedinFill = function LinkedinFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$X);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.429 8.969h3.714v1.85c.535-1.064 1.907-2.02 3.968-2.02 3.951 0 4.889 2.118 4.889 6.004V22h-4v-6.312c0-2.213-.535-3.461-1.897-3.461-1.889 0-2.674 1.345-2.674 3.46V22h-4V8.969zM2.57 21.83h4V8.799h-4V21.83zM7.143 4.55a2.53 2.53 0 0 1-.753 1.802A2.573 2.573 0 0 1 4.57 7.1a2.59 2.59 0 0 1-1.818-.747A2.548 2.548 0 0 1 2 4.55c0-.677.27-1.325.753-1.803A2.583 2.583 0 0 1 4.571 2c.682 0 1.336.269 1.819.747.482.478.753 1.126.753 1.803z"
  }));
};
LinkedinFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$W = ["color", "size"];
var VimeoFill = function VimeoFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$W);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21.99 7.16c-.092 2.027-1.52 4.8-4.28 8.323C14.857 19.161 12.44 21 10.462 21c-1.225 0-2.26-1.122-3.106-3.359-.564-2.055-1.127-4.11-1.697-6.16-.627-2.237-1.3-3.359-2.025-3.359-.155 0-.707.33-1.645.98L1 7.837c1.035-.906 2.06-1.805 3.066-2.71 1.38-1.185 2.422-1.805 3.112-1.868 1.633-.153 2.64.951 3.02 3.325.408 2.556.69 4.15.851 4.77.472 2.124.99 3.183 1.553 3.183.437 0 1.099-.688 1.979-2.066.88-1.378 1.351-2.425 1.415-3.143.126-1.19-.345-1.782-1.415-1.782-.5 0-1.018.114-1.553.342 1.03-3.353 3.002-4.982 5.913-4.885 2.157.057 3.175 1.446 3.049 4.156z"
  }));
};
VimeoFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$V = ["color", "size"];
var MediumFill = function MediumFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$V);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.372 7.264a.784.784 0 0 0-.252-.658L2.252 4.339V4H8.05l4.482 9.905L16.472 4H22v.339L20.403 5.88a.472.472 0 0 0-.177.452v11.334a.472.472 0 0 0 .177.452l1.56 1.542V20h-7.844v-.339l1.616-1.58c.159-.16.159-.207.159-.451V8.468l-4.492 11.494h-.606L5.566 8.468v7.704c-.043.323.064.65.29.884l2.101 2.568v.338H2v-.338l2.1-2.568a1.03 1.03 0 0 0 .272-.884V7.264z"
  }));
};
MediumFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$U = ["color", "size"];
var ZoomFill = function ZoomFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$U);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_822_311)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zM6 16.2h9V9.6a1.8 1.8 0 0 0-1.8-1.8h-9v6.6A1.8 1.8 0 0 0 6 16.2zm10.2-2.4l3.6 2.4V7.8l-3.6 2.4v3.6z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_822_311"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
ZoomFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$T = ["color", "size"];
var SlackFill = function SlackFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$T);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.066 1a2.2 2.2 0 1 0 .001 4.4h2.2V3.2a2.202 2.202 0 0 0-2.2-2.2zm0 5.867H3.2a2.2 2.2 0 0 0 0 4.4h5.866a2.2 2.2 0 1 0 0-4.4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 9.066a2.2 2.2 0 0 0-4.4 0v2.2h2.2a2.2 2.2 0 0 0 2.2-2.2zm-5.867 0V3.2a2.2 2.2 0 0 0-4.4 0v5.866a2.2 2.2 0 1 0 4.4 0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.933 23a2.2 2.2 0 1 0 0-4.4h-2.2v2.2c-.001 1.213.984 2.198 2.2 2.2zm0-5.868H20.8a2.2 2.2 0 0 0 0-4.4h-5.866a2.2 2.2 0 0 0-.001 4.4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 14.933a2.2 2.2 0 0 0 4.4 0v-2.2H3.2a2.2 2.2 0 0 0-2.2 2.2zm5.867 0v5.866a2.2 2.2 0 0 0 4.4.001v-5.866a2.2 2.2 0 0 0-4.4-.001z"
  }));
};
SlackFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$S = ["color", "size"];
var StackOverflowFill = function StackOverflowFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$S);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18.372 20.222v-5.358h1.79V22H4v-7.136h1.79v5.358h12.582z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7.768 14.356l8.79 1.824.372-1.755L8.14 12.6l-.372 1.756zm1.162-4.157l8.14 3.764.744-1.617-8.14-3.787-.744 1.64zm2.256-3.973l6.907 5.705 1.14-1.363-6.907-5.704-1.14 1.362zM15.651 2L14.21 3.062l5.35 7.16L21 9.159 15.651 2zm-8.07 16.42h8.977v-1.778H7.581v1.778z"
  }));
};
StackOverflowFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$R = ["color", "size"];
var TwitchFill = function TwitchFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$R);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.547 1L1 4.776v15.433h5.5V23h3.093l2.922-2.791h4.47L23 14.462V1H2.547zm18.39 12.478l-3.438 3.283H12l-2.922 2.791v-2.79h-4.64V2.97h16.499v10.508zm-3.438-6.731v5.74h-2.062v-5.74H17.5zm-5.499 0v5.74H9.938v-5.74H12z"
  }));
};
TwitchFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$Q = ["color", "size"];
var SnapchatFill = function SnapchatFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$Q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_822_337)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.829 4.533c-.6 1.344-.363 3.752-.267 5.436-.648.359-1.48-.271-1.951-.271-.49 0-1.075.322-1.167.802-.066.346.089.85 1.201 1.289.43.17 1.453.37 1.69.928.333.784-1.71 4.403-4.918 4.931a.498.498 0 0 0-.416.519c.056.975 2.242 1.357 3.211 1.507.099.134.179.7.306 1.131.057.193.204.424.582.424.493 0 1.312-.38 2.738-.144 1.398.233 2.712 2.215 5.235 2.215 2.345 0 3.744-1.991 5.09-2.215.779-.129 1.448-.088 2.196.058.515.101.977.157 1.124-.349.129-.437.208-.992.305-1.123.96-.149 3.156-.53 3.211-1.505a.498.498 0 0 0-.416-.519c-3.154-.52-5.259-4.128-4.918-4.931.236-.557 1.252-.755 1.69-.928.814-.321 1.222-.716 1.213-1.173-.011-.585-.715-.934-1.233-.934-.527 0-1.284.624-1.897.286.096-1.698.332-4.095-.267-5.438C17.036 1.986 14.511.7 11.987.7 9.479.7 6.973 1.968 5.829 4.533z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_822_337"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
SnapchatFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$P = ["color", "size"];
var OctocatFill = function OctocatFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$P);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.422 20.081c0 .896.01 1.753.016 2.285a.617.617 0 0 0 .422.58c2.078.686 4.317.718 6.414.091l.292-.087a.67.67 0 0 0 .478-.638c.005-.733.017-2.017.017-3.53 0-1.372-.477-2.25-1.031-2.707 3.399-.366 6.97-1.61 6.97-7.227 0-1.61-.592-2.91-1.566-3.934.153-.366.688-1.866-.153-3.878 0 0-1.28-.403-4.201 1.5a14.76 14.76 0 0 0-3.82-.494c-1.298 0-2.597.165-3.819.494C5.52.65 4.24 1.036 4.24 1.036c-.84 2.012-.306 3.512-.153 3.878a5.565 5.565 0 0 0-1.566 3.934c0 5.598 3.552 6.86 6.951 7.227-.439.366-.84 1.006-.973 1.957-.879.384-3.075 1.006-4.45-1.207-.286-.44-1.146-1.519-2.349-1.5-1.28.018-.516.695.02.97.648.347 1.393 1.646 1.565 2.067.306.823 1.299 2.396 5.137 1.72z"
  }));
};
OctocatFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$O = ["color", "size"];
var DiscordFill = function DiscordFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$O);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.317 4.492c-1.53-.69-3.17-1.2-4.885-1.49a.075.075 0 0 0-.079.036c-.21.369-.444.85-.608 1.23a18.566 18.566 0 0 0-5.487 0 12.36 12.36 0 0 0-.617-1.23A.077.077 0 0 0 8.562 3c-1.714.29-3.354.8-4.885 1.491a.07.07 0 0 0-.032.027C.533 9.093-.32 13.555.099 17.961a.08.08 0 0 0 .031.055 20.03 20.03 0 0 0 5.993 2.98.078.078 0 0 0 .084-.026c.462-.62.874-1.275 1.226-1.963.021-.04.001-.088-.041-.104a13.201 13.201 0 0 1-1.872-.878.075.075 0 0 1-.008-.125c.126-.093.252-.19.372-.287a.075.075 0 0 1 .078-.01c3.927 1.764 8.18 1.764 12.061 0a.075.075 0 0 1 .079.009c.12.098.245.195.372.288a.075.075 0 0 1-.006.125c-.598.344-1.22.635-1.873.877a.075.075 0 0 0-.041.105c.36.687.772 1.341 1.225 1.962a.077.077 0 0 0 .084.028 19.963 19.963 0 0 0 6.002-2.981.076.076 0 0 0 .032-.054c.5-5.094-.838-9.52-3.549-13.442a.06.06 0 0 0-.031-.028zM8.02 15.278c-1.182 0-2.157-1.069-2.157-2.38 0-1.312.956-2.38 2.157-2.38 1.21 0 2.176 1.077 2.157 2.38 0 1.312-.956 2.38-2.157 2.38zm7.975 0c-1.183 0-2.157-1.069-2.157-2.38 0-1.312.955-2.38 2.157-2.38 1.21 0 2.176 1.077 2.157 2.38 0 1.312-.946 2.38-2.157 2.38z"
  }));
};
DiscordFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$N = ["color", "size"];
var BehanceFill = function BehanceFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$N);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_1599_271)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 7h-7V5h7v2zm1.726 10c-.442 1.297-2.029 3-5.101 3-3.074 0-5.564-1.729-5.564-5.675 0-3.91 2.325-5.92 5.466-5.92 3.082 0 4.964 1.782 5.375 4.426.078.506.109 1.188.095 2.14H15.97c.13 3.211 3.483 3.312 4.588 2.029h3.168zm-7.686-4h4.965c-.105-1.547-1.136-2.219-2.477-2.219-1.466 0-2.277.768-2.488 2.219zm-9.574 6.988H0V5.021h6.953c5.476.081 5.58 5.444 2.72 6.906 3.461 1.26 3.577 8.061-3.207 8.061zM3 11h3.584c2.508 0 2.906-3-.312-3H3v3zm3.391 3H3v3.016h3.341c3.055 0 2.868-3.016.05-3.016z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_1599_271"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
BehanceFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$M = ["color", "size"];
var PostgresqlFill = function PostgresqlFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$M);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.805 1a9.85 9.85 0 0 0-2.603.37l-.06.018a10.629 10.629 0 0 0-1.615-.151c-1.113-.019-2.07.243-2.84.68-.76-.256-2.336-.697-3.997-.609-1.157.061-2.419.402-3.354 1.36-.933.958-1.426 2.44-1.322 4.457.028.557.191 1.464.463 2.64.27 1.175.652 2.55 1.127 3.805.475 1.256.996 2.384 1.81 3.15.406.384.965.707 1.624.68.463-.018.882-.215 1.243-.506.176.225.364.323.535.414.215.114.425.192.642.244.39.094 1.059.22 1.84.091.267-.043.548-.127.828-.247.01.302.022.598.035.898.038.95.063 1.827.357 2.596.047.126.176.773.687 1.344.51.572 1.51.928 2.648.692.803-.167 1.825-.468 2.503-1.404.67-.926.973-2.255 1.033-4.409.015-.116.033-.215.052-.308l.16.014h.018c.857.038 1.787-.08 2.564-.43.688-.31 1.208-.622 1.587-1.177.095-.137.199-.303.227-.59.028-.285-.14-.733-.421-.939-.563-.414-.916-.257-1.295-.18-.373.08-.753.124-1.136.133 1.093-1.784 1.876-3.68 2.323-5.358.264-.99.413-1.903.425-2.701.012-.798-.055-1.505-.548-2.117-1.541-1.91-3.708-2.438-5.384-2.456-.052-.001-.104-.002-.156-.001V1zm-.044.587c1.585-.015 3.611.417 5.065 2.22.327.405.424.997.413 1.727-.012.729-.151 1.601-.405 2.557-.493 1.852-1.425 4.01-2.738 5.948a.724.724 0 0 0 .15.079c.274.11.898.204 2.145-.044.313-.065.543-.108.781.068a.478.478 0 0 1 .173.39.635.635 0 0 1-.123.308c-.24.351-.716.684-1.326.958-.539.244-1.313.371-1.999.379-.344.003-.661-.023-.93-.104l-.018-.006c-.104.971-.343 2.89-.498 3.765-.125.706-.343 1.267-.76 1.687-.416.42-1.004.673-1.796.838-.981.204-1.696-.016-2.157-.393-.46-.375-.671-.874-.798-1.18-.087-.21-.132-.483-.176-.848a18.073 18.073 0 0 1-.097-1.315 45.725 45.725 0 0 1-.028-2.313c-.41.364-.92.606-1.467.697-.65.107-1.232.002-1.579-.082a2.19 2.19 0 0 1-.49-.185c-.162-.083-.315-.177-.417-.363a.5.5 0 0 1-.054-.35.559.559 0 0 1 .206-.303c.188-.148.435-.23.808-.306.68-.135.917-.228 1.061-.339.123-.095.262-.287.508-.57a1.166 1.166 0 0 1-.003-.037 2.864 2.864 0 0 1-1.257-.329c-.141.145-.865.888-1.748 1.918-.371.431-.781.678-1.214.696-.433.018-.824-.194-1.156-.506-.665-.626-1.195-1.703-1.657-2.92-.46-1.218-.836-2.574-1.102-3.729-.268-1.155-.426-2.086-.448-2.535-.1-1.909.36-3.195 1.15-4.006.79-.811 1.872-1.118 2.928-1.177 1.894-.106 3.693.535 4.057.673.701-.462 1.604-.75 2.733-.732a7.185 7.185 0 0 1 1.588.2l.019-.008c.229-.078.462-.144.698-.196a9.362 9.362 0 0 1 1.957-.23v-.002zm.143.614h-.137a8.502 8.502 0 0 0-1.61.176 7.048 7.048 0 0 1 2.692 2.062c.435.539.795 1.13 1.07 1.76.104.242.174.447.213.605.02.08.034.147.038.217a.392.392 0 0 1-.011.132l-.006.012c.029.803-.176 1.347-.201 2.113-.019.556.127 1.209.163 1.92.034.67-.049 1.405-.497 2.127.038.044.072.088.108.132 1.185-1.81 2.04-3.814 2.495-5.521.243-.92.373-1.753.384-2.413.01-.66-.117-1.139-.279-1.338-1.268-1.573-2.983-1.974-4.422-1.985zm-4.525.235c-1.117.002-1.919.33-2.526.82-.627.507-1.047 1.2-1.323 1.911a7.898 7.898 0 0 0-.485 2.213l.013-.007c.337-.184.78-.367 1.254-.473.475-.106.986-.139 1.449.035.463.175.846.584.985 1.206.665 2.986-.207 4.096-.529 4.933a8.628 8.628 0 0 0-.313.929c.041-.01.082-.02.122-.024a1.06 1.06 0 0 1 .51.1c.324.13.546.402.666.714.031.082.054.17.067.26.014.038.02.077.019.117a49.059 49.059 0 0 0 .012 3.426c.022.494.054.928.095 1.271.04.342.098.602.135.69.12.294.297.678.617.939.32.26.777.434 1.614.26.726-.151 1.174-.36 1.474-.663.298-.301.477-.72.591-1.363.171-.963.515-3.754.556-4.28-.018-.395.042-.7.172-.932.135-.238.343-.384.522-.463.09-.04.174-.066.243-.085a5.487 5.487 0 0 0-.23-.298 4.065 4.065 0 0 1-.629-1.007 7.578 7.578 0 0 0-.243-.443c-.125-.22-.284-.495-.45-.804-.333-.619-.695-1.369-.883-2.1-.187-.729-.215-1.484.265-2.017.426-.473 1.172-.669 2.293-.559-.033-.096-.053-.176-.109-.304a7.125 7.125 0 0 0-.983-1.617c-.95-1.178-2.487-2.346-4.863-2.384h-.108v-.001zm-6.276.047c-.12 0-.24.004-.36.01-.954.053-1.856.322-2.501.986-.647.663-1.072 1.751-.98 3.553.019.34.172 1.296.434 2.43.262 1.136.634 2.471 1.08 3.65.446 1.18.988 2.207 1.502 2.693.259.243.484.341.688.333.205-.01.451-.124.753-.475a40.03 40.03 0 0 1 1.71-1.877 3.206 3.206 0 0 1-.932-1.307 3.116 3.116 0 0 1-.17-1.58c.097-.678.11-1.312.099-1.812-.012-.488-.048-.812-.048-1.015V8.044c-.001-1.056.188-2.103.559-3.095.264-.682.658-1.375 1.249-1.936-.58-.185-1.61-.467-2.725-.52a7.4 7.4 0 0 0-.36-.01h.002zm11.714 4.842c-.641.008-1.001.169-1.19.379-.268.298-.293.82-.127 1.464.165.644.507 1.365.829 1.963.16.3.316.57.442.788.127.22.22.376.276.51.052.122.11.23.168.331.248-.509.293-1.008.267-1.529-.033-.644-.187-1.303-.164-1.97.025-.78.184-1.289.198-1.892a5.639 5.639 0 0 0-.699-.044zm-7.78.105a2.743 2.743 0 0 0-.582.068 4.49 4.49 0 0 0-1.09.412c-.115.06-.226.13-.33.209l-.02.018c.006.134.033.459.045.936.01.523-.002 1.19-.106 1.91-.226 1.568.946 2.866 2.324 2.868.08-.322.213-.648.345-.992.384-1.003 1.139-1.734.503-4.589-.104-.467-.31-.656-.594-.763a1.431 1.431 0 0 0-.495-.077zm7.48.187h.048c.062.002.12.009.17.02a.396.396 0 0 1 .13.051.153.153 0 0 1 .071.1v.008a.215.215 0 0 1-.034.124.614.614 0 0 1-.104.137.646.646 0 0 1-.364.195.57.57 0 0 1-.388-.095.569.569 0 0 1-.123-.108.235.235 0 0 1-.06-.116.151.151 0 0 1 .04-.118.361.361 0 0 1 .111-.082 1.256 1.256 0 0 1 .504-.118v.002zm-7.388.154c.05 0 .103.005.157.012.144.02.273.057.371.112.048.025.09.057.126.097.019.022.033.046.042.073.009.027.012.055.009.083a.274.274 0 0 1-.071.141.608.608 0 0 1-.135.12.619.619 0 0 1-.424.103.694.694 0 0 1-.396-.209.652.652 0 0 1-.112-.15.25.25 0 0 1-.039-.162c.014-.1.099-.15.18-.18a.842.842 0 0 1 .29-.036l.002-.004zm8.56 6.732h-.003c-.139.05-.253.07-.35.11a.423.423 0 0 0-.225.197c-.06.105-.11.292-.095.61a.49.49 0 0 0 .14.064c.161.048.432.08.735.075.602-.007 1.344-.143 1.738-.321.323-.146.623-.336.891-.564-1.317.264-2.06.194-2.517.011a1.247 1.247 0 0 1-.314-.183zm-7.588.086h-.02c-.05.004-.123.02-.263.172-.33.358-.444.582-.716.792-.27.21-.623.321-1.327.461-.223.044-.35.093-.436.132.028.022.025.028.066.049.103.055.236.103.342.13.303.073.8.159 1.319.073.518-.086 1.058-.327 1.518-.953.08-.108.088-.268.023-.44-.067-.17-.211-.318-.313-.36a.632.632 0 0 0-.193-.054v-.002z"
  }));
};
PostgresqlFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$L = ["color", "size"];
var MastodonFill = function MastodonFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$L);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.158 0c-3.068.025-6.02.357-7.74 1.147 0 0-3.41 1.526-3.41 6.733 0 1.192-.024 2.617.014 4.129.123 5.091.933 10.11 5.64 11.355 2.171.575 4.035.695 5.535.613 2.722-.151 4.25-.972 4.25-.972l-.09-1.974s-1.945.613-4.13.538c-2.163-.074-4.448-.233-4.798-2.89a5.448 5.448 0 0 1-.048-.745s2.124.519 4.816.642c1.647.076 3.19-.096 4.759-.283 3.007-.36 5.625-2.212 5.954-3.905.519-2.667.476-6.508.476-6.508 0-5.207-3.411-6.733-3.411-6.733C18.255.357 15.302.025 12.233 0h-.075zM8.686 4.068c1.278 0 2.245.491 2.885 1.474l.622 1.043.623-1.043c.64-.983 1.607-1.474 2.885-1.474 1.105 0 1.995.388 2.675 1.146.658.757.986 1.781.986 3.07v6.303h-2.497V8.47c0-1.29-.543-1.945-1.628-1.945-1.2 0-1.802.777-1.802 2.313v3.349h-2.483v-3.35c0-1.535-.601-2.312-1.802-2.312-1.085 0-1.628.655-1.628 1.945v6.118H5.024V8.283c0-1.288.328-2.312.987-3.07.68-.757 1.57-1.145 2.675-1.145z"
  }));
};
MastodonFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$K = ["color", "size"];
var TiktokFill = function TiktokFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$K);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.321 5.562a5.124 5.124 0 0 1-.443-.258 6.228 6.228 0 0 1-1.137-.966c-.849-.971-1.166-1.956-1.282-2.645h.004c-.097-.573-.057-.943-.05-.943h-3.865v14.943c0 .2 0 .399-.008.595 0 .024-.003.046-.004.073 0 .01 0 .022-.003.033v.009a3.28 3.28 0 0 1-1.65 2.604 3.226 3.226 0 0 1-1.6.422c-1.8 0-3.26-1.468-3.26-3.281 0-1.814 1.46-3.282 3.26-3.282.341 0 .68.054 1.004.16l.005-3.936A7.178 7.178 0 0 0 4.76 10.71a7.583 7.583 0 0 0-1.655 2.04c-.163.281-.779 1.412-.853 3.246-.047 1.04.266 2.12.415 2.565v.01c.093.262.457 1.158 1.049 1.913a7.856 7.856 0 0 0 1.674 1.58v-.01l.009.01c1.87 1.27 3.945 1.187 3.945 1.187.359-.015 1.562 0 2.928-.647 1.515-.718 2.377-1.787 2.377-1.787a7.43 7.43 0 0 0 1.296-2.153c.35-.92.466-2.022.466-2.462V8.273c.047.028.672.441.672.441s.9.577 2.303.952c1.006.267 2.363.324 2.363.324V6.153c-.475.052-1.44-.098-2.429-.59z"
  }));
};
TiktokFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$J = ["color", "size"];
var UnsplashFill = function UnsplashFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$J);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 2h7.5v5.625h-7.5V2zM2 10.75h6.268v5.675h7.517V10.75H22V22H2V10.75z"
  }));
};
UnsplashFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$I = ["color", "size"];
var ProductHuntFill = function ProductHuntFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$I);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_2601_269)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.402 10.2c0 .992-.808 1.8-1.8 1.8H10.2V8.4h3.402c.992 0 1.8.808 1.8 1.8zM24 12c0 6.629-5.371 12-12 12S0 18.629 0 12 5.371 0 12 0s12 5.371 12 12zm-6.198-1.8c0-2.318-1.883-4.2-4.2-4.2H7.8v12h2.4v-3.6h3.402c2.317 0 4.2-1.882 4.2-4.2z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_2601_269"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
ProductHuntFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$H = ["color", "size"];
var YelpFill = function YelpFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$H);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98 11.264l4.701 2.278a1.075 1.075 0 0 1 .6 1.074 1.066 1.066 0 0 1-.81.927L4.393 16.8a1.088 1.088 0 0 1-1.187-.492 1.069 1.069 0 0 1-.146-.429 9.159 9.159 0 0 1 .424-3.996 1.07 1.07 0 0 1 .606-.645 1.085 1.085 0 0 1 .888.026z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.862 20.879l3.5-3.861a1.08 1.08 0 0 1 1.205-.277 1.076 1.076 0 0 1 .673 1.03l-.183 5.195a1.066 1.066 0 0 1-.396.793 1.083 1.083 0 0 1-.861.226 9.401 9.401 0 0 1-3.748-1.506 1.074 1.074 0 0 1-.46-.758 1.065 1.065 0 0 1 .27-.842z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.16 15.74l4.975 1.606a1.08 1.08 0 0 1 .657.596 1.064 1.064 0 0 1-.017.884 9.312 9.312 0 0 1-2.487 3.166 1.082 1.082 0 0 1-1.602-.258l-2.773-4.408a1.065 1.065 0 0 1 .065-1.226 1.078 1.078 0 0 1 1.182-.36z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.219 12.588l-5.029 1.433a1.085 1.085 0 0 1-1.169-.4A1.065 1.065 0 0 1 14 12.393l2.926-4.308a1.075 1.075 0 0 1 .755-.464 1.085 1.085 0 0 1 .85.257 9.222 9.222 0 0 1 2.379 3.25 1.069 1.069 0 0 1-.691 1.46z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.469.468a15.12 15.12 0 0 0-2.585.946 1.077 1.077 0 0 0-.564.65 1.063 1.063 0 0 0 .097.851l4.915 8.456a1.076 1.076 0 0 0 1.212.499 1.066 1.066 0 0 0 .799-1.034V1.072A1.065 1.065 0 0 0 11.622.06a1.084 1.084 0 0 0-.437-.057c-.918.072-1.826.228-2.715.465z"
  }));
};
YelpFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$G = ["color", "size"];
var XFill = function XFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$G);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.808 10.469L20.88 2h-1.676l-6.142 7.353L8.158 2H2.5l7.418 11.12L2.5 22h1.676l6.486-7.765L15.842 22H21.5l-7.693-11.531zm-2.296 2.748l-.752-1.107L4.78 3.3h2.575l4.826 7.11.751 1.107 6.273 9.242h-2.574l-5.12-7.541z"
  }));
};
XFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$F = ["color", "size"];
var ThreadsFill = function ThreadsFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$F);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17.692 11.123a8.547 8.547 0 0 0-.315-.142c-.185-3.414-2.05-5.368-5.182-5.388h-.042c-1.873 0-3.431.8-4.39 2.255l1.722 1.181c.716-1.087 1.84-1.318 2.669-1.318h.028c1.031.006 1.81.306 2.313.89.367.426.612 1.015.733 1.757a13.176 13.176 0 0 0-2.96-.143c-2.977.172-4.892 1.909-4.763 4.322.065 1.223.675 2.277 1.717 2.964.88.582 2.015.866 3.194.802 1.558-.085 2.78-.68 3.632-1.766.647-.825 1.056-1.894 1.237-3.241.742.448 1.292 1.037 1.596 1.745.516 1.205.546 3.184-1.068 4.797-1.415 1.414-3.116 2.025-5.686 2.044-2.851-.02-5.008-.935-6.41-2.717-1.313-1.67-1.991-4.08-2.016-7.165.025-3.085.703-5.496 2.016-7.165 1.402-1.782 3.558-2.696 6.41-2.717 2.871.02 5.065.94 6.521 2.73.714.879 1.252 1.983 1.607 3.27l2.018-.538c-.43-1.585-1.107-2.95-2.027-4.083C18.38 1.2 15.65.024 12.134 0h-.014C8.61.024 5.912 1.205 4.099 3.51c-1.614 2.05-2.446 4.904-2.474 8.482v.016c.028 3.578.86 6.431 2.474 8.482 1.813 2.305 4.511 3.486 8.02 3.51h.015c3.12-.022 5.319-.838 7.13-2.649 2.371-2.368 2.3-5.336 1.518-7.158-.56-1.307-1.629-2.368-3.09-3.07zm-5.387 5.065c-1.305.074-2.66-.512-2.728-1.766-.05-.93.662-1.969 2.808-2.092.246-.015.487-.021.724-.021.78 0 1.508.075 2.171.22-.247 3.088-1.697 3.59-2.975 3.66z"
  }));
};
ThreadsFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$E = ["color", "size"];
var Circle = function Circle(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$E);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }));
};
Circle.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$D = ["color", "size"];
var CircleFill = function CircleFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$D);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "11"
  }));
};
CircleFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$C = ["color", "size"];
var Triangle = function Triangle(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$C);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.293 4.793c.78-1.277 2.634-1.277 3.414 0l7.433 12.164C21.955 18.29 20.996 20 19.434 20H4.566c-1.562 0-2.52-1.71-1.706-3.043l7.433-12.164z"
  }));
};
Triangle.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$B = ["color", "size"];
var TriangleFill = function TriangleFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$B);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.285 3.858c.777-1.294 2.653-1.294 3.43 0l8.468 14.113c.8 1.333-.16 3.029-1.715 3.029H3.532c-1.554 0-2.514-1.696-1.715-3.029l8.468-14.113z"
  }));
};
TriangleFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$A = ["color", "size"];
var Square = function Square(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$A);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2"
  }));
};
Square.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$z = ["color", "size"];
var SquareFill = function SquareFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$z);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "20",
    rx: "2"
  }));
};
SquareFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$y = ["color", "size"];
var Tetragon = function Tetragon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$y);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3.575 13.388a1.962 1.962 0 0 1 0-2.776l7.037-7.037a1.962 1.962 0 0 1 2.776 0l7.037 7.037a1.963 1.963 0 0 1 0 2.776l-7.037 7.037a1.963 1.963 0 0 1-2.776 0l-7.037-7.037z"
  }));
};
Tetragon.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$x = ["color", "size"];
var TetragonFill = function TetragonFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$x);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.61 2.576a1.966 1.966 0 0 1 2.78 0l8.034 8.034a1.966 1.966 0 0 1 0 2.78l-8.034 8.034a1.966 1.966 0 0 1-2.78 0L2.576 13.39a1.966 1.966 0 0 1 0-2.78l8.034-8.034z"
  }));
};
TetragonFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$w = ["color", "size"];
var Pentagon = function Pentagon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$w);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.75 3a2 2 0 0 1 2.5 0l7.63 6.103a2 2 0 0 1 .63 2.246l-3.031 8.334A2 2 0 0 1 16.599 21H7.401a2 2 0 0 1-1.88-1.317l-3.03-8.334a2 2 0 0 1 .63-2.246L10.75 3z"
  }));
};
Pentagon.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$v = ["color", "size"];
var PentagonFill = function PentagonFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$v);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.126 2.219a3 3 0 0 1 3.748 0l7.63 6.104a3 3 0 0 1 .945 3.367l-3.03 8.335A3 3 0 0 1 16.599 22H7.401a3 3 0 0 1-2.82-1.975l-3.03-8.334a3 3 0 0 1 .945-3.368l7.63-6.104z"
  }));
};
PentagonFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$u = ["color", "size"];
var Hexagon = function Hexagon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$u);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.029 2.54a2 2 0 0 1 1.942 0l7 3.888A2 2 0 0 1 21 8.177v7.646a2 2 0 0 1-1.029 1.748l-7 3.89a2 2 0 0 1-1.942 0l-7-3.89A2 2 0 0 1 3 15.824V8.177a2 2 0 0 1 1.029-1.749l7-3.888z"
  }));
};
Hexagon.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$t = ["color", "size"];
var HexagonFill = function HexagonFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$t);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.036 1.53a2 2 0 0 1 1.928 0l8 4.4A2 2 0 0 1 22 7.683v8.634a2 2 0 0 1-1.036 1.753l-8 4.4a2 2 0 0 1-1.928 0l-8-4.4A2 2 0 0 1 2 16.317V7.683A2 2 0 0 1 3.036 5.93l8-4.4z"
  }));
};
HexagonFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$s = ["color", "size"];
var Heptagon = function Heptagon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$s);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.114 2.438a2 2 0 0 1 1.772 0l6.275 3.1a2 2 0 0 1 1.066 1.358l1.569 7.047a2 2 0 0 1-.374 1.662l-4.371 5.623a2 2 0 0 1-1.579.772H8.528a2 2 0 0 1-1.579-.772l-4.371-5.623a2 2 0 0 1-.374-1.662l1.569-7.047a2 2 0 0 1 1.066-1.359l6.275-3.1z"
  }));
};
Heptagon.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$r = ["color", "size"];
var HeptagonFill = function HeptagonFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$r);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.114 1.438a2 2 0 0 1 1.772 0l7.077 3.495a2 2 0 0 1 1.066 1.359l1.767 7.937a2 2 0 0 1-.374 1.662l-4.926 6.337a2 2 0 0 1-1.579.772H8.083a2 2 0 0 1-1.579-.772L1.578 15.89a2 2 0 0 1-.374-1.662l1.767-7.937a2 2 0 0 1 1.066-1.359l7.077-3.495z"
  }));
};
HeptagonFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$q = ["color", "size"];
var Octagon = function Octagon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$q);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.235 2.317a2 2 0 0 1 1.53 0l5.54 2.295a2 2 0 0 1 1.083 1.082l2.295 5.54a2 2 0 0 1 0 1.531l-2.295 5.54a2 2 0 0 1-1.082 1.083l-5.54 2.295a2 2 0 0 1-1.531 0l-5.54-2.295a2 2 0 0 1-1.083-1.082l-2.295-5.54a2 2 0 0 1 0-1.531l2.295-5.54a2 2 0 0 1 1.082-1.083l5.54-2.295z"
  }));
};
Octagon.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$p = ["color", "size"];
var OctagonFill = function OctagonFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$p);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.235 1.317a2 2 0 0 1 1.53 0l6.248 2.588a2 2 0 0 1 1.082 1.082l2.588 6.248a2 2 0 0 1 0 1.53l-2.588 6.248a2 2 0 0 1-1.082 1.082l-6.248 2.588a2 2 0 0 1-1.53 0l-6.248-2.588a2 2 0 0 1-1.082-1.082l-2.588-6.248a2 2 0 0 1 0-1.53l2.588-6.248a2 2 0 0 1 1.082-1.082l6.248-2.588z"
  }));
};
OctagonFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$o = ["color", "size"];
var Oval = function Oval(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$o);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("ellipse", {
    cx: "12",
    cy: "12",
    rx: "8",
    ry: "10"
  }));
};
Oval.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$n = ["color", "size"];
var Parallelogram = function Parallelogram(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$n);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.586 6.45A2 2 0 0 1 7.509 5h11.84a2 2 0 0 1 1.923 2.55l-2.858 10A2 2 0 0 1 16.491 19H4.651a2 2 0 0 1-1.923-2.55l2.858-10z"
  }));
};
Parallelogram.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$m = ["color", "size"];
var Diamond = function Diamond(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$m);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.511 13.542c-.681-.852-.681-2.232 0-3.084l6.256-7.82c.68-.85 1.785-.85 2.466 0l6.256 7.82c.681.852.681 2.232 0 3.084l-6.256 7.82c-.68.85-1.785.85-2.466 0l-6.256-7.82z"
  }));
};
Diamond.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$l = ["color", "size"];
var BootstrapFill = function BootstrapFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$l);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.985 2c-1.37 0-2.383 1.199-2.337 2.498.043 1.25-.013 2.867-.42 4.186-.41 1.322-1.1 2.16-2.228 2.268v1.215c1.128.107 1.819.945 2.227 2.268.408 1.319.464 2.936.42 4.185-.045 1.3.968 2.499 2.338 2.499h14.032c1.37 0 2.383-1.199 2.337-2.499-.043-1.249.013-2.866.42-4.185.409-1.323 1.098-2.16 2.226-2.268v-1.215c-1.128-.108-1.817-.946-2.226-2.268-.407-1.32-.463-2.937-.42-4.186C21.4 3.198 20.386 2 19.017 2H4.985zM16.27 13.769c0 1.79-1.335 2.875-3.55 2.875H8.949a.407.407 0 0 1-.407-.407V6.881a.407.407 0 0 1 .407-.406h3.75c1.847 0 3.06 1 3.06 2.537 0 1.078-.816 2.043-1.855 2.213v.056c1.415.155 2.367 1.135 2.367 2.488zM12.31 7.764h-2.15v3.038h1.811c1.4 0 2.172-.564 2.172-1.572 0-.944-.664-1.466-1.833-1.466zm-2.15 4.243v3.347h2.23c1.457 0 2.23-.585 2.23-1.684 0-1.1-.794-1.663-2.324-1.663h-2.136z"
  }));
};
BootstrapFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$k = ["color", "size"];
var ReactFill = function ReactFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$k);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_642)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M24 11.689c0-1.59-1.991-3.097-5.044-4.031.705-3.111.392-5.587-.988-6.38a2.145 2.145 0 0 0-1.096-.273v1.09c.225 0 .406.045.558.128.665.382.954 1.834.729 3.703-.054.46-.142.944-.25 1.438a23.706 23.706 0 0 0-3.106-.533 23.857 23.857 0 0 0-2.035-2.446c1.595-1.482 3.092-2.294 4.11-2.294V1c-1.346 0-3.107.959-4.888 2.622C10.21 1.97 8.448 1.02 7.103 1.02v1.09c1.013 0 2.515.808 4.11 2.28-.685.72-1.37 1.536-2.021 2.441a22.844 22.844 0 0 0-3.111.538c-.113-.489-.196-.963-.255-1.418-.23-1.87.054-3.322.715-3.708.146-.088.337-.128.562-.128v-1.09c-.41 0-.783.088-1.105.273-1.375.793-1.683 3.263-.974 6.365C1.981 8.603 0 10.104 0 11.689c0 1.59 1.991 3.097 5.044 4.03-.705 3.112-.392 5.588.988 6.38.318.186.69.274 1.1.274 1.346 0 3.107-.959 4.888-2.622 1.78 1.653 3.541 2.602 4.887 2.602a2.18 2.18 0 0 0 1.105-.274c1.375-.792 1.683-3.262.974-6.364C22.019 14.781 24 13.274 24 11.689zm-6.37-3.263a22.023 22.023 0 0 1-.66 1.932 26.444 26.444 0 0 0-1.345-2.319c.695.103 1.365.23 2.006.387zm-2.24 5.21c-.381.66-.773 1.287-1.179 1.869a25.453 25.453 0 0 1-4.412.005 25.457 25.457 0 0 1-2.201-3.806 26.064 26.064 0 0 1 2.192-3.82 25.455 25.455 0 0 1 4.411-.006c.406.582.803 1.204 1.184 1.86.372.64.71 1.29 1.018 1.946a27.41 27.41 0 0 1-1.013 1.952zM16.97 13c.264.655.49 1.311.675 1.947-.64.157-1.316.289-2.015.391A27.044 27.044 0 0 0 16.97 13zm-4.96 5.22c-.455-.47-.91-.993-1.36-1.566.44.02.89.035 1.345.035.46 0 .915-.01 1.36-.035-.44.573-.895 1.096-1.345 1.566zm-3.64-2.882a22.113 22.113 0 0 1-2.006-.386c.181-.631.406-1.282.66-1.932.201.39.412.782.642 1.174.23.391.464.773.704 1.144zm3.615-10.18c.455.47.91.993 1.36 1.566-.44-.02-.89-.035-1.345-.035-.46 0-.915.01-1.36.035.44-.573.895-1.096 1.345-1.566zM8.365 8.04a27.02 27.02 0 0 0-1.34 2.333 20.96 20.96 0 0 1-.675-1.947c.64-.152 1.316-.284 2.015-.386zm-4.427 6.124c-1.732-.738-2.852-1.707-2.852-2.475s1.12-1.742 2.852-2.475c.42-.181.88-.343 1.355-.494.279.958.646 1.956 1.1 2.979a23.165 23.165 0 0 0-1.085 2.964 14.875 14.875 0 0 1-1.37-.499zm2.632 6.99c-.665-.38-.954-1.834-.729-3.702.054-.46.142-.945.25-1.439.958.235 2.005.416 3.106.534a23.87 23.87 0 0 0 2.035 2.446c-1.595 1.482-3.092 2.294-4.11 2.294a1.167 1.167 0 0 1-.552-.132zm11.604-3.727c.23 1.869-.054 3.322-.715 3.708-.146.088-.337.127-.562.127-1.013 0-2.515-.807-4.11-2.28.685-.718 1.37-1.535 2.021-2.44a22.843 22.843 0 0 0 3.111-.538c.113.494.2.968.255 1.423zm1.883-3.263c-.42.181-.88.343-1.355.494a23.482 23.482 0 0 0-1.1-2.979c.45-1.017.811-2.01 1.085-2.964.485.151.944.318 1.375.499 1.732.738 2.852 1.707 2.852 2.475-.005.768-1.125 1.742-2.857 2.475z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.995 13.925a2.236 2.236 0 1 0 0-4.472 2.236 2.236 0 0 0 0 4.472z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_642"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
ReactFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$j = ["color", "size"];
var AngularFill = function AngularFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$j);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.174 12.594h3.652L12 8.095l-1.826 4.499z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 1L2 4.652l1.525 13.541L12 23l8.475-4.807L22 4.652 12 1zm6.24 16.786h-2.33l-1.257-3.212H9.347L8.09 17.786H5.76L12 3.431l6.24 14.355z"
  }));
};
AngularFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$i = ["color", "size"];
var VueFill = function VueFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$i);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.114 2H15l-3 4.9L9.429 2H0l12 21L24 2h-4.886zM3 3.75h2.914L12 14.6l6.086-10.85H21L12 19.5 3 3.75z"
  }));
};
VueFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$h = ["color", "size"];
var JavascriptFill = function JavascriptFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$h);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_640)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h24v24H0V0zm18.347 20.12c-1.113 0-1.742-.58-2.225-1.37l-1.833 1.065c.662 1.308 2.015 2.306 4.11 2.306 2.142 0 3.737-1.112 3.737-3.143 0-1.883-1.082-2.72-2.998-3.543l-.564-.241c-.968-.42-1.387-.693-1.387-1.37 0-.547.42-.966 1.08-.966.647 0 1.064.273 1.451.966l1.756-1.127c-.743-1.307-1.773-1.806-3.207-1.806-2.014 0-3.303 1.288-3.303 2.98 0 1.835 1.08 2.704 2.708 3.397l.564.242c1.029.45 1.642.724 1.642 1.497 0 .646-.597 1.113-1.531 1.113zm-8.74-.015c-.775 0-1.098-.53-1.452-1.16l-1.836 1.112c.532 1.126 1.578 2.06 3.383 2.06 1.999 0 3.368-1.063 3.368-3.398v-7.7h-2.255v7.67c0 1.127-.468 1.416-1.209 1.416z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_640"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
JavascriptFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$g = ["color", "size"];
var NodeFill = function NodeFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$g);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 23.956c-.342 0-.66-.089-.957-.243l-3.029-1.738c-.455-.242-.227-.33-.09-.374.614-.198.728-.242 1.366-.595.068-.044.16-.022.228.022l2.323 1.343c.09.044.205.044.273 0l9.087-5.084c.09-.044.136-.132.136-.242V6.899c0-.11-.045-.198-.136-.242l-9.087-5.061c-.091-.044-.205-.044-.273 0L2.754 6.657c-.091.044-.137.154-.137.242v10.146c0 .088.046.198.137.242l2.482 1.387c1.344.66 2.186-.11 2.186-.88V7.78c0-.132.114-.264.274-.264h1.161c.137 0 .273.11.273.264v10.013c0 1.739-.979 2.751-2.687 2.751-.524 0-.934 0-2.095-.55l-2.391-1.32A1.847 1.847 0 0 1 1 17.067V6.921c0-.66.364-1.276.957-1.606L11.044.23a2.095 2.095 0 0 1 1.912 0l9.088 5.084c.592.33.956.946.956 1.606v10.146c0 .66-.364 1.276-.956 1.607l-9.088 5.083a2.4 2.4 0 0 1-.956.198zm2.801-6.977c-3.985 0-4.805-1.76-4.805-3.257 0-.132.114-.264.273-.264h1.184c.137 0 .25.088.25.22.183 1.166.707 1.738 3.121 1.738 1.913 0 2.733-.418 2.733-1.408 0-.572-.228-.99-3.211-1.276-2.483-.243-4.031-.77-4.031-2.685 0-1.783 1.548-2.84 4.145-2.84 2.915 0 4.35.969 4.532 3.082a.347.347 0 0 1-.069.198c-.045.044-.113.088-.182.088h-1.184a.265.265 0 0 1-.25-.198c-.274-1.21-.98-1.607-2.847-1.607-2.096 0-2.346.704-2.346 1.232 0 .639.296.837 3.12 1.189 2.801.352 4.122.858 4.122 2.75-.023 1.938-1.662 3.038-4.555 3.038z"
  }));
};
NodeFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$f = ["color", "size"];
var HtmlFill = function HtmlFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$f);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_633)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.08 0h1.082v1.069h.99V0h1.082v3.236H7.152V2.153h-.99v1.083H5.081V0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.656 1.073h-.952V0h2.987v1.073h-.953v2.163H9.656V1.073z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.165 0h1.128l.694 1.137L14.68 0h1.128v3.236h-1.077V1.632l-.744 1.151h-.019l-.745-1.15v1.603h-1.058V0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.346 0h1.083v2.167h1.52v1.07h-2.603V0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.046 22.072L3 4.717h18L18.953 22.07 11.99 24l-6.944-1.928zm4.137-9.5l-.194-2.18h8.145l.19-2.128H6.664l.574 6.437h7.377l-.247 2.76-2.374.642h-.002l-2.37-.64-.152-1.697H7.332l.298 3.342 4.36 1.21 4.367-1.21.532-5.964.052-.571H9.183z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_633"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
HtmlFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$e = ["color", "size"];
var CssFill = function CssFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$e);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7.502 0h2.578v1.078h-1.5v1.078h1.5v1.078H7.502V0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.595 0h2.579v.938h-1.5v.187h1.5v2.156h-2.579v-.984h1.5v-.188h-1.5V0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.69 0h2.577v.938h-1.5v.187h1.5v2.156H13.69v-.984h1.5v-.188h-1.5V0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.991 24l-6.944-1.928L3 4.717h18L18.954 22.07 11.991 24zM7.047 12.573l.191 2.128h7.377l-.247 2.76-2.374.642h-.002l-2.37-.64-.152-1.697H7.333l.298 3.342 4.36 1.21 4.367-1.21.532-5.964.052-.571.384-4.309H6.664l.194 2.129h8.136l-.194 2.18H7.047z"
  }));
};
CssFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$d = ["color", "size"];
var VercelFill = function VercelFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$d);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 1l12 21H0L12 1z"
  }));
};
VercelFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$c = ["color", "size"];
var NextjsFill = function NextjsFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$c);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_641)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.214.006c-.052.005-.216.022-.364.033C7.442.347 4.25 2.186 2.226 5.013a11.88 11.88 0 0 0-2.118 5.243c-.096.66-.108.854-.108 1.748s.012 1.089.108 1.748c.652 4.507 3.86 8.293 8.209 9.696.779.251 1.6.422 2.533.526.364.04 1.936.04 2.3 0 1.611-.179 2.977-.578 4.323-1.265.207-.105.247-.134.219-.157-.02-.014-.899-1.194-1.955-2.62l-1.919-2.593-2.404-3.559a342.499 342.499 0 0 0-2.422-3.556c-.009-.003-.018 1.578-.023 3.51-.007 3.38-.01 3.516-.052 3.596a.426.426 0 0 1-.206.213c-.075.038-.14.045-.495.045H7.81l-.108-.068a.44.44 0 0 1-.157-.172l-.05-.105.005-4.704.007-4.706.073-.092a.644.644 0 0 1 .174-.143c.096-.047.133-.051.54-.051.478 0 .558.018.682.154.035.038 1.337 2 2.895 4.362l4.734 7.172 1.9 2.878.097-.063a12.318 12.318 0 0 0 2.465-2.163 11.947 11.947 0 0 0 2.825-6.135c.096-.66.108-.854.108-1.748s-.012-1.088-.108-1.748C23.24 5.75 20.032 1.963 15.683.56a12.6 12.6 0 0 0-2.498-.523c-.226-.024-1.776-.05-1.97-.03zm4.913 7.26a.473.473 0 0 1 .237.276c.018.06.023 1.365.018 4.305l-.007 4.218-.743-1.14-.746-1.14v-3.066c0-1.983.009-3.097.023-3.151a.478.478 0 0 1 .232-.296c.097-.05.132-.054.5-.054.347 0 .408.005.486.047z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_641"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
NextjsFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$b = ["color", "size"];
var ReduxFill = function ReduxFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$b);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_630)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.63 16.563c.885-.092 1.557-.863 1.527-1.788a1.723 1.723 0 0 0-1.71-1.665h-.062c-.947.03-1.68.832-1.65 1.788.032.463.215.863.49 1.14-1.039 2.067-2.627 3.577-5.01 4.841-1.618.864-3.298 1.172-4.977.956-1.375-.185-2.444-.802-3.116-1.819-.977-1.51-1.068-3.145-.244-4.779.58-1.171 1.497-2.035 2.077-2.466-.122-.401-.305-1.08-.397-1.573C-.871 14.436-.412 18.814.93 20.88c1.008 1.542 3.054 2.498 5.315 2.498.61 0 1.221-.062 1.832-.216 3.91-.77 6.872-3.114 8.552-6.598zm5.375-3.823c-2.321-2.744-5.742-4.255-9.651-4.255h-.489a1.677 1.677 0 0 0-1.496-.925h-.062c-.946.031-1.68.833-1.649 1.789.03.925.794 1.664 1.71 1.664h.062a1.721 1.721 0 0 0 1.496-1.048h.55c2.321 0 4.52.678 6.505 2.004 1.527 1.018 2.627 2.343 3.237 3.947.52 1.294.49 2.558-.06 3.638-.856 1.634-2.291 2.528-4.185 2.528-1.221 0-2.382-.37-2.993-.648a18.07 18.07 0 0 1-1.374 1.11c1.313.617 2.657.956 3.94.956 2.932 0 5.1-1.634 5.925-3.268.885-1.788.824-4.871-1.466-7.492zM6.49 17.087c.03.925.794 1.665 1.71 1.665h.061c.947-.03 1.68-.832 1.65-1.788a1.723 1.723 0 0 0-1.71-1.665h-.062c-.061 0-.153 0-.214.03-1.252-2.096-1.771-4.377-1.588-6.844.122-1.85.733-3.453 1.802-4.779.886-1.14 2.596-1.695 3.757-1.726 3.237-.062 4.611 4.008 4.703 5.642.397.092 1.069.308 1.527.462C17.759 3.09 14.706.5 11.773.5 9.025.5 6.49 2.504 5.482 5.464c-1.405 3.946-.489 7.738 1.222 10.729-.153.216-.245.555-.214.894z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_630"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
ReduxFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$a = ["color", "size"];
var PythonFill = function PythonFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$a);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_629)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.914 0C5.82 0 6.2 2.656 6.2 2.656l.007 2.752h5.814v.826H3.9S0 5.789 0 11.969c0 6.18 3.403 5.96 3.403 5.96h2.03v-2.867s-.109-3.42 3.35-3.42h5.766s3.24.052 3.24-3.148V3.202S18.28 0 11.913 0zM8.708 1.85c.578 0 1.046.47 1.046 1.052 0 .581-.468 1.051-1.046 1.051-.579 0-1.046-.47-1.046-1.051 0-.582.467-1.052 1.046-1.052z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.087 24c6.092 0 5.712-2.656 5.712-2.656l-.007-2.752h-5.814v-.826h8.123s3.9.445 3.9-5.735c0-6.18-3.404-5.96-3.404-5.96h-2.03v2.867s.109 3.42-3.35 3.42H9.452s-3.24-.052-3.24 3.148v5.292S5.72 24 12.087 24zm3.206-1.85c-.579 0-1.046-.47-1.046-1.052 0-.581.467-1.051 1.046-1.051.578 0 1.046.47 1.046 1.051 0 .582-.468 1.052-1.046 1.052z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_629"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
PythonFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$9 = ["color", "size"];
var GraphqlFill = function GraphqlFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$9);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_628)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.384 4.187a2.132 2.132 0 0 0 1.171.018l6.326 11.182a2.126 2.126 0 0 0-.593 1.038H5.71a2.148 2.148 0 0 0-.64-1.079l6.313-11.159zm-.921-.565c.018.02.038.039.057.058L4.193 14.865a2.11 2.11 0 0 0-.09-.022V9.156A2.122 2.122 0 0 0 5.481 8.14a2.142 2.142 0 0 0 .19-1.694l4.792-2.823zm3.57-.835a2.134 2.134 0 1 0-4.079-.04L5.159 5.573A2.131 2.131 0 0 0 1.785 6a2.146 2.146 0 0 0 1.322 3.143v5.715A2.147 2.147 0 0 0 1.79 18a2.13 2.13 0 0 0 3.368.43l4.795 2.826a2.151 2.151 0 0 0-.086.605C9.868 23.044 10.82 24 12 24a2.138 2.138 0 0 0 2.012-2.848l4.751-2.8a2.128 2.128 0 0 0 3.44-.352 2.138 2.138 0 0 0-1.384-3.159v-5.68A2.147 2.147 0 0 0 22.215 6a2.133 2.133 0 0 0-3.401-.398l-4.78-2.816zm-.599.937l.075-.072 4.808 2.833a2.142 2.142 0 0 0 .203 1.654 2.12 2.12 0 0 0 1.303 1v5.72a2.074 2.074 0 0 0-.078.023L13.434 3.724zm4.895 13.858l-4.774 2.814a2.124 2.124 0 0 0-1.554-.674c-.606 0-1.152.252-1.54.658l-4.785-2.82c.012-.039.023-.078.032-.118H18.29c.012.047.025.094.04.14z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_628"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
GraphqlFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$8 = ["color", "size"];
var PhpFill = function PhpFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$8);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 5.5C5.271 5.5 0 8.355 0 12s5.271 6.5 12 6.5 12-2.855 12-6.5-5.271-6.5-12-6.5zm-1.246 2h1.31l-.416 2h1.17c.742 0 1.24.104 1.524.363.277.256.361.676.25 1.248l-.52 2.389H12.74l.479-2.209c.058-.303.035-.514-.067-.625-.101-.111-.324-.166-.658-.166h-1.049l-.633 3H9.5l1.254-6zM5 9.5h2.666c1.271 0 2.041.852 1.74 2.123C9.056 13.1 8.12 13.5 6.396 13.5h-.824L5.311 15H3.986L5 9.5zm10.5 0h2.666c1.271 0 2.041.852 1.74 2.123-.35 1.477-1.287 1.877-3.01 1.877h-.824l-.261 1.5h-1.325L15.5 9.5zm-9.365 1l-.377 2h.855c.74 0 1.428-.084 1.543-1.188.043-.427-.135-.812-.99-.812H6.135zm10.5 0l-.377 2h.855c.74 0 1.428-.084 1.543-1.188.043-.427-.134-.812-.99-.812h-1.031z"
  }));
};
PhpFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$7 = ["color", "size"];
var JqueryFill = function JqueryFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$7);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_626)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.301 5.601c-.628-1.528-.54-3.247.367-4.63L14.346 0c-1.254 2.35-.06 5.236 1.86 6.749a6.343 6.343 0 0 0 1.698.95c.164.06.35.124.52.167 2.146.54 3.895.167 4.936-1.389-.032.048-.073.124-.125.22-.464.86-1.822 3.377-5.76 2.587-.075-.015-.147-.04-.219-.063l-.064-.022-.046-.015a2.119 2.119 0 0 0-.064-.021 5.8 5.8 0 0 1-.174-.063c-1.585-.604-2.944-1.876-3.607-3.499z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.12 2.966c-1.537 2.295-1.453 5.368-.254 7.796a10.242 10.242 0 0 0 .762 1.301c.209.313.439.66.708.902.111.127.227.25.345.371l.068.07.023.023a10.22 10.22 0 0 0 .367.353l.001.001.002.002a10.623 10.623 0 0 0 .465.397l.04.032c.14.112.283.222.43.327l.006.004.007.005c.047.034.095.067.143.099l.053.036a3.109 3.109 0 0 1 .093.064c.105.07.211.137.319.203l.03.017.015.01a11.466 11.466 0 0 0 .351.201l.031.016.04.022c.052.028.104.057.158.084l.03.015a9.941 9.941 0 0 0 .47.224l.032.013a10.315 10.315 0 0 0 .451.186l.03.011c.103.04.206.076.31.112l.052.018.088.029c.039.012.078.026.116.039.109.038.218.075.332.095C22.168 17.408 24 11.068 24 11.068c-1.651 2.468-4.849 3.646-8.261 2.726a9.54 9.54 0 0 1-.45-.135c-.04-.012-.08-.026-.12-.04l-.015-.005a8.82 8.82 0 0 1-.314-.112l-.003-.002a10.08 10.08 0 0 1-.512-.21l-.056-.025a9.272 9.272 0 0 1-.58-.287l-.042-.022-.12-.064a9.64 9.64 0 0 1-.325-.19 10.318 10.318 0 0 1-.62-.41 10.976 10.976 0 0 1-.429-.326l-.035-.029a6.304 6.304 0 0 1-.061-.05c-1.494-1.224-2.678-2.897-3.24-4.793-.59-1.968-.463-4.176.559-5.968L8.12 2.966z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1.524 5.637C-.6 8.807-.336 12.932 1.287 16.3c.03.065.063.129.095.192l.024.048.03.059a2.987 2.987 0 0 0 .08.155l.013.025.07.13.015.027c.05.092.102.184.155.276l.017.03a9.464 9.464 0 0 0 .251.413l.018.03.059.093c.084.13.17.261.26.39v.001a.085.085 0 0 0 .007.009l.024.033.02.028c.078.11.157.22.238.328l.09.118a18.083 18.083 0 0 0 .608.746l.006.007.005.005.007.008a15.627 15.627 0 0 0 .658.697l.03.03.071.07a12.947 12.947 0 0 0 .346.326l.033.03.026.022a18.342 18.342 0 0 0 .38.33l.056.047c.085.07.171.14.258.208l.137.109c.096.073.192.145.289.215l.016.012.09.066.028.02c.088.064.177.124.267.184l.014.01a5.661 5.661 0 0 1 .12.083 15.577 15.577 0 0 0 .507.319l.054.032a14.516 14.516 0 0 0 .459.26l.053.029.059.032c.059.032.117.064.177.095l.025.012.03.015.034.017c.02.01.041.02.062.032.124.061.248.121.374.18l.047.021.032.015a13.238 13.238 0 0 0 .953.39l.01.003.042.016a13.91 13.91 0 0 0 .69.228c.116.039.233.077.353.1 10.277 1.946 13.262-6.41 13.262-6.41-2.507 3.39-6.957 4.285-11.174 3.289a5.368 5.368 0 0 1-.47-.137l-.118-.037c-.152-.048-.303-.1-.453-.153l-.062-.023c-.135-.05-.267-.1-.4-.154l-.112-.046c-.145-.06-.289-.121-.431-.186l-.046-.02a17.296 17.296 0 0 1-.404-.194l-.041-.022a5.56 5.56 0 0 1-.064-.031l-.214-.113-.068-.036a6.057 6.057 0 0 0-.067-.036l-.12-.066c-.114-.063-.226-.13-.338-.197l-.043-.025-.07-.04a16.203 16.203 0 0 1-.516-.332l-.043-.03a12.657 12.657 0 0 1-1.225-.929 15.269 15.269 0 0 1-.352-.307l-.016-.015a16.412 16.412 0 0 1-.448-.428 11.175 11.175 0 0 1-.25-.255l-.034-.034a13.54 13.54 0 0 1-.38-.414l-.006-.006-.002-.003c-.106-.12-.21-.244-.312-.368l-.082-.101a13.975 13.975 0 0 1-.307-.395c-.088-.12-.175-.238-.26-.359-2.34-3.314-3.181-7.886-1.31-11.64L1.524 5.637z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_626"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
JqueryFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$6 = ["color", "size"];
var SassFill = function SassFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$6);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_625)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 0c6.6 0 12 5.4 12 12s-5.4 12-12 12S0 18.6 0 12 5.4 0 12 0zM9.6 15.975c.15.675.15 1.275 0 1.8L9.525 18c0 .075-.075.15-.075.15-.15.3-.3.525-.525.825-.675.75-1.65 1.05-2.1.825-.45-.225-.225-1.35.6-2.175.9-.9 2.1-1.5 2.1-1.5l.075-.15zM19.5 5.1c-.525-2.1-4.05-2.85-7.425-1.65-1.95.75-4.125 1.875-5.7 3.3-1.875 1.725-2.1 3.225-2.025 3.825C4.8 12.75 7.8 14.25 9.075 15.3 8.7 15.45 6 16.8 5.4 18.225c-.675 1.5.075 2.55.6 2.625 1.575.45 3.225-.375 4.05-1.65.825-1.275.75-2.85.375-3.675a3.532 3.532 0 0 1 1.8-.075c2.1.225 2.55 1.575 2.4 2.1-.15.525-.525.825-.675.975-.15.075-.225.15-.15.15 0 .075.075.075.225.075.15 0 1.125-.45 1.125-1.5.075-1.275-1.2-2.7-3.375-2.7-.9 0-1.5.075-1.875.225 0-.075-.075-.075-.075-.075-1.35-1.425-3.825-2.475-3.75-4.425 0-.675.3-2.55 4.8-4.8 3.675-1.875 6.675-1.35 7.2-.225.75 1.575-1.575 4.575-5.4 5.025-1.5.15-2.25-.375-2.4-.6-.225-.225-.225-.225-.3-.225-.15.075-.075.225 0 .375.15.3.6.825 1.425 1.125.675.225 2.4.375 4.5-.45 2.325-.9 4.125-3.375 3.6-5.475V5.1z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_625"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
SassFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$5 = ["color", "size"];
var GatsbyFill = function GatsbyFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$5);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_624)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 0C5.323 0 0 5.317 0 12s5.317 12 12 12 12-5.323 12-12S18.683 0 12 0zM2.608 12.101l9.29 9.286c-5.114.005-9.29-4.171-9.29-9.286zm11.477 9.083L2.821 9.909C3.76 5.733 7.515 2.603 12 2.603a9.493 9.493 0 0 1 7.616 3.861l-1.355 1.147A7.666 7.666 0 0 0 11.9 4.267 7.57 7.57 0 0 0 4.693 9.38l9.814 9.819c2.4-.837 4.277-2.923 4.8-5.43h-4.07V12h6.155c0 4.485-3.13 8.245-7.307 9.184z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_624"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
GatsbyFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$4 = ["color", "size"];
var NpmFill = function NpmFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$4);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_637)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0H0v24h24V0zM2.578 2.578H21.42V21.42H16.67V7.33h-4.752V21.42h-9.34V2.578z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_637"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
NpmFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$3 = ["color", "size"];
var YarnFill = function YarnFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_623)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.994 11.675C23.825 5.23 18.561.013 12.004 0 5.21-.005-.3 5.668.013 12.556c.28 6.216 5.344 11.296 11.71 11.441 6.81.157 12.449-5.4 12.271-12.322zM7.92 7.525c-.145.28-.258.575-.336.879-.025.018-.02.05-.032.073 0 .05 0 .1-.014.147v.328c.017.05.012.1.017.15.029.065-.019.146.054.198.088.3.187.594.347.861.05.084.042.129-.031.194-.381.349-.723.734-.987 1.183-.472.802-.648 1.679-.648 2.6a.323.323 0 0 1-.016.104.275.275 0 0 1-.062.105c-.609.667-.936 1.427-.786 2.348.076.467.212.91.49 1.298a.395.395 0 0 1 .089.273c-.018.404.144.732.488.939.58.351 1.207.477 1.875.328a.735.735 0 0 0 .133-.052c.068-.032.137-.063.198-.053.068.01.128.063.189.115.035.03.07.06.107.084.381.228.809.286 1.238.267 1.044-.044 2.085-.107 3.121-.252.342-.047.67-.133.95-.343a.64.64 0 0 1 .198-.1c1.049-.346 2.052-.798 2.967-1.406.555-.364 1.137-.662 1.794-.808.359-.078.62-.315.78-.648.408-.844-.217-1.79-1.19-1.799-.658-.005-1.263.2-1.843.49a8.696 8.696 0 0 0-.615.352c-.19.115-.38.231-.579.333l-.029.017c-.04.024-.083.049-.136.046v-.1c.052-1.395-.401-2.607-1.328-3.646-.056-.062-.046-.102-.005-.162a6.753 6.753 0 0 0 .831-1.6c.344-.973.413-1.972.308-2.987-.05-.489-.15-.966-.356-1.417-.18-.385-.515-.567-.93-.474-.111.023-.149-.01-.194-.102a4.747 4.747 0 0 0-.468-.817.886.886 0 0 0-.685-.36c-.444-.025-.75.216-1.008.539-.194.243-.34.519-.458.805-.036.087-.08.136-.15.162a.382.382 0 0 1-.094.02 3.28 3.28 0 0 0-2.014.97 1.34 1.34 0 0 1-.543.349c-.293.097-.496.299-.637.57z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14.947 15.813c0 .242-.056.478-.086.713-.026.207-.005.231.205.195.472-.082.9-.28 1.311-.515.441-.251.861-.537 1.332-.726a3.013 3.013 0 0 1 1.134-.243c.343 0 .582.186.624.48.04.272-.11.533-.384.59-.781.166-1.456.551-2.113.98-.882.569-1.842.98-2.841 1.295-.037.01-.085.019-.108.041-.236.25-.548.292-.863.333-.884.116-1.773.168-2.665.22a3.049 3.049 0 0 1-.77-.026c-.41-.08-.583-.233-.645-.57-.056-.301.086-.587.388-.784l.116-.073a1.306 1.306 0 0 1-.398-.364c-.05-.069-.076-.026-.092.031l-.15.57c-.034.126-.076.25-.129.37-.152.348-.43.516-.797.55a1.976 1.976 0 0 1-1.065-.215c-.23-.113-.299-.283-.223-.533.04-.134.116-.25.207-.391-.317.063-.456-.121-.566-.344a2.374 2.374 0 0 1-.231-1.54c.081-.424.33-.77.63-1.069.175-.175.228-.344.223-.59-.04-1.425.498-2.595 1.605-3.499.097-.081.195-.165.297-.239.063-.044.07-.073.018-.138-.286-.36-.509-.75-.61-1.204-.117-.511.057-.955.314-1.38.037-.057.094-.086.158-.11.323-.116.595-.291.842-.538.555-.555 1.243-.81 2.03-.776.1.005.144-.024.175-.118.117-.344.264-.675.461-.98a1.26 1.26 0 0 1 .26-.31c.194-.16.36-.137.49.076.242.386.428.8.616 1.215.048.105.084.142.194.07a2.03 2.03 0 0 1 .417-.189c.116-.04.184-.013.234.108.147.354.226.724.27 1.104.013.105.037.207.024.312-.008.228.003.457.005.688 0 .102-.036.205-.005.309-.023.624-.189 1.214-.43 1.786-.225.535-.553 1.01-.881 1.485-.129.183-.126.186.042.336.818.737 1.27 1.663 1.42 2.743.006.042.004.087.004.131-.034.1.003.197.005.294.009.148-.025.296 0 .44z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_623"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
YarnFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$2 = ["color", "size"];
var DjangoFill = function DjangoFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.172 0h-4.176v5.932c-.623-.15-1.14-.2-1.816-.2C4.816 5.731 2 8.305 2 12.273c0 4.118 2.655 6.263 7.755 6.268 1.703 0 3.278-.15 5.417-.53V0zM9.734 8.977c.516 0 .92.05 1.408.2v6.248c-.596.075-.972.1-1.434.1-2.14 0-3.305-1.142-3.305-3.21 0-2.125 1.22-3.338 3.331-3.338z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 15.233V6.215h-4.17v7.675c0 3.387-.188 4.674-.785 5.786-.57 1.087-1.462 1.8-3.305 2.606L17.615 24c1.843-.862 2.735-1.643 3.412-2.88.726-1.288.973-2.782.973-5.887z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21.584 0H17.41v3.993h4.175V0z"
  }));
};
DjangoFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded$1 = ["color", "size"];
var VscodeFill = function VscodeFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_950_639)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M.228 8.37s-.584-.427.117-.995L1.98 5.897s.467-.497.962-.064l15.081 11.542v5.534s-.007.87-1.11.774L.227 8.369z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.116 11.937L.228 15.509s-.4.3 0 .837l1.805 1.66s.429.465 1.062-.065l4.121-3.158-3.1-2.846z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.94 11.966l7.13-5.502-.047-5.505s-.305-1.202-1.32-.576L7.216 9.11l3.724 2.856z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.912 23.69c.414.428.916.288.916.288l5.556-2.767c.711-.49.611-1.098.611-1.098V3.588c0-.726-.735-.977-.735-.977L18.444.264c-1.052-.657-1.741.119-1.741.119s.886-.645 1.32.576v21.85c0 .15-.032.297-.095.43-.127.259-.402.5-1.062.4l.046.051z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_950_639"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
VscodeFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

var _excluded = ["color", "size"];
var TypescriptFill = function TypescriptFill(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '24' : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps), /*#__PURE__*/React__default["default"].createElement("g", {
    clipPath: "url(#clip0_2147_271)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M23.429 0H.57A.571.571 0 0 0 0 .571V23.43c0 .315.255.571.571.571H23.43a.571.571 0 0 0 .571-.571V.57A.571.571 0 0 0 23.429 0zm-9.143 12.826h-2.857v8.888H9.143v-8.888H6.286v-1.969h8v1.969zm.64 8.38v-2.375s1.298.978 2.855.978 1.497-1.018 1.497-1.158c0-1.477-4.412-1.477-4.412-4.751 0-4.452 6.429-2.695 6.429-2.695l-.08 2.116s-1.078-.719-2.296-.719c-1.218 0-1.657.58-1.657 1.198 0 1.597 4.452 1.438 4.452 4.652 0 4.95-6.788 2.755-6.788 2.755z"
  })), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("clipPath", {
    id: "clip0_2147_271"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24"
  }))));
};
TypescriptFill.propTypes = {
  color: PropTypes__default["default"].string,
  size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number])
};

exports.Air = Air;
exports.AirplayAudio = AirplayAudio;
exports.AirplayVideo = AirplayVideo;
exports.Airpods = Airpods;
exports.Alarm = Alarm;
exports.AlignBottom = AlignBottom;
exports.AlignHorizontalCenter = AlignHorizontalCenter;
exports.AlignLeft = AlignLeft;
exports.AlignRight = AlignRight;
exports.AlignToBottom = AlignToBottom;
exports.AlignToMiddle = AlignToMiddle;
exports.AlignToTop = AlignToTop;
exports.AlignTop = AlignTop;
exports.AlignVerticalCenter = AlignVerticalCenter;
exports.AndroidFill = AndroidFill;
exports.AngularFill = AngularFill;
exports.ArrowBack = ArrowBack;
exports.ArrowBackThick = ArrowBackThick;
exports.ArrowBackThickFill = ArrowBackThickFill;
exports.ArrowClockwise = ArrowClockwise;
exports.ArrowCounterClockwise = ArrowCounterClockwise;
exports.ArrowCycle = ArrowCycle;
exports.ArrowDown = ArrowDown;
exports.ArrowDownLeft = ArrowDownLeft;
exports.ArrowDownRight = ArrowDownRight;
exports.ArrowDownThick = ArrowDownThick;
exports.ArrowForward = ArrowForward;
exports.ArrowForwardThick = ArrowForwardThick;
exports.ArrowForwardThickFill = ArrowForwardThickFill;
exports.ArrowLeft = ArrowLeft;
exports.ArrowLeftThick = ArrowLeftThick;
exports.ArrowRepeat = ArrowRepeat;
exports.ArrowRight = ArrowRight;
exports.ArrowRightLeft = ArrowRightLeft;
exports.ArrowRightThick = ArrowRightThick;
exports.ArrowShuffle = ArrowShuffle;
exports.ArrowUp = ArrowUp;
exports.ArrowUpDown = ArrowUpDown;
exports.ArrowUpLeft = ArrowUpLeft;
exports.ArrowUpRight = ArrowUpRight;
exports.ArrowUpThick = ArrowUpThick;
exports.Ascending = Ascending;
exports.Attach = Attach;
exports.AugmentedReality = AugmentedReality;
exports.Backspace = Backspace;
exports.BackspaceFill = BackspaceFill;
exports.Bank = Bank;
exports.Basket = Basket;
exports.BatteryCharging = BatteryCharging;
exports.BatteryEmpty = BatteryEmpty;
exports.BatteryFull = BatteryFull;
exports.BatteryLow = BatteryLow;
exports.BatteryMedium = BatteryMedium;
exports.BehanceFill = BehanceFill;
exports.Bell = Bell;
exports.Bicycle = Bicycle;
exports.BitcoinFill = BitcoinFill;
exports.Block = Block;
exports.Bluetooth = Bluetooth;
exports.Boat = Boat;
exports.BookClose = BookClose;
exports.BookOpen = BookOpen;
exports.BootstrapFill = BootstrapFill;
exports.Box = Box;
exports.Briefcase = Briefcase;
exports.Bug = Bug;
exports.Cake = Cake;
exports.Calculator = Calculator;
exports.Calendar = Calendar;
exports.Camera = Camera;
exports.Cart = Cart;
exports.ChatAdd = ChatAdd;
exports.ChatApprove = ChatApprove;
exports.ChatBubble = ChatBubble;
exports.ChatDots = ChatDots;
exports.ChatEdit = ChatEdit;
exports.ChatError = ChatError;
exports.ChatQuestion = ChatQuestion;
exports.ChatRemove = ChatRemove;
exports.Check = Check;
exports.CheckBox = CheckBox;
exports.CheckBoxFill = CheckBoxFill;
exports.CheckIn = CheckIn;
exports.Chess = Chess;
exports.ChevronDown = ChevronDown;
exports.ChevronDownSmall = ChevronDownSmall;
exports.ChevronHorizontal = ChevronHorizontal;
exports.ChevronLeft = ChevronLeft;
exports.ChevronLeftSmall = ChevronLeftSmall;
exports.ChevronRight = ChevronRight;
exports.ChevronRightSmall = ChevronRightSmall;
exports.ChevronUp = ChevronUp;
exports.ChevronUpSmall = ChevronUpSmall;
exports.ChevronVertical = ChevronVertical;
exports.Circle = Circle;
exports.CircleAlert = CircleAlert;
exports.CircleAlertFill = CircleAlertFill;
exports.CircleCheck = CircleCheck;
exports.CircleCheckFill = CircleCheckFill;
exports.CircleChevronDown = CircleChevronDown;
exports.CircleChevronDownFill = CircleChevronDownFill;
exports.CircleChevronLeft = CircleChevronLeft;
exports.CircleChevronLeftFill = CircleChevronLeftFill;
exports.CircleChevronRight = CircleChevronRight;
exports.CircleChevronRightFill = CircleChevronRightFill;
exports.CircleChevronUp = CircleChevronUp;
exports.CircleChevronUpFill = CircleChevronUpFill;
exports.CircleFill = CircleFill;
exports.CircleMinus = CircleMinus;
exports.CircleMinusFill = CircleMinusFill;
exports.CirclePlus = CirclePlus;
exports.CirclePlusFill = CirclePlusFill;
exports.CircleTriangleDown = CircleTriangleDown;
exports.CircleTriangleDownFill = CircleTriangleDownFill;
exports.CircleTriangleLeft = CircleTriangleLeft;
exports.CircleTriangleLeftFill = CircleTriangleLeftFill;
exports.CircleTriangleRight = CircleTriangleRight;
exports.CircleTriangleRightFill = CircleTriangleRightFill;
exports.CircleTriangleUp = CircleTriangleUp;
exports.CircleTriangleUpFill = CircleTriangleUpFill;
exports.CircleX = CircleX;
exports.CircleXFill = CircleXFill;
exports.Clipboard = Clipboard;
exports.Clock = Clock;
exports.Cloud = Cloud;
exports.CloudDownload = CloudDownload;
exports.CloudUpload = CloudUpload;
exports.CodepenFill = CodepenFill;
exports.Coffee = Coffee;
exports.Coin = Coin;
exports.Command = Command;
exports.Computing = Computing;
exports.Copy = Copy;
exports.CreditCard = CreditCard;
exports.CreditCardAlt1 = CreditCardAlt1;
exports.Cross = Cross;
exports.Crown = Crown;
exports.CssFill = CssFill;
exports.Cursor = Cursor;
exports.Cut = Cut;
exports.Dashboard = Dashboard;
exports.Data = Data;
exports.Dental = Dental;
exports.Descending = Descending;
exports.DesktopDevice = DesktopDevice;
exports.Devices = Devices;
exports.Diamond = Diamond;
exports.Dice1 = Dice1;
exports.Dice2 = Dice2;
exports.Dice3 = Dice3;
exports.Dice4 = Dice4;
exports.Dice5 = Dice5;
exports.Dice6 = Dice6;
exports.DiscordFill = DiscordFill;
exports.DjangoFill = DjangoFill;
exports.Door = Door;
exports.DotGridFill = DotGridFill;
exports.DoubleCheck = DoubleCheck;
exports.DoubleSword = DoubleSword;
exports.Download = Download;
exports.Draft = Draft;
exports.DragHorizontalFill = DragHorizontalFill;
exports.DragVerticalFill = DragVerticalFill;
exports.DribbbleFill = DribbbleFill;
exports.DropboxFill = DropboxFill;
exports.Edit = Edit;
exports.Enlarge = Enlarge;
exports.Envelope = Envelope;
exports.Equal = Equal;
exports.EqualFill = EqualFill;
exports.EyeClosed = EyeClosed;
exports.EyeOpen = EyeOpen;
exports.EyeSlashed = EyeSlashed;
exports.FaceHappy = FaceHappy;
exports.FaceNeutral = FaceNeutral;
exports.FaceSad = FaceSad;
exports.FaceVeryHappy = FaceVeryHappy;
exports.FaceVerySad = FaceVerySad;
exports.FaceWink = FaceWink;
exports.FacebookFill = FacebookFill;
exports.FigmaFill = FigmaFill;
exports.File = File;
exports.Filter = Filter;
exports.Fire = Fire;
exports.Flag = Flag;
exports.Flashlight = Flashlight;
exports.Folder = Folder;
exports.FolderAdd = FolderAdd;
exports.ForkLeft = ForkLeft;
exports.ForkRight = ForkRight;
exports.Frame = Frame;
exports.FullScreen = FullScreen;
exports.GameController = GameController;
exports.GatsbyFill = GatsbyFill;
exports.Gear = Gear;
exports.Gift = Gift;
exports.GithubFill = GithubFill;
exports.Glasses = Glasses;
exports.Globe = Globe;
exports.GoogleContainedFill = GoogleContainedFill;
exports.GoogleFill = GoogleFill;
exports.GraphqlFill = GraphqlFill;
exports.Grid = Grid;
exports.Hammer = Hammer;
exports.Hand = Hand;
exports.Hashtag = Hashtag;
exports.Headphone = Headphone;
exports.Health = Health;
exports.Heart = Heart;
exports.Height = Height;
exports.Heptagon = Heptagon;
exports.HeptagonFill = HeptagonFill;
exports.Hexagon = Hexagon;
exports.HexagonFill = HexagonFill;
exports.History = History;
exports.Home = Home;
exports.HomeAlt1 = HomeAlt1;
exports.HtmlFill = HtmlFill;
exports.Image = Image;
exports.Inbox = Inbox;
exports.Infinite = Infinite;
exports.Info = Info;
exports.InfoFill = InfoFill;
exports.InstagramFill = InstagramFill;
exports.Jar = Jar;
exports.JavascriptFill = JavascriptFill;
exports.JqueryFill = JqueryFill;
exports.Key = Key;
exports.KeyCap = KeyCap;
exports.Language = Language;
exports.LaptopDevice = LaptopDevice;
exports.Leaf = Leaf;
exports.Lifesaver = Lifesaver;
exports.LightBulb = LightBulb;
exports.LinkChain = LinkChain;
exports.LinkOff = LinkOff;
exports.LinkOn = LinkOn;
exports.LinkOut = LinkOut;
exports.LinkedinBoxFill = LinkedinBoxFill;
exports.LinkedinFill = LinkedinFill;
exports.Location = Location;
exports.LockOff = LockOff;
exports.LockOn = LockOn;
exports.Map = Map;
exports.MastodonFill = MastodonFill;
exports.MediumFill = MediumFill;
exports.Mention = Mention;
exports.Microphone = Microphone;
exports.Miniplayer = Miniplayer;
exports.Minus = Minus;
exports.MobileDevice = MobileDevice;
exports.Money = Money;
exports.Moon = Moon;
exports.MoonFill = MoonFill;
exports.MoreHorizontalFill = MoreHorizontalFill;
exports.MoreVerticalFill = MoreVerticalFill;
exports.Music = Music;
exports.MusicAlbum = MusicAlbum;
exports.MusicAlbumFill = MusicAlbumFill;
exports.MusicNote = MusicNote;
exports.Network = Network;
exports.Newspaper = Newspaper;
exports.NextjsFill = NextjsFill;
exports.NodeFill = NodeFill;
exports.NormalScreen = NormalScreen;
exports.NpmFill = NpmFill;
exports.Octagon = Octagon;
exports.OctagonFill = OctagonFill;
exports.OctocatFill = OctocatFill;
exports.OpenEnvelope = OpenEnvelope;
exports.Oval = Oval;
exports.PanelBottom = PanelBottom;
exports.PanelLeft = PanelLeft;
exports.PanelRight = PanelRight;
exports.PanelSplit = PanelSplit;
exports.PanelSplitColumn = PanelSplitColumn;
exports.PanelSplitRow = PanelSplitRow;
exports.PanelTop = PanelTop;
exports.Paper = Paper;
exports.PaperAirplane = PaperAirplane;
exports.Parallelogram = Parallelogram;
exports.Pause = Pause;
exports.Pencil = Pencil;
exports.Pentagon = Pentagon;
exports.PentagonFill = PentagonFill;
exports.PeopleGroup = PeopleGroup;
exports.PeopleMultiple = PeopleMultiple;
exports.Percentage = Percentage;
exports.Person = Person;
exports.PersonAdd = PersonAdd;
exports.PersonCheck = PersonCheck;
exports.PersonCross = PersonCross;
exports.Phone = Phone;
exports.PhpFill = PhpFill;
exports.Pin = Pin;
exports.PinterestFill = PinterestFill;
exports.Plane = Plane;
exports.PlaneFill = PlaneFill;
exports.Planet = Planet;
exports.Plant = Plant;
exports.Play = Play;
exports.Plus = Plus;
exports.PointerDownFill = PointerDownFill;
exports.PointerHand = PointerHand;
exports.PointerLeftFill = PointerLeftFill;
exports.PointerRightFill = PointerRightFill;
exports.PointerUpFill = PointerUpFill;
exports.PointingUp = PointingUp;
exports.PostgresqlFill = PostgresqlFill;
exports.PriceCut = PriceCut;
exports.ProductHuntFill = ProductHuntFill;
exports.PythonFill = PythonFill;
exports.Question = Question;
exports.QuestionFill = QuestionFill;
exports.Radio = Radio;
exports.RadioFill = RadioFill;
exports.Radish = Radish;
exports.ReactFill = ReactFill;
exports.Receipt = Receipt;
exports.RedditFill = RedditFill;
exports.Reduce = Reduce;
exports.ReduxFill = ReduxFill;
exports.Ribbon = Ribbon;
exports.RockOn = RockOn;
exports.Rss = Rss;
exports.SassFill = SassFill;
exports.Save = Save;
exports.Schedule = Schedule;
exports.Scissor = Scissor;
exports.Search = Search;
exports.Send = Send;
exports.SettingsHorizontal = SettingsHorizontal;
exports.SettingsVertical = SettingsVertical;
exports.ShareBox = ShareBox;
exports.Shield = Shield;
exports.ShippingBoxV1 = ShippingBoxV1;
exports.ShippingBoxV2 = ShippingBoxV2;
exports.ShoppingBag = ShoppingBag;
exports.SignOut = SignOut;
exports.SlackFill = SlackFill;
exports.Slice = Slice;
exports.SnapchatFill = SnapchatFill;
exports.Sort = Sort;
exports.SoundDown = SoundDown;
exports.SoundOff = SoundOff;
exports.SoundOn = SoundOn;
exports.SoundUp = SoundUp;
exports.SoundcloudFill = SoundcloudFill;
exports.Sparkles = Sparkles;
exports.SpotifyFill = SpotifyFill;
exports.Square = Square;
exports.SquareFill = SquareFill;
exports.StackOverflowFill = StackOverflowFill;
exports.Star = Star;
exports.StatisticDown = StatisticDown;
exports.StatisticUp = StatisticUp;
exports.Stop = Stop;
exports.StopFill = StopFill;
exports.Sun = Sun;
exports.SunFill = SunFill;
exports.Sword = Sword;
exports.TabletDevice = TabletDevice;
exports.Tag = Tag;
exports.TelegramFill = TelegramFill;
exports.Telescope = Telescope;
exports.Tetragon = Tetragon;
exports.TetragonFill = TetragonFill;
exports.TextAlignCenter = TextAlignCenter;
exports.TextAlignJustified = TextAlignJustified;
exports.TextAlignLeft = TextAlignLeft;
exports.TextAlignRight = TextAlignRight;
exports.ThreadsFill = ThreadsFill;
exports.ThreeLineHorizontal = ThreeLineHorizontal;
exports.ThreeLineVertical = ThreeLineVertical;
exports.ThumbsDown = ThumbsDown;
exports.ThumbsUp = ThumbsUp;
exports.Thunder = Thunder;
exports.Ticket = Ticket;
exports.TiktokFill = TiktokFill;
exports.ToggleOff = ToggleOff;
exports.ToggleOffFill = ToggleOffFill;
exports.ToggleOn = ToggleOn;
exports.ToggleOnFill = ToggleOnFill;
exports.TogoCup = TogoCup;
exports.TrashBin = TrashBin;
exports.TrashCan = TrashCan;
exports.Triangle = Triangle;
exports.TriangleAlert = TriangleAlert;
exports.TriangleAlertFill = TriangleAlertFill;
exports.TriangleDown = TriangleDown;
exports.TriangleDownFill = TriangleDownFill;
exports.TriangleFill = TriangleFill;
exports.TriangleLeft = TriangleLeft;
exports.TriangleLeftFill = TriangleLeftFill;
exports.TriangleRight = TriangleRight;
exports.TriangleRightFill = TriangleRightFill;
exports.TriangleUp = TriangleUp;
exports.TriangleUpFill = TriangleUpFill;
exports.Trophy = Trophy;
exports.Truck = Truck;
exports.TumblrFill = TumblrFill;
exports.TwitchFill = TwitchFill;
exports.TwitterFill = TwitterFill;
exports.TwoLineHorizontal = TwoLineHorizontal;
exports.TwoLineVertical = TwoLineVertical;
exports.TypescriptFill = TypescriptFill;
exports.Umbrella = Umbrella;
exports.UnsplashFill = UnsplashFill;
exports.Utensils = Utensils;
exports.VapeKit = VapeKit;
exports.VercelFill = VercelFill;
exports.VictoryHand = VictoryHand;
exports.Video = Video;
exports.VimeoFill = VimeoFill;
exports.VkFill = VkFill;
exports.VrAr = VrAr;
exports.VscodeFill = VscodeFill;
exports.VueFill = VueFill;
exports.Wallet = Wallet;
exports.WatchDevice = WatchDevice;
exports.Water = Water;
exports.WhatsappFill = WhatsappFill;
exports.Width = Width;
exports.Wifi = Wifi;
exports.WineGlass = WineGlass;
exports.XFill = XFill;
exports.XSmall = XSmall;
exports.YarnFill = YarnFill;
exports.YelpFill = YelpFill;
exports.YoutubeFill = YoutubeFill;
exports.ZoomFill = ZoomFill;
exports.ZoomIn = ZoomIn;
exports.ZoomOut = ZoomOut;
